/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R403RouteImport } from './routes/403'
import { Route as R502RouteImport } from './routes/502'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetHaslaRouteImport } from './routes/reset-hasla'
import { Route as UstawHasloRouteImport } from './routes/ustaw-haslo'
import { Route as ZgloszenieRouteImport } from './routes/zgloszenie'
import { Route as AuthAsystentRouteImport } from './routes/_auth/asystent'
import { Route as AuthAsystentJakoscRouteImport } from './routes/_auth/asystent-jakosc'
import { Route as AuthAsystentKosztyRouteImport } from './routes/_auth/asystent-koszty'
import { Route as AuthAsystentStatystykiAptekRouteImport } from './routes/_auth/asystent-statystyki-aptek'
import { Route as AuthDashboardRouteImport } from './routes/_auth/dashboard'
import { Route as AuthMojProfilRouteImport } from './routes/_auth/moj-profil'
import { Route as AuthStrategCenowyRouteRouteImport } from './routes/_auth/strateg-cenowy/route'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as PolaczAiZgodaRouteImport } from './routes/polacz-ai.zgoda'
import { Route as PubliczneKsefRouteImport } from './routes/publiczne/ksef'
import { Route as AuthApteneoPorownanieRouteImport } from './routes/_auth/apteneo/porownanie'
import { Route as AuthApteneoRozliczeniaRouteImport } from './routes/_auth/apteneo/rozliczenia'
import { Route as AuthApteneoZaczytajDaneRouteImport } from './routes/_auth/apteneo/zaczytaj-dane'
import { Route as AuthApteneoZakupyRouteImport } from './routes/_auth/apteneo/zakupy'
import { Route as AuthDokumentyIndexRouteImport } from './routes/_auth/dokumenty/index'
import { Route as AuthDokumentyHurtownicyRouteImport } from './routes/_auth/dokumenty/hurtownicy'
import { Route as AuthDokumentyKalendarzPlatnosciRouteImport } from './routes/_auth/dokumenty/kalendarz-platnosci'
import { Route as AuthDokumentyKsefRouteImport } from './routes/_auth/dokumenty/ksef'
import { Route as AuthHelpdeskIndexRouteImport } from './routes/_auth/helpdesk/index'
import { Route as AuthHelpdeskAwariaRouteImport } from './routes/_auth/helpdesk/awaria'
import { Route as AuthHelpdeskCzatRouteImport } from './routes/_auth/helpdesk/czat'
import { Route as AuthHelpdeskKonfiguracjaRouteImport } from './routes/_auth/helpdesk/konfiguracja'
import { Route as AuthHelpdeskSzukajRouteImport } from './routes/_auth/helpdesk/szukaj'
import { Route as AuthHelpdeskZarzadzanieRouteImport } from './routes/_auth/helpdesk/zarzadzanie'
import { Route as AuthKartotekaCennikNajtaniejRouteImport } from './routes/_auth/kartoteka/cennik-najtaniej'
import { Route as AuthKartotekaCennikZgodnoscRouteImport } from './routes/_auth/kartoteka/cennik-zgodnosc'
import { Route as AuthKartotekaCennikiHistoriaRouteImport } from './routes/_auth/kartoteka/cenniki-historia'
import { Route as AuthKartotekaCennikiPodgladRouteImport } from './routes/_auth/kartoteka/cenniki-podglad'
import { Route as AuthKartotekaGrupyProduktowRouteImport } from './routes/_auth/kartoteka/grupy-produktow'
import { Route as AuthKartotekaKategoryzacjaRouteImport } from './routes/_auth/kartoteka/kategoryzacja'
import { Route as AuthKartotekaKontrahenciRouteImport } from './routes/_auth/kartoteka/kontrahenci'
import { Route as AuthKartotekaMapowanieApcRouteImport } from './routes/_auth/kartoteka/mapowanie-apc'
import { Route as AuthKartotekaProducenciRouteImport } from './routes/_auth/kartoteka/producenci'
import { Route as AuthKartotekaStanMagazynuRouteImport } from './routes/_auth/kartoteka/stan-magazynu'
import { Route as AuthKartotekaTowaryRouteImport } from './routes/_auth/kartoteka/towary'
import { Route as AuthKonfiguracjaIndexRouteImport } from './routes/_auth/konfiguracja/index'
import { Route as AuthKonfiguracjaAiRouteImport } from './routes/_auth/konfiguracja/ai'
import { Route as AuthKonfiguracjaAktualizacjeRouteImport } from './routes/_auth/konfiguracja/aktualizacje'
import { Route as AuthKonfiguracjaAptekiRouteImport } from './routes/_auth/konfiguracja/apteki'
import { Route as AuthKonfiguracjaAuditLogRouteImport } from './routes/_auth/konfiguracja/audit-log'
import { Route as AuthKonfiguracjaDrukarkiRouteImport } from './routes/_auth/konfiguracja/drukarki'
import { Route as AuthKonfiguracjaDyskiRouteImport } from './routes/_auth/konfiguracja/dyski'
import { Route as AuthKonfiguracjaEksportyPlikoweRouteImport } from './routes/_auth/konfiguracja/eksporty-plikowe'
import { Route as AuthKonfiguracjaEmailRouteImport } from './routes/_auth/konfiguracja/email'
import { Route as AuthKonfiguracjaEmailLogRouteImport } from './routes/_auth/konfiguracja/email-log'
import { Route as AuthKonfiguracjaGrupyAptekRouteImport } from './routes/_auth/konfiguracja/grupy-aptek'
import { Route as AuthKonfiguracjaGrupyOrganizacyjneRouteImport } from './routes/_auth/konfiguracja/grupy-organizacyjne'
import { Route as AuthKonfiguracjaGrupyUzytkownikowRouteImport } from './routes/_auth/konfiguracja/grupy-uzytkownikow'
import { Route as AuthKonfiguracjaHarmonogramyPowiadomienRouteImport } from './routes/_auth/konfiguracja/harmonogramy-powiadomien'
import { Route as AuthKonfiguracjaHarmonogramyRaportowRouteImport } from './routes/_auth/konfiguracja/harmonogramy-raportow'
import { Route as AuthKonfiguracjaImportMshrRouteImport } from './routes/_auth/konfiguracja/import-mshr'
import { Route as AuthKonfiguracjaIqviaRouteImport } from './routes/_auth/konfiguracja/iqvia'
import { Route as AuthKonfiguracjaKsefRouteImport } from './routes/_auth/konfiguracja/ksef'
import { Route as AuthKonfiguracjaKsefCertyfikatyRouteImport } from './routes/_auth/konfiguracja/ksef-certyfikaty'
import { Route as AuthKonfiguracjaKsefOsozEdiRouteImport } from './routes/_auth/konfiguracja/ksef-osoz-edi'
import { Route as AuthKonfiguracjaMcpRouteImport } from './routes/_auth/konfiguracja/mcp'
import { Route as AuthKonfiguracjaMcpStatystykiRouteImport } from './routes/_auth/konfiguracja/mcp-statystyki'
import { Route as AuthKonfiguracjaOrganizacjeRouteImport } from './routes/_auth/konfiguracja/organizacje'
import { Route as AuthKonfiguracjaPodgladUzytkownikaRouteImport } from './routes/_auth/konfiguracja/podglad-uzytkownika'
import { Route as AuthKonfiguracjaPracownicyRouteImport } from './routes/_auth/konfiguracja/pracownicy'
import { Route as AuthKonfiguracjaRegulyZdarzenRouteImport } from './routes/_auth/konfiguracja/reguly-zdarzen'
import { Route as AuthKonfiguracjaSfyRouteImport } from './routes/_auth/konfiguracja/sfy'
import { Route as AuthKonfiguracjaSmsRouteImport } from './routes/_auth/konfiguracja/sms'
import { Route as AuthKonfiguracjaSpolkiRouteImport } from './routes/_auth/konfiguracja/spolki'
import { Route as AuthKonfiguracjaSqlKonsolaRouteImport } from './routes/_auth/konfiguracja/sql-konsola'
import { Route as AuthKonfiguracjaSqlSfyRouteImport } from './routes/_auth/konfiguracja/sql-sfy'
import { Route as AuthKonfiguracjaStatystykiUzyciaRouteImport } from './routes/_auth/konfiguracja/statystyki-uzycia'
import { Route as AuthKonfiguracjaSystemRouteImport } from './routes/_auth/konfiguracja/system'
import { Route as AuthKonfiguracjaTokenyApiRouteImport } from './routes/_auth/konfiguracja/tokeny-api'
import { Route as AuthKonfiguracjaUrzadzeniaRouteImport } from './routes/_auth/konfiguracja/urzadzenia'
import { Route as AuthKonfiguracjaUzytkownicyRouteImport } from './routes/_auth/konfiguracja/uzytkownicy'
import { Route as AuthKontraktyIndexRouteImport } from './routes/_auth/kontrakty/index'
import { Route as AuthKontraktyIdRouteImport } from './routes/_auth/kontrakty/$id'
import { Route as AuthKontraktyAptekiProducentowRouteImport } from './routes/_auth/kontrakty/apteki-producentow'
import { Route as AuthKontraktyAptekiProducentowHistoriaRouteImport } from './routes/_auth/kontrakty/apteki-producentow-historia'
import { Route as AuthKontraktyNieaktywneAptekiRouteImport } from './routes/_auth/kontrakty/nieaktywne-apteki'
import { Route as AuthKontraktyNowyRouteImport } from './routes/_auth/kontrakty/nowy'
import { Route as AuthKontraktyPorownanieZProducentemRouteImport } from './routes/_auth/kontrakty/porownanie-z-producentem'
import { Route as AuthKontraktyProducenciDzzfRouteImport } from './routes/_auth/kontrakty/producenci-dzzf'
import { Route as AuthKontraktyUdzialRouteImport } from './routes/_auth/kontrakty/udzial'
import { Route as AuthKontraktyWykonanieRouteImport } from './routes/_auth/kontrakty/wykonanie'
import { Route as AuthRaportyAnalizaZakupowNoweZamRouteImport } from './routes/_auth/raporty/analiza-zakupow-nowe-zam'
import { Route as AuthRaportyAnalizaZakupyIndeksowRouteImport } from './routes/_auth/raporty/analiza-zakupy-indeksow'
import { Route as AuthRaportyDashboardAnalitycznyRouteImport } from './routes/_auth/raporty/dashboard-analityczny'
import { Route as AuthRaportyDashboardMagazynSzczegolRouteImport } from './routes/_auth/raporty/dashboard-magazyn-szczegol'
import { Route as AuthRaportyDatyWaznosciRouteImport } from './routes/_auth/raporty/daty-waznosci'
import { Route as AuthRaportyDynamikaSprzedazyRouteImport } from './routes/_auth/raporty/dynamika-sprzedazy'
import { Route as AuthRaportyEcomRouteImport } from './routes/_auth/raporty/ecom'
import { Route as AuthRaportyJakoscDanychWyjatkiRouteImport } from './routes/_auth/raporty/jakosc-danych-wyjatki'
import { Route as AuthRaportyKategoriaKwartalnaRouteImport } from './routes/_auth/raporty/kategoria-kwartalna'
import { Route as AuthRaportyLukiPowiazanRouteImport } from './routes/_auth/raporty/luki-powiazan'
import { Route as AuthRaportyOdchyleniaCenFvRouteImport } from './routes/_auth/raporty/odchylenia-cen-fv'
import { Route as AuthRaportyRaportProduktowyRouteImport } from './routes/_auth/raporty/raport-produktowy'
import { Route as AuthRaportyRozkladMarzRouteImport } from './routes/_auth/raporty/rozklad-marz'
import { Route as AuthRaportySprzOpiekunRouteImport } from './routes/_auth/raporty/sprz-opiekun'
import { Route as AuthRaportySprzWynikRouteImport } from './routes/_auth/raporty/sprz-wynik'
import { Route as AuthRaportySprz_kasjer_dataRouteImport } from './routes/_auth/raporty/sprz_kasjer_data'
import { Route as AuthRaportySprzedazDziennaRouteImport } from './routes/_auth/raporty/sprzedaz-dzienna'
import { Route as AuthRaportySprzedazZrealizowanaRouteImport } from './routes/_auth/raporty/sprzedaz-zrealizowana'
import { Route as AuthRaportyUjemneMarzeRouteImport } from './routes/_auth/raporty/ujemne-marze'
import { Route as AuthRaportyWeryfikacjaTowrRouteImport } from './routes/_auth/raporty/weryfikacja-towr'
import { Route as AuthRaportyWyprzedazMagazynuRouteImport } from './routes/_auth/raporty/wyprzedaz-magazynu'
import { Route as AuthRaportyZmianyBlozuRouteImport } from './routes/_auth/raporty/zmiany-blozu'
import { Route as AuthRaportyZwrotyDzienneRouteImport } from './routes/_auth/raporty/zwroty-dzienne'
import { Route as AuthRaportyZwrotyKwartalneRouteImport } from './routes/_auth/raporty/zwroty-kwartalne'
import { Route as AuthRdaAnalizaKorzysciRouteImport } from './routes/_auth/rda/analiza-korzysci'
import { Route as AuthRdaListaOfertFm1RouteImport } from './routes/_auth/rda/lista-ofert-fm1'
import { Route as AuthRecepturaProtokolyRouteImport } from './routes/_auth/receptura/protokoly'
import { Route as AuthRecepturaSurowceRouteImport } from './routes/_auth/receptura/surowce'
import { Route as AuthRecepturaSzablonyRouteImport } from './routes/_auth/receptura/szablony'
import { Route as AuthSmsIndexRouteImport } from './routes/_auth/sms/index'
import { Route as AuthSmsKampanieRouteImport } from './routes/_auth/sms/kampanie'
import { Route as AuthSmsKontaktyRouteImport } from './routes/_auth/sms/kontakty'
import { Route as AuthSmsSzablonyRouteImport } from './routes/_auth/sms/szablony'
import { Route as AuthSmsZuzycieRouteImport } from './routes/_auth/sms/zuzycie'
import { Route as AuthStrategCenowyIndexRouteImport } from './routes/_auth/strateg-cenowy/index'
import { Route as AuthStrategCenowyCennikiCentralneRouteImport } from './routes/_auth/strateg-cenowy/cenniki-centralne'
import { Route as AuthStrategCenowyCennikiWlasneRouteImport } from './routes/_auth/strateg-cenowy/cenniki-wlasne'
import { Route as AuthStrategCenowyKalkulatorMarzyRouteImport } from './routes/_auth/strateg-cenowy/kalkulator-marzy'
import { Route as AuthStrategCenowyKonfiguracjaTopRouteImport } from './routes/_auth/strateg-cenowy/konfiguracja-top'
import { Route as AuthStrategCenowyLiderFranczyzaRouteImport } from './routes/_auth/strateg-cenowy/lider-franczyza'
import { Route as AuthStrategCenowyModyfikatoryRouteImport } from './routes/_auth/strateg-cenowy/modyfikatory'
import { Route as AuthStrategCenowyStrategieRouteImport } from './routes/_auth/strateg-cenowy/strategie'
import { Route as AuthStrategCenowyWykluczeniaRouteImport } from './routes/_auth/strateg-cenowy/wykluczenia'
import { Route as AuthStrategCenowyWynikiRouteImport } from './routes/_auth/strateg-cenowy/wyniki'
import { Route as AuthStrategCenowyWynikiTopRouteImport } from './routes/_auth/strateg-cenowy/wyniki-top'
import { Route as AuthSynchronizacjaKonsolaSqlRouteImport } from './routes/_auth/synchronizacja/konsola-sql'
import { Route as AuthSynchronizacjaZatwierdzeniaSqlRouteImport } from './routes/_auth/synchronizacja/zatwierdzenia-sql'
import { Route as AuthDokumentyHurtownicyNipRouteImport } from './routes/_auth/dokumenty/hurtownicy.$nip'
import { Route as AuthDokumentyKsefInvoiceIdRouteImport } from './routes/_auth/dokumenty/ksef.$invoiceId'
import { Route as AuthKonfiguracjaIssueResolveIndexRouteImport } from './routes/_auth/konfiguracja/issue-resolve/index'
import { Route as AuthKonfiguracjaIssueResolveNumberRouteImport } from './routes/_auth/konfiguracja/issue-resolve/$number'
import { Route as AuthKonfiguracjaSfyPrzegladRouteImport } from './routes/_auth/konfiguracja/sfy_.przeglad'
import { Route as AuthKontraktyAptekiGapIndexRouteImport } from './routes/_auth/kontrakty/apteki-gap/index'
import { Route as AuthKontraktyAptekiGapIdRouteImport } from './routes/_auth/kontrakty/apteki-gap/$id'
import { Route as AuthKontraktyAptekiGapNowyRouteImport } from './routes/_auth/kontrakty/apteki-gap/nowy'
import { Route as AuthKontraktyCennikiExfactoryIndexRouteImport } from './routes/_auth/kontrakty/cenniki-exfactory/index'
import { Route as AuthKontraktyCennikiExfactoryIdRouteImport } from './routes/_auth/kontrakty/cenniki-exfactory/$id'
import { Route as AuthKontraktyCennikiExfactoryNowyRouteImport } from './routes/_auth/kontrakty/cenniki-exfactory/nowy'
import { Route as AuthKontraktyDoplatyGapIndexRouteImport } from './routes/_auth/kontrakty/doplaty-gap/index'
import { Route as AuthKontraktyDoplatyGapIdRouteImport } from './routes/_auth/kontrakty/doplaty-gap/$id'
import { Route as AuthKontraktyDoplatyGapNowyRouteImport } from './routes/_auth/kontrakty/doplaty-gap/nowy'
import { Route as AuthKontraktyLiderZakupyIndexRouteImport } from './routes/_auth/kontrakty/lider-zakupy/index'
import { Route as AuthKontraktyLiderZakupyIdRouteImport } from './routes/_auth/kontrakty/lider-zakupy/$id'
import { Route as AuthKontraktyLiderZakupyNowyRouteImport } from './routes/_auth/kontrakty/lider-zakupy/nowy'
import { Route as AuthKontraktyMslDostepnoscIndexRouteImport } from './routes/_auth/kontrakty/msl-dostepnosc/index'
import { Route as AuthKontraktyMslDostepnoscIdRouteImport } from './routes/_auth/kontrakty/msl-dostepnosc/$id'
import { Route as AuthKontraktyMslDostepnoscNowyRouteImport } from './routes/_auth/kontrakty/msl-dostepnosc/nowy'
import { Route as AuthKontraktyPorownanieIndexRouteImport } from './routes/_auth/kontrakty/porownanie/index'
import { Route as AuthKontraktyPorownanieIdRouteImport } from './routes/_auth/kontrakty/porownanie/$id'
import { Route as AuthKontraktyRaportyIndexRouteImport } from './routes/_auth/kontrakty/raporty/index'
import { Route as AuthKontraktyRaportyKontraktRouteImport } from './routes/_auth/kontrakty/raporty/kontrakt'
import { Route as AuthKontraktyRaportyLiderRouteImport } from './routes/_auth/kontrakty/raporty/lider'
import { Route as AuthKontraktyRaportyPodsumowanieRouteImport } from './routes/_auth/kontrakty/raporty/podsumowanie'
import { Route as AuthKontraktyRaportyProducentRouteImport } from './routes/_auth/kontrakty/raporty/producent'
import { Route as AuthKontraktyRozliczeniaZakupIndexRouteImport } from './routes/_auth/kontrakty/rozliczenia-zakup/index'
import { Route as AuthKontraktyRozliczeniaZakupIdRouteImport } from './routes/_auth/kontrakty/rozliczenia-zakup/$id'
import { Route as AuthKontraktyRozliczeniaIndexRouteImport } from './routes/_auth/kontrakty/rozliczenia/index'
import { Route as AuthKontraktyRozliczeniaIdRouteImport } from './routes/_auth/kontrakty/rozliczenia/$id'
import { Route as AuthKontraktyRozliczeniaAktywnoscAptekRouteImport } from './routes/_auth/kontrakty/rozliczenia/aktywnosc-aptek'
import { Route as AuthKontraktyRozliczeniaPrognozaWstecznaRouteImport } from './routes/_auth/kontrakty/rozliczenia/prognoza-wsteczna'
import { Route as AuthKontraktyRozliczeniaProporcjeKanalowRouteImport } from './routes/_auth/kontrakty/rozliczenia/proporcje-kanalow'
import { Route as AuthKontraktyWeryfikacjaWysylekIndexRouteImport } from './routes/_auth/kontrakty/weryfikacja-wysylek/index'
import { Route as AuthKontraktyWeryfikacjaWysylekIdRouteImport } from './routes/_auth/kontrakty/weryfikacja-wysylek/$id'
import { Route as AuthKontraktyWeryfikacjaWysylekKlienciRouteImport } from './routes/_auth/kontrakty/weryfikacja-wysylek/klienci'
import { Route as AuthKontraktyWeryfikacjaWysylekPolaczeniaRouteImport } from './routes/_auth/kontrakty/weryfikacja-wysylek/polaczenia'
import { Route as AuthRaportySprzWybranychBlozowIndexRouteImport } from './routes/_auth/raporty/sprz-wybranych-blozow/index'
import { Route as AuthRaportySystemPremiowyLiderSzczegolowoRouteImport } from './routes/_auth/raporty/system-premiowy/lider-szczegolowo'
import { Route as AuthRaportyWeryfikacjaSprzedazyIndexRouteImport } from './routes/_auth/raporty/weryfikacja-sprzedazy/index'
import { Route as AuthRaportyWeryfikacjaSprzedazyFakturaDoParagonuRouteImport } from './routes/_auth/raporty/weryfikacja-sprzedazy/faktura-do-paragonu'
import { Route as AuthRaportyWeryfikacjaSprzedazyZmianyRouteImport } from './routes/_auth/raporty/weryfikacja-sprzedazy/zmiany'
import { Route as AuthRdaListaOfertFm1OfferIdRouteImport } from './routes/_auth/rda/lista-ofert-fm1_.$offerId'
import { Route as AuthRecepturaProtokolyIdRouteImport } from './routes/_auth/receptura/protokoly_.$id'
import { Route as AuthSynchronizacjaAptekiIndexRouteImport } from './routes/_auth/synchronizacja/apteki/index'
import { Route as AuthSynchronizacjaAptekiIdfirmRouteImport } from './routes/_auth/synchronizacja/apteki/$idfirm'
import { Route as AuthKontraktyRozliczeniaZakupIdAnalizaDzialZakupowRouteImport } from './routes/_auth/kontrakty/rozliczenia-zakup/$id.analiza-dzial-zakupow'
import { Route as AuthKontraktyRozliczeniaZakupIdAnalizaPerSpolkaRouteImport } from './routes/_auth/kontrakty/rozliczenia-zakup/$id.analiza-per-spolka'
import { Route as AuthKontraktyRozliczeniaIdMiesiecznieRouteImport } from './routes/_auth/kontrakty/rozliczenia/$id.miesiecznie'
import { Route as AuthKontraktyRozliczeniaIdPoSpolceRouteImport } from './routes/_auth/kontrakty/rozliczenia/$id.po-spolce'
import { Route as AuthRaportySprzWybranychBlozowParametryIndexRouteImport } from './routes/_auth/raporty/sprz-wybranych-blozow/parametry/index'
import { Route as AuthRaportySprzWybranychBlozowParametryIdRouteImport } from './routes/_auth/raporty/sprz-wybranych-blozow/parametry/$id'
import { Route as AuthRaportySprzWybranychBlozowParametryNowyRouteImport } from './routes/_auth/raporty/sprz-wybranych-blozow/parametry/nowy'
import { Route as AuthRaportySystemPremiowyLiderIndexRouteImport } from './routes/_auth/raporty/system-premiowy/lider/index'
import { Route as AuthRaportySystemPremiowyLiderIdRouteImport } from './routes/_auth/raporty/system-premiowy/lider/$id'
import { Route as AuthRaportySystemPremiowyLiderNowyRouteImport } from './routes/_auth/raporty/system-premiowy/lider/nowy'
import { Route as AuthRaportySystemPremiowyProgramPartnerskiIndexRouteImport } from './routes/_auth/raporty/system-premiowy/program-partnerski/index'
import { Route as AuthRaportySystemPremiowyProgramPartnerskiIdRouteImport } from './routes/_auth/raporty/system-premiowy/program-partnerski/$id'
import { Route as AuthRaportySystemPremiowyProgramPartnerskiNowyRouteImport } from './routes/_auth/raporty/system-premiowy/program-partnerski/nowy'
import { Route as AuthRaportySystemPremiowyRentownoscIndexRouteImport } from './routes/_auth/raporty/system-premiowy/rentownosc/index'
import { Route as AuthRaportySystemPremiowyRentownoscIdRouteImport } from './routes/_auth/raporty/system-premiowy/rentownosc/$id'
import { Route as AuthRaportySystemPremiowyRentownoscNowaRouteImport } from './routes/_auth/raporty/system-premiowy/rentownosc/nowa'
import { Route as AuthRaportySystemPremiowyStrukturaIndexRouteImport } from './routes/_auth/raporty/system-premiowy/struktura/index'
import { Route as AuthRaportySystemPremiowyStrukturaIdRouteImport } from './routes/_auth/raporty/system-premiowy/struktura/$id'
import { Route as AuthRaportySystemPremiowyStrukturaNowaRouteImport } from './routes/_auth/raporty/system-premiowy/struktura/nowa'
import { Route as AuthRecepturaProtokolyIdDrukujRouteImport } from './routes/_auth/receptura/protokoly_.$id_.drukuj'
import { Route as AuthRecepturaProtokolyIdEtykietaRouteImport } from './routes/_auth/receptura/protokoly_.$id_.etykieta'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const R403Route = R403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const R502Route = R502RouteImport.update({
  id: '/502',
  path: '/502',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetHaslaRoute = ResetHaslaRouteImport.update({
  id: '/reset-hasla',
  path: '/reset-hasla',
  getParentRoute: () => rootRouteImport,
} as any)
const UstawHasloRoute = UstawHasloRouteImport.update({
  id: '/ustaw-haslo',
  path: '/ustaw-haslo',
  getParentRoute: () => rootRouteImport,
} as any)
const ZgloszenieRoute = ZgloszenieRouteImport.update({
  id: '/zgloszenie',
  path: '/zgloszenie',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAsystentRoute = AuthAsystentRouteImport.update({
  id: '/asystent',
  path: '/asystent',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAsystentJakoscRoute = AuthAsystentJakoscRouteImport.update({
  id: '/asystent-jakosc',
  path: '/asystent-jakosc',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAsystentKosztyRoute = AuthAsystentKosztyRouteImport.update({
  id: '/asystent-koszty',
  path: '/asystent-koszty',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAsystentStatystykiAptekRoute =
  AuthAsystentStatystykiAptekRouteImport.update({
    id: '/asystent-statystyki-aptek',
    path: '/asystent-statystyki-aptek',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMojProfilRoute = AuthMojProfilRouteImport.update({
  id: '/moj-profil',
  path: '/moj-profil',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStrategCenowyRouteRoute = AuthStrategCenowyRouteRouteImport.update({
  id: '/strateg-cenowy',
  path: '/strateg-cenowy',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PolaczAiZgodaRoute = PolaczAiZgodaRouteImport.update({
  id: '/polacz-ai/zgoda',
  path: '/polacz-ai/zgoda',
  getParentRoute: () => rootRouteImport,
} as any)
const PubliczneKsefRoute = PubliczneKsefRouteImport.update({
  id: '/publiczne/ksef',
  path: '/publiczne/ksef',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthApteneoPorownanieRoute = AuthApteneoPorownanieRouteImport.update({
  id: '/apteneo/porownanie',
  path: '/apteneo/porownanie',
  getParentRoute: () => AuthRoute,
} as any)
const AuthApteneoRozliczeniaRoute = AuthApteneoRozliczeniaRouteImport.update({
  id: '/apteneo/rozliczenia',
  path: '/apteneo/rozliczenia',
  getParentRoute: () => AuthRoute,
} as any)
const AuthApteneoZaczytajDaneRoute = AuthApteneoZaczytajDaneRouteImport.update({
  id: '/apteneo/zaczytaj-dane',
  path: '/apteneo/zaczytaj-dane',
  getParentRoute: () => AuthRoute,
} as any)
const AuthApteneoZakupyRoute = AuthApteneoZakupyRouteImport.update({
  id: '/apteneo/zakupy',
  path: '/apteneo/zakupy',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDokumentyIndexRoute = AuthDokumentyIndexRouteImport.update({
  id: '/dokumenty/',
  path: '/dokumenty/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDokumentyHurtownicyRoute = AuthDokumentyHurtownicyRouteImport.update({
  id: '/dokumenty/hurtownicy',
  path: '/dokumenty/hurtownicy',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDokumentyKalendarzPlatnosciRoute =
  AuthDokumentyKalendarzPlatnosciRouteImport.update({
    id: '/dokumenty/kalendarz-platnosci',
    path: '/dokumenty/kalendarz-platnosci',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDokumentyKsefRoute = AuthDokumentyKsefRouteImport.update({
  id: '/dokumenty/ksef',
  path: '/dokumenty/ksef',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHelpdeskIndexRoute = AuthHelpdeskIndexRouteImport.update({
  id: '/helpdesk/',
  path: '/helpdesk/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHelpdeskAwariaRoute = AuthHelpdeskAwariaRouteImport.update({
  id: '/helpdesk/awaria',
  path: '/helpdesk/awaria',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHelpdeskCzatRoute = AuthHelpdeskCzatRouteImport.update({
  id: '/helpdesk/czat',
  path: '/helpdesk/czat',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHelpdeskKonfiguracjaRoute =
  AuthHelpdeskKonfiguracjaRouteImport.update({
    id: '/helpdesk/konfiguracja',
    path: '/helpdesk/konfiguracja',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthHelpdeskSzukajRoute = AuthHelpdeskSzukajRouteImport.update({
  id: '/helpdesk/szukaj',
  path: '/helpdesk/szukaj',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHelpdeskZarzadzanieRoute = AuthHelpdeskZarzadzanieRouteImport.update({
  id: '/helpdesk/zarzadzanie',
  path: '/helpdesk/zarzadzanie',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKartotekaCennikNajtaniejRoute =
  AuthKartotekaCennikNajtaniejRouteImport.update({
    id: '/kartoteka/cennik-najtaniej',
    path: '/kartoteka/cennik-najtaniej',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKartotekaCennikZgodnoscRoute =
  AuthKartotekaCennikZgodnoscRouteImport.update({
    id: '/kartoteka/cennik-zgodnosc',
    path: '/kartoteka/cennik-zgodnosc',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKartotekaCennikiHistoriaRoute =
  AuthKartotekaCennikiHistoriaRouteImport.update({
    id: '/kartoteka/cenniki-historia',
    path: '/kartoteka/cenniki-historia',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKartotekaCennikiPodgladRoute =
  AuthKartotekaCennikiPodgladRouteImport.update({
    id: '/kartoteka/cenniki-podglad',
    path: '/kartoteka/cenniki-podglad',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKartotekaGrupyProduktowRoute =
  AuthKartotekaGrupyProduktowRouteImport.update({
    id: '/kartoteka/grupy-produktow',
    path: '/kartoteka/grupy-produktow',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKartotekaKategoryzacjaRoute =
  AuthKartotekaKategoryzacjaRouteImport.update({
    id: '/kartoteka/kategoryzacja',
    path: '/kartoteka/kategoryzacja',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKartotekaKontrahenciRoute =
  AuthKartotekaKontrahenciRouteImport.update({
    id: '/kartoteka/kontrahenci',
    path: '/kartoteka/kontrahenci',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKartotekaMapowanieApcRoute =
  AuthKartotekaMapowanieApcRouteImport.update({
    id: '/kartoteka/mapowanie-apc',
    path: '/kartoteka/mapowanie-apc',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKartotekaProducenciRoute = AuthKartotekaProducenciRouteImport.update({
  id: '/kartoteka/producenci',
  path: '/kartoteka/producenci',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKartotekaStanMagazynuRoute =
  AuthKartotekaStanMagazynuRouteImport.update({
    id: '/kartoteka/stan-magazynu',
    path: '/kartoteka/stan-magazynu',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKartotekaTowaryRoute = AuthKartotekaTowaryRouteImport.update({
  id: '/kartoteka/towary',
  path: '/kartoteka/towary',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKonfiguracjaIndexRoute = AuthKonfiguracjaIndexRouteImport.update({
  id: '/konfiguracja/',
  path: '/konfiguracja/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKonfiguracjaAiRoute = AuthKonfiguracjaAiRouteImport.update({
  id: '/konfiguracja/ai',
  path: '/konfiguracja/ai',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKonfiguracjaAktualizacjeRoute =
  AuthKonfiguracjaAktualizacjeRouteImport.update({
    id: '/konfiguracja/aktualizacje',
    path: '/konfiguracja/aktualizacje',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaAptekiRoute = AuthKonfiguracjaAptekiRouteImport.update({
  id: '/konfiguracja/apteki',
  path: '/konfiguracja/apteki',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKonfiguracjaAuditLogRoute =
  AuthKonfiguracjaAuditLogRouteImport.update({
    id: '/konfiguracja/audit-log',
    path: '/konfiguracja/audit-log',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaDrukarkiRoute =
  AuthKonfiguracjaDrukarkiRouteImport.update({
    id: '/konfiguracja/drukarki',
    path: '/konfiguracja/drukarki',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaDyskiRoute = AuthKonfiguracjaDyskiRouteImport.update({
  id: '/konfiguracja/dyski',
  path: '/konfiguracja/dyski',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKonfiguracjaEksportyPlikoweRoute =
  AuthKonfiguracjaEksportyPlikoweRouteImport.update({
    id: '/konfiguracja/eksporty-plikowe',
    path: '/konfiguracja/eksporty-plikowe',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaEmailRoute = AuthKonfiguracjaEmailRouteImport.update({
  id: '/konfiguracja/email',
  path: '/konfiguracja/email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKonfiguracjaEmailLogRoute =
  AuthKonfiguracjaEmailLogRouteImport.update({
    id: '/konfiguracja/email-log',
    path: '/konfiguracja/email-log',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaGrupyAptekRoute =
  AuthKonfiguracjaGrupyAptekRouteImport.update({
    id: '/konfiguracja/grupy-aptek',
    path: '/konfiguracja/grupy-aptek',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaGrupyOrganizacyjneRoute =
  AuthKonfiguracjaGrupyOrganizacyjneRouteImport.update({
    id: '/konfiguracja/grupy-organizacyjne',
    path: '/konfiguracja/grupy-organizacyjne',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaGrupyUzytkownikowRoute =
  AuthKonfiguracjaGrupyUzytkownikowRouteImport.update({
    id: '/konfiguracja/grupy-uzytkownikow',
    path: '/konfiguracja/grupy-uzytkownikow',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaHarmonogramyPowiadomienRoute =
  AuthKonfiguracjaHarmonogramyPowiadomienRouteImport.update({
    id: '/konfiguracja/harmonogramy-powiadomien',
    path: '/konfiguracja/harmonogramy-powiadomien',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaHarmonogramyRaportowRoute =
  AuthKonfiguracjaHarmonogramyRaportowRouteImport.update({
    id: '/konfiguracja/harmonogramy-raportow',
    path: '/konfiguracja/harmonogramy-raportow',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaImportMshrRoute =
  AuthKonfiguracjaImportMshrRouteImport.update({
    id: '/konfiguracja/import-mshr',
    path: '/konfiguracja/import-mshr',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaIqviaRoute = AuthKonfiguracjaIqviaRouteImport.update({
  id: '/konfiguracja/iqvia',
  path: '/konfiguracja/iqvia',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKonfiguracjaKsefRoute = AuthKonfiguracjaKsefRouteImport.update({
  id: '/konfiguracja/ksef',
  path: '/konfiguracja/ksef',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKonfiguracjaKsefCertyfikatyRoute =
  AuthKonfiguracjaKsefCertyfikatyRouteImport.update({
    id: '/konfiguracja/ksef-certyfikaty',
    path: '/konfiguracja/ksef-certyfikaty',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaKsefOsozEdiRoute =
  AuthKonfiguracjaKsefOsozEdiRouteImport.update({
    id: '/konfiguracja/ksef-osoz-edi',
    path: '/konfiguracja/ksef-osoz-edi',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaMcpRoute = AuthKonfiguracjaMcpRouteImport.update({
  id: '/konfiguracja/mcp',
  path: '/konfiguracja/mcp',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKonfiguracjaMcpStatystykiRoute =
  AuthKonfiguracjaMcpStatystykiRouteImport.update({
    id: '/konfiguracja/mcp-statystyki',
    path: '/konfiguracja/mcp-statystyki',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaOrganizacjeRoute =
  AuthKonfiguracjaOrganizacjeRouteImport.update({
    id: '/konfiguracja/organizacje',
    path: '/konfiguracja/organizacje',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaPodgladUzytkownikaRoute =
  AuthKonfiguracjaPodgladUzytkownikaRouteImport.update({
    id: '/konfiguracja/podglad-uzytkownika',
    path: '/konfiguracja/podglad-uzytkownika',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaPracownicyRoute =
  AuthKonfiguracjaPracownicyRouteImport.update({
    id: '/konfiguracja/pracownicy',
    path: '/konfiguracja/pracownicy',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaRegulyZdarzenRoute =
  AuthKonfiguracjaRegulyZdarzenRouteImport.update({
    id: '/konfiguracja/reguly-zdarzen',
    path: '/konfiguracja/reguly-zdarzen',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaSfyRoute = AuthKonfiguracjaSfyRouteImport.update({
  id: '/konfiguracja/sfy',
  path: '/konfiguracja/sfy',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKonfiguracjaSmsRoute = AuthKonfiguracjaSmsRouteImport.update({
  id: '/konfiguracja/sms',
  path: '/konfiguracja/sms',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKonfiguracjaSpolkiRoute = AuthKonfiguracjaSpolkiRouteImport.update({
  id: '/konfiguracja/spolki',
  path: '/konfiguracja/spolki',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKonfiguracjaSqlKonsolaRoute =
  AuthKonfiguracjaSqlKonsolaRouteImport.update({
    id: '/konfiguracja/sql-konsola',
    path: '/konfiguracja/sql-konsola',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaSqlSfyRoute = AuthKonfiguracjaSqlSfyRouteImport.update({
  id: '/konfiguracja/sql-sfy',
  path: '/konfiguracja/sql-sfy',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKonfiguracjaStatystykiUzyciaRoute =
  AuthKonfiguracjaStatystykiUzyciaRouteImport.update({
    id: '/konfiguracja/statystyki-uzycia',
    path: '/konfiguracja/statystyki-uzycia',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaSystemRoute = AuthKonfiguracjaSystemRouteImport.update({
  id: '/konfiguracja/system',
  path: '/konfiguracja/system',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKonfiguracjaTokenyApiRoute =
  AuthKonfiguracjaTokenyApiRouteImport.update({
    id: '/konfiguracja/tokeny-api',
    path: '/konfiguracja/tokeny-api',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaUrzadzeniaRoute =
  AuthKonfiguracjaUrzadzeniaRouteImport.update({
    id: '/konfiguracja/urzadzenia',
    path: '/konfiguracja/urzadzenia',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaUzytkownicyRoute =
  AuthKonfiguracjaUzytkownicyRouteImport.update({
    id: '/konfiguracja/uzytkownicy',
    path: '/konfiguracja/uzytkownicy',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyIndexRoute = AuthKontraktyIndexRouteImport.update({
  id: '/kontrakty/',
  path: '/kontrakty/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKontraktyIdRoute = AuthKontraktyIdRouteImport.update({
  id: '/kontrakty/$id',
  path: '/kontrakty/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKontraktyAptekiProducentowRoute =
  AuthKontraktyAptekiProducentowRouteImport.update({
    id: '/kontrakty/apteki-producentow',
    path: '/kontrakty/apteki-producentow',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyAptekiProducentowHistoriaRoute =
  AuthKontraktyAptekiProducentowHistoriaRouteImport.update({
    id: '/kontrakty/apteki-producentow-historia',
    path: '/kontrakty/apteki-producentow-historia',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyNieaktywneAptekiRoute =
  AuthKontraktyNieaktywneAptekiRouteImport.update({
    id: '/kontrakty/nieaktywne-apteki',
    path: '/kontrakty/nieaktywne-apteki',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyNowyRoute = AuthKontraktyNowyRouteImport.update({
  id: '/kontrakty/nowy',
  path: '/kontrakty/nowy',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKontraktyPorownanieZProducentemRoute =
  AuthKontraktyPorownanieZProducentemRouteImport.update({
    id: '/kontrakty/porownanie-z-producentem',
    path: '/kontrakty/porownanie-z-producentem',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyProducenciDzzfRoute =
  AuthKontraktyProducenciDzzfRouteImport.update({
    id: '/kontrakty/producenci-dzzf',
    path: '/kontrakty/producenci-dzzf',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyUdzialRoute = AuthKontraktyUdzialRouteImport.update({
  id: '/kontrakty/udzial',
  path: '/kontrakty/udzial',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKontraktyWykonanieRoute = AuthKontraktyWykonanieRouteImport.update({
  id: '/kontrakty/wykonanie',
  path: '/kontrakty/wykonanie',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRaportyAnalizaZakupowNoweZamRoute =
  AuthRaportyAnalizaZakupowNoweZamRouteImport.update({
    id: '/raporty/analiza-zakupow-nowe-zam',
    path: '/raporty/analiza-zakupow-nowe-zam',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyAnalizaZakupyIndeksowRoute =
  AuthRaportyAnalizaZakupyIndeksowRouteImport.update({
    id: '/raporty/analiza-zakupy-indeksow',
    path: '/raporty/analiza-zakupy-indeksow',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyDashboardAnalitycznyRoute =
  AuthRaportyDashboardAnalitycznyRouteImport.update({
    id: '/raporty/dashboard-analityczny',
    path: '/raporty/dashboard-analityczny',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyDashboardMagazynSzczegolRoute =
  AuthRaportyDashboardMagazynSzczegolRouteImport.update({
    id: '/raporty/dashboard-magazyn-szczegol',
    path: '/raporty/dashboard-magazyn-szczegol',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyDatyWaznosciRoute = AuthRaportyDatyWaznosciRouteImport.update({
  id: '/raporty/daty-waznosci',
  path: '/raporty/daty-waznosci',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRaportyDynamikaSprzedazyRoute =
  AuthRaportyDynamikaSprzedazyRouteImport.update({
    id: '/raporty/dynamika-sprzedazy',
    path: '/raporty/dynamika-sprzedazy',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyEcomRoute = AuthRaportyEcomRouteImport.update({
  id: '/raporty/ecom',
  path: '/raporty/ecom',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRaportyJakoscDanychWyjatkiRoute =
  AuthRaportyJakoscDanychWyjatkiRouteImport.update({
    id: '/raporty/jakosc-danych-wyjatki',
    path: '/raporty/jakosc-danych-wyjatki',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyKategoriaKwartalnaRoute =
  AuthRaportyKategoriaKwartalnaRouteImport.update({
    id: '/raporty/kategoria-kwartalna',
    path: '/raporty/kategoria-kwartalna',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyLukiPowiazanRoute = AuthRaportyLukiPowiazanRouteImport.update({
  id: '/raporty/luki-powiazan',
  path: '/raporty/luki-powiazan',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRaportyOdchyleniaCenFvRoute =
  AuthRaportyOdchyleniaCenFvRouteImport.update({
    id: '/raporty/odchylenia-cen-fv',
    path: '/raporty/odchylenia-cen-fv',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyRaportProduktowyRoute =
  AuthRaportyRaportProduktowyRouteImport.update({
    id: '/raporty/raport-produktowy',
    path: '/raporty/raport-produktowy',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyRozkladMarzRoute = AuthRaportyRozkladMarzRouteImport.update({
  id: '/raporty/rozklad-marz',
  path: '/raporty/rozklad-marz',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRaportySprzOpiekunRoute = AuthRaportySprzOpiekunRouteImport.update({
  id: '/raporty/sprz-opiekun',
  path: '/raporty/sprz-opiekun',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRaportySprzWynikRoute = AuthRaportySprzWynikRouteImport.update({
  id: '/raporty/sprz-wynik',
  path: '/raporty/sprz-wynik',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRaportySprz_kasjer_dataRoute =
  AuthRaportySprz_kasjer_dataRouteImport.update({
    id: '/raporty/sprz_kasjer_data',
    path: '/raporty/sprz_kasjer_data',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySprzedazDziennaRoute =
  AuthRaportySprzedazDziennaRouteImport.update({
    id: '/raporty/sprzedaz-dzienna',
    path: '/raporty/sprzedaz-dzienna',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySprzedazZrealizowanaRoute =
  AuthRaportySprzedazZrealizowanaRouteImport.update({
    id: '/raporty/sprzedaz-zrealizowana',
    path: '/raporty/sprzedaz-zrealizowana',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyUjemneMarzeRoute = AuthRaportyUjemneMarzeRouteImport.update({
  id: '/raporty/ujemne-marze',
  path: '/raporty/ujemne-marze',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRaportyWeryfikacjaTowrRoute =
  AuthRaportyWeryfikacjaTowrRouteImport.update({
    id: '/raporty/weryfikacja-towr',
    path: '/raporty/weryfikacja-towr',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyWyprzedazMagazynuRoute =
  AuthRaportyWyprzedazMagazynuRouteImport.update({
    id: '/raporty/wyprzedaz-magazynu',
    path: '/raporty/wyprzedaz-magazynu',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyZmianyBlozuRoute = AuthRaportyZmianyBlozuRouteImport.update({
  id: '/raporty/zmiany-blozu',
  path: '/raporty/zmiany-blozu',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRaportyZwrotyDzienneRoute =
  AuthRaportyZwrotyDzienneRouteImport.update({
    id: '/raporty/zwroty-dzienne',
    path: '/raporty/zwroty-dzienne',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyZwrotyKwartalneRoute =
  AuthRaportyZwrotyKwartalneRouteImport.update({
    id: '/raporty/zwroty-kwartalne',
    path: '/raporty/zwroty-kwartalne',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRdaAnalizaKorzysciRoute = AuthRdaAnalizaKorzysciRouteImport.update({
  id: '/rda/analiza-korzysci',
  path: '/rda/analiza-korzysci',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRdaListaOfertFm1Route = AuthRdaListaOfertFm1RouteImport.update({
  id: '/rda/lista-ofert-fm1',
  path: '/rda/lista-ofert-fm1',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecepturaProtokolyRoute = AuthRecepturaProtokolyRouteImport.update({
  id: '/receptura/protokoly',
  path: '/receptura/protokoly',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecepturaSurowceRoute = AuthRecepturaSurowceRouteImport.update({
  id: '/receptura/surowce',
  path: '/receptura/surowce',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecepturaSzablonyRoute = AuthRecepturaSzablonyRouteImport.update({
  id: '/receptura/szablony',
  path: '/receptura/szablony',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSmsIndexRoute = AuthSmsIndexRouteImport.update({
  id: '/sms/',
  path: '/sms/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSmsKampanieRoute = AuthSmsKampanieRouteImport.update({
  id: '/sms/kampanie',
  path: '/sms/kampanie',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSmsKontaktyRoute = AuthSmsKontaktyRouteImport.update({
  id: '/sms/kontakty',
  path: '/sms/kontakty',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSmsSzablonyRoute = AuthSmsSzablonyRouteImport.update({
  id: '/sms/szablony',
  path: '/sms/szablony',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSmsZuzycieRoute = AuthSmsZuzycieRouteImport.update({
  id: '/sms/zuzycie',
  path: '/sms/zuzycie',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStrategCenowyIndexRoute = AuthStrategCenowyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthStrategCenowyRouteRoute,
} as any)
const AuthStrategCenowyCennikiCentralneRoute =
  AuthStrategCenowyCennikiCentralneRouteImport.update({
    id: '/cenniki-centralne',
    path: '/cenniki-centralne',
    getParentRoute: () => AuthStrategCenowyRouteRoute,
  } as any)
const AuthStrategCenowyCennikiWlasneRoute =
  AuthStrategCenowyCennikiWlasneRouteImport.update({
    id: '/cenniki-wlasne',
    path: '/cenniki-wlasne',
    getParentRoute: () => AuthStrategCenowyRouteRoute,
  } as any)
const AuthStrategCenowyKalkulatorMarzyRoute =
  AuthStrategCenowyKalkulatorMarzyRouteImport.update({
    id: '/kalkulator-marzy',
    path: '/kalkulator-marzy',
    getParentRoute: () => AuthStrategCenowyRouteRoute,
  } as any)
const AuthStrategCenowyKonfiguracjaTopRoute =
  AuthStrategCenowyKonfiguracjaTopRouteImport.update({
    id: '/konfiguracja-top',
    path: '/konfiguracja-top',
    getParentRoute: () => AuthStrategCenowyRouteRoute,
  } as any)
const AuthStrategCenowyLiderFranczyzaRoute =
  AuthStrategCenowyLiderFranczyzaRouteImport.update({
    id: '/lider-franczyza',
    path: '/lider-franczyza',
    getParentRoute: () => AuthStrategCenowyRouteRoute,
  } as any)
const AuthStrategCenowyModyfikatoryRoute =
  AuthStrategCenowyModyfikatoryRouteImport.update({
    id: '/modyfikatory',
    path: '/modyfikatory',
    getParentRoute: () => AuthStrategCenowyRouteRoute,
  } as any)
const AuthStrategCenowyStrategieRoute =
  AuthStrategCenowyStrategieRouteImport.update({
    id: '/strategie',
    path: '/strategie',
    getParentRoute: () => AuthStrategCenowyRouteRoute,
  } as any)
const AuthStrategCenowyWykluczeniaRoute =
  AuthStrategCenowyWykluczeniaRouteImport.update({
    id: '/wykluczenia',
    path: '/wykluczenia',
    getParentRoute: () => AuthStrategCenowyRouteRoute,
  } as any)
const AuthStrategCenowyWynikiRoute = AuthStrategCenowyWynikiRouteImport.update({
  id: '/wyniki',
  path: '/wyniki',
  getParentRoute: () => AuthStrategCenowyRouteRoute,
} as any)
const AuthStrategCenowyWynikiTopRoute =
  AuthStrategCenowyWynikiTopRouteImport.update({
    id: '/wyniki-top',
    path: '/wyniki-top',
    getParentRoute: () => AuthStrategCenowyRouteRoute,
  } as any)
const AuthSynchronizacjaKonsolaSqlRoute =
  AuthSynchronizacjaKonsolaSqlRouteImport.update({
    id: '/synchronizacja/konsola-sql',
    path: '/synchronizacja/konsola-sql',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSynchronizacjaZatwierdzeniaSqlRoute =
  AuthSynchronizacjaZatwierdzeniaSqlRouteImport.update({
    id: '/synchronizacja/zatwierdzenia-sql',
    path: '/synchronizacja/zatwierdzenia-sql',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDokumentyHurtownicyNipRoute =
  AuthDokumentyHurtownicyNipRouteImport.update({
    id: '/$nip',
    path: '/$nip',
    getParentRoute: () => AuthDokumentyHurtownicyRoute,
  } as any)
const AuthDokumentyKsefInvoiceIdRoute =
  AuthDokumentyKsefInvoiceIdRouteImport.update({
    id: '/$invoiceId',
    path: '/$invoiceId',
    getParentRoute: () => AuthDokumentyKsefRoute,
  } as any)
const AuthKonfiguracjaIssueResolveIndexRoute =
  AuthKonfiguracjaIssueResolveIndexRouteImport.update({
    id: '/konfiguracja/issue-resolve/',
    path: '/konfiguracja/issue-resolve/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaIssueResolveNumberRoute =
  AuthKonfiguracjaIssueResolveNumberRouteImport.update({
    id: '/konfiguracja/issue-resolve/$number',
    path: '/konfiguracja/issue-resolve/$number',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKonfiguracjaSfyPrzegladRoute =
  AuthKonfiguracjaSfyPrzegladRouteImport.update({
    id: '/konfiguracja/sfy_/przeglad',
    path: '/konfiguracja/sfy/przeglad',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyAptekiGapIndexRoute =
  AuthKontraktyAptekiGapIndexRouteImport.update({
    id: '/kontrakty/apteki-gap/',
    path: '/kontrakty/apteki-gap/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyAptekiGapIdRoute =
  AuthKontraktyAptekiGapIdRouteImport.update({
    id: '/kontrakty/apteki-gap/$id',
    path: '/kontrakty/apteki-gap/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyAptekiGapNowyRoute =
  AuthKontraktyAptekiGapNowyRouteImport.update({
    id: '/kontrakty/apteki-gap/nowy',
    path: '/kontrakty/apteki-gap/nowy',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyCennikiExfactoryIndexRoute =
  AuthKontraktyCennikiExfactoryIndexRouteImport.update({
    id: '/kontrakty/cenniki-exfactory/',
    path: '/kontrakty/cenniki-exfactory/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyCennikiExfactoryIdRoute =
  AuthKontraktyCennikiExfactoryIdRouteImport.update({
    id: '/kontrakty/cenniki-exfactory/$id',
    path: '/kontrakty/cenniki-exfactory/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyCennikiExfactoryNowyRoute =
  AuthKontraktyCennikiExfactoryNowyRouteImport.update({
    id: '/kontrakty/cenniki-exfactory/nowy',
    path: '/kontrakty/cenniki-exfactory/nowy',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyDoplatyGapIndexRoute =
  AuthKontraktyDoplatyGapIndexRouteImport.update({
    id: '/kontrakty/doplaty-gap/',
    path: '/kontrakty/doplaty-gap/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyDoplatyGapIdRoute =
  AuthKontraktyDoplatyGapIdRouteImport.update({
    id: '/kontrakty/doplaty-gap/$id',
    path: '/kontrakty/doplaty-gap/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyDoplatyGapNowyRoute =
  AuthKontraktyDoplatyGapNowyRouteImport.update({
    id: '/kontrakty/doplaty-gap/nowy',
    path: '/kontrakty/doplaty-gap/nowy',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyLiderZakupyIndexRoute =
  AuthKontraktyLiderZakupyIndexRouteImport.update({
    id: '/kontrakty/lider-zakupy/',
    path: '/kontrakty/lider-zakupy/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyLiderZakupyIdRoute =
  AuthKontraktyLiderZakupyIdRouteImport.update({
    id: '/kontrakty/lider-zakupy/$id',
    path: '/kontrakty/lider-zakupy/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyLiderZakupyNowyRoute =
  AuthKontraktyLiderZakupyNowyRouteImport.update({
    id: '/kontrakty/lider-zakupy/nowy',
    path: '/kontrakty/lider-zakupy/nowy',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyMslDostepnoscIndexRoute =
  AuthKontraktyMslDostepnoscIndexRouteImport.update({
    id: '/kontrakty/msl-dostepnosc/',
    path: '/kontrakty/msl-dostepnosc/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyMslDostepnoscIdRoute =
  AuthKontraktyMslDostepnoscIdRouteImport.update({
    id: '/kontrakty/msl-dostepnosc/$id',
    path: '/kontrakty/msl-dostepnosc/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyMslDostepnoscNowyRoute =
  AuthKontraktyMslDostepnoscNowyRouteImport.update({
    id: '/kontrakty/msl-dostepnosc/nowy',
    path: '/kontrakty/msl-dostepnosc/nowy',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyPorownanieIndexRoute =
  AuthKontraktyPorownanieIndexRouteImport.update({
    id: '/kontrakty/porownanie/',
    path: '/kontrakty/porownanie/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyPorownanieIdRoute =
  AuthKontraktyPorownanieIdRouteImport.update({
    id: '/kontrakty/porownanie/$id',
    path: '/kontrakty/porownanie/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyRaportyIndexRoute =
  AuthKontraktyRaportyIndexRouteImport.update({
    id: '/kontrakty/raporty/',
    path: '/kontrakty/raporty/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyRaportyKontraktRoute =
  AuthKontraktyRaportyKontraktRouteImport.update({
    id: '/kontrakty/raporty/kontrakt',
    path: '/kontrakty/raporty/kontrakt',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyRaportyLiderRoute =
  AuthKontraktyRaportyLiderRouteImport.update({
    id: '/kontrakty/raporty/lider',
    path: '/kontrakty/raporty/lider',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyRaportyPodsumowanieRoute =
  AuthKontraktyRaportyPodsumowanieRouteImport.update({
    id: '/kontrakty/raporty/podsumowanie',
    path: '/kontrakty/raporty/podsumowanie',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyRaportyProducentRoute =
  AuthKontraktyRaportyProducentRouteImport.update({
    id: '/kontrakty/raporty/producent',
    path: '/kontrakty/raporty/producent',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyRozliczeniaZakupIndexRoute =
  AuthKontraktyRozliczeniaZakupIndexRouteImport.update({
    id: '/kontrakty/rozliczenia-zakup/',
    path: '/kontrakty/rozliczenia-zakup/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyRozliczeniaZakupIdRoute =
  AuthKontraktyRozliczeniaZakupIdRouteImport.update({
    id: '/kontrakty/rozliczenia-zakup/$id',
    path: '/kontrakty/rozliczenia-zakup/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyRozliczeniaIndexRoute =
  AuthKontraktyRozliczeniaIndexRouteImport.update({
    id: '/kontrakty/rozliczenia/',
    path: '/kontrakty/rozliczenia/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyRozliczeniaIdRoute =
  AuthKontraktyRozliczeniaIdRouteImport.update({
    id: '/kontrakty/rozliczenia/$id',
    path: '/kontrakty/rozliczenia/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyRozliczeniaAktywnoscAptekRoute =
  AuthKontraktyRozliczeniaAktywnoscAptekRouteImport.update({
    id: '/kontrakty/rozliczenia/aktywnosc-aptek',
    path: '/kontrakty/rozliczenia/aktywnosc-aptek',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyRozliczeniaPrognozaWstecznaRoute =
  AuthKontraktyRozliczeniaPrognozaWstecznaRouteImport.update({
    id: '/kontrakty/rozliczenia/prognoza-wsteczna',
    path: '/kontrakty/rozliczenia/prognoza-wsteczna',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyRozliczeniaProporcjeKanalowRoute =
  AuthKontraktyRozliczeniaProporcjeKanalowRouteImport.update({
    id: '/kontrakty/rozliczenia/proporcje-kanalow',
    path: '/kontrakty/rozliczenia/proporcje-kanalow',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyWeryfikacjaWysylekIndexRoute =
  AuthKontraktyWeryfikacjaWysylekIndexRouteImport.update({
    id: '/kontrakty/weryfikacja-wysylek/',
    path: '/kontrakty/weryfikacja-wysylek/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyWeryfikacjaWysylekIdRoute =
  AuthKontraktyWeryfikacjaWysylekIdRouteImport.update({
    id: '/kontrakty/weryfikacja-wysylek/$id',
    path: '/kontrakty/weryfikacja-wysylek/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyWeryfikacjaWysylekKlienciRoute =
  AuthKontraktyWeryfikacjaWysylekKlienciRouteImport.update({
    id: '/kontrakty/weryfikacja-wysylek/klienci',
    path: '/kontrakty/weryfikacja-wysylek/klienci',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyWeryfikacjaWysylekPolaczeniaRoute =
  AuthKontraktyWeryfikacjaWysylekPolaczeniaRouteImport.update({
    id: '/kontrakty/weryfikacja-wysylek/polaczenia',
    path: '/kontrakty/weryfikacja-wysylek/polaczenia',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySprzWybranychBlozowIndexRoute =
  AuthRaportySprzWybranychBlozowIndexRouteImport.update({
    id: '/raporty/sprz-wybranych-blozow/',
    path: '/raporty/sprz-wybranych-blozow/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySystemPremiowyLiderSzczegolowoRoute =
  AuthRaportySystemPremiowyLiderSzczegolowoRouteImport.update({
    id: '/raporty/system-premiowy/lider-szczegolowo',
    path: '/raporty/system-premiowy/lider-szczegolowo',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyWeryfikacjaSprzedazyIndexRoute =
  AuthRaportyWeryfikacjaSprzedazyIndexRouteImport.update({
    id: '/raporty/weryfikacja-sprzedazy/',
    path: '/raporty/weryfikacja-sprzedazy/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyWeryfikacjaSprzedazyFakturaDoParagonuRoute =
  AuthRaportyWeryfikacjaSprzedazyFakturaDoParagonuRouteImport.update({
    id: '/raporty/weryfikacja-sprzedazy/faktura-do-paragonu',
    path: '/raporty/weryfikacja-sprzedazy/faktura-do-paragonu',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportyWeryfikacjaSprzedazyZmianyRoute =
  AuthRaportyWeryfikacjaSprzedazyZmianyRouteImport.update({
    id: '/raporty/weryfikacja-sprzedazy/zmiany',
    path: '/raporty/weryfikacja-sprzedazy/zmiany',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRdaListaOfertFm1OfferIdRoute =
  AuthRdaListaOfertFm1OfferIdRouteImport.update({
    id: '/rda/lista-ofert-fm1_/$offerId',
    path: '/rda/lista-ofert-fm1/$offerId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRecepturaProtokolyIdRoute =
  AuthRecepturaProtokolyIdRouteImport.update({
    id: '/receptura/protokoly_/$id',
    path: '/receptura/protokoly/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSynchronizacjaAptekiIndexRoute =
  AuthSynchronizacjaAptekiIndexRouteImport.update({
    id: '/synchronizacja/apteki/',
    path: '/synchronizacja/apteki/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSynchronizacjaAptekiIdfirmRoute =
  AuthSynchronizacjaAptekiIdfirmRouteImport.update({
    id: '/synchronizacja/apteki/$idfirm',
    path: '/synchronizacja/apteki/$idfirm',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKontraktyRozliczeniaZakupIdAnalizaDzialZakupowRoute =
  AuthKontraktyRozliczeniaZakupIdAnalizaDzialZakupowRouteImport.update({
    id: '/analiza-dzial-zakupow',
    path: '/analiza-dzial-zakupow',
    getParentRoute: () => AuthKontraktyRozliczeniaZakupIdRoute,
  } as any)
const AuthKontraktyRozliczeniaZakupIdAnalizaPerSpolkaRoute =
  AuthKontraktyRozliczeniaZakupIdAnalizaPerSpolkaRouteImport.update({
    id: '/analiza-per-spolka',
    path: '/analiza-per-spolka',
    getParentRoute: () => AuthKontraktyRozliczeniaZakupIdRoute,
  } as any)
const AuthKontraktyRozliczeniaIdMiesiecznieRoute =
  AuthKontraktyRozliczeniaIdMiesiecznieRouteImport.update({
    id: '/miesiecznie',
    path: '/miesiecznie',
    getParentRoute: () => AuthKontraktyRozliczeniaIdRoute,
  } as any)
const AuthKontraktyRozliczeniaIdPoSpolceRoute =
  AuthKontraktyRozliczeniaIdPoSpolceRouteImport.update({
    id: '/po-spolce',
    path: '/po-spolce',
    getParentRoute: () => AuthKontraktyRozliczeniaIdRoute,
  } as any)
const AuthRaportySprzWybranychBlozowParametryIndexRoute =
  AuthRaportySprzWybranychBlozowParametryIndexRouteImport.update({
    id: '/raporty/sprz-wybranych-blozow/parametry/',
    path: '/raporty/sprz-wybranych-blozow/parametry/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySprzWybranychBlozowParametryIdRoute =
  AuthRaportySprzWybranychBlozowParametryIdRouteImport.update({
    id: '/raporty/sprz-wybranych-blozow/parametry/$id',
    path: '/raporty/sprz-wybranych-blozow/parametry/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySprzWybranychBlozowParametryNowyRoute =
  AuthRaportySprzWybranychBlozowParametryNowyRouteImport.update({
    id: '/raporty/sprz-wybranych-blozow/parametry/nowy',
    path: '/raporty/sprz-wybranych-blozow/parametry/nowy',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySystemPremiowyLiderIndexRoute =
  AuthRaportySystemPremiowyLiderIndexRouteImport.update({
    id: '/raporty/system-premiowy/lider/',
    path: '/raporty/system-premiowy/lider/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySystemPremiowyLiderIdRoute =
  AuthRaportySystemPremiowyLiderIdRouteImport.update({
    id: '/raporty/system-premiowy/lider/$id',
    path: '/raporty/system-premiowy/lider/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySystemPremiowyLiderNowyRoute =
  AuthRaportySystemPremiowyLiderNowyRouteImport.update({
    id: '/raporty/system-premiowy/lider/nowy',
    path: '/raporty/system-premiowy/lider/nowy',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySystemPremiowyProgramPartnerskiIndexRoute =
  AuthRaportySystemPremiowyProgramPartnerskiIndexRouteImport.update({
    id: '/raporty/system-premiowy/program-partnerski/',
    path: '/raporty/system-premiowy/program-partnerski/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySystemPremiowyProgramPartnerskiIdRoute =
  AuthRaportySystemPremiowyProgramPartnerskiIdRouteImport.update({
    id: '/raporty/system-premiowy/program-partnerski/$id',
    path: '/raporty/system-premiowy/program-partnerski/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySystemPremiowyProgramPartnerskiNowyRoute =
  AuthRaportySystemPremiowyProgramPartnerskiNowyRouteImport.update({
    id: '/raporty/system-premiowy/program-partnerski/nowy',
    path: '/raporty/system-premiowy/program-partnerski/nowy',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySystemPremiowyRentownoscIndexRoute =
  AuthRaportySystemPremiowyRentownoscIndexRouteImport.update({
    id: '/raporty/system-premiowy/rentownosc/',
    path: '/raporty/system-premiowy/rentownosc/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySystemPremiowyRentownoscIdRoute =
  AuthRaportySystemPremiowyRentownoscIdRouteImport.update({
    id: '/raporty/system-premiowy/rentownosc/$id',
    path: '/raporty/system-premiowy/rentownosc/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySystemPremiowyRentownoscNowaRoute =
  AuthRaportySystemPremiowyRentownoscNowaRouteImport.update({
    id: '/raporty/system-premiowy/rentownosc/nowa',
    path: '/raporty/system-premiowy/rentownosc/nowa',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySystemPremiowyStrukturaIndexRoute =
  AuthRaportySystemPremiowyStrukturaIndexRouteImport.update({
    id: '/raporty/system-premiowy/struktura/',
    path: '/raporty/system-premiowy/struktura/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySystemPremiowyStrukturaIdRoute =
  AuthRaportySystemPremiowyStrukturaIdRouteImport.update({
    id: '/raporty/system-premiowy/struktura/$id',
    path: '/raporty/system-premiowy/struktura/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRaportySystemPremiowyStrukturaNowaRoute =
  AuthRaportySystemPremiowyStrukturaNowaRouteImport.update({
    id: '/raporty/system-premiowy/struktura/nowa',
    path: '/raporty/system-premiowy/struktura/nowa',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRecepturaProtokolyIdDrukujRoute =
  AuthRecepturaProtokolyIdDrukujRouteImport.update({
    id: '/receptura/protokoly_/$id_/drukuj',
    path: '/receptura/protokoly/$id/drukuj',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthRecepturaProtokolyIdEtykietaRoute =
  AuthRecepturaProtokolyIdEtykietaRouteImport.update({
    id: '/receptura/protokoly_/$id_/etykieta',
    path: '/receptura/protokoly/$id/etykieta',
    getParentRoute: () => AuthRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/502': typeof R502Route
  '/login': typeof LoginRoute
  '/reset-hasla': typeof ResetHaslaRoute
  '/ustaw-haslo': typeof UstawHasloRoute
  '/zgloszenie': typeof ZgloszenieRoute
  '/strateg-cenowy': typeof AuthStrategCenowyRouteRouteWithChildren
  '/asystent': typeof AuthAsystentRoute
  '/asystent-jakosc': typeof AuthAsystentJakoscRoute
  '/asystent-koszty': typeof AuthAsystentKosztyRoute
  '/asystent-statystyki-aptek': typeof AuthAsystentStatystykiAptekRoute
  '/dashboard': typeof AuthDashboardRoute
  '/moj-profil': typeof AuthMojProfilRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/polacz-ai/zgoda': typeof PolaczAiZgodaRoute
  '/publiczne/ksef': typeof PubliczneKsefRoute
  '/apteneo/porownanie': typeof AuthApteneoPorownanieRoute
  '/apteneo/rozliczenia': typeof AuthApteneoRozliczeniaRoute
  '/apteneo/zaczytaj-dane': typeof AuthApteneoZaczytajDaneRoute
  '/apteneo/zakupy': typeof AuthApteneoZakupyRoute
  '/dokumenty/hurtownicy': typeof AuthDokumentyHurtownicyRouteWithChildren
  '/dokumenty/kalendarz-platnosci': typeof AuthDokumentyKalendarzPlatnosciRoute
  '/dokumenty/ksef': typeof AuthDokumentyKsefRouteWithChildren
  '/helpdesk/awaria': typeof AuthHelpdeskAwariaRoute
  '/helpdesk/czat': typeof AuthHelpdeskCzatRoute
  '/helpdesk/konfiguracja': typeof AuthHelpdeskKonfiguracjaRoute
  '/helpdesk/szukaj': typeof AuthHelpdeskSzukajRoute
  '/helpdesk/zarzadzanie': typeof AuthHelpdeskZarzadzanieRoute
  '/kartoteka/cennik-najtaniej': typeof AuthKartotekaCennikNajtaniejRoute
  '/kartoteka/cennik-zgodnosc': typeof AuthKartotekaCennikZgodnoscRoute
  '/kartoteka/cenniki-historia': typeof AuthKartotekaCennikiHistoriaRoute
  '/kartoteka/cenniki-podglad': typeof AuthKartotekaCennikiPodgladRoute
  '/kartoteka/grupy-produktow': typeof AuthKartotekaGrupyProduktowRoute
  '/kartoteka/kategoryzacja': typeof AuthKartotekaKategoryzacjaRoute
  '/kartoteka/kontrahenci': typeof AuthKartotekaKontrahenciRoute
  '/kartoteka/mapowanie-apc': typeof AuthKartotekaMapowanieApcRoute
  '/kartoteka/producenci': typeof AuthKartotekaProducenciRoute
  '/kartoteka/stan-magazynu': typeof AuthKartotekaStanMagazynuRoute
  '/kartoteka/towary': typeof AuthKartotekaTowaryRoute
  '/konfiguracja/ai': typeof AuthKonfiguracjaAiRoute
  '/konfiguracja/aktualizacje': typeof AuthKonfiguracjaAktualizacjeRoute
  '/konfiguracja/apteki': typeof AuthKonfiguracjaAptekiRoute
  '/konfiguracja/audit-log': typeof AuthKonfiguracjaAuditLogRoute
  '/konfiguracja/drukarki': typeof AuthKonfiguracjaDrukarkiRoute
  '/konfiguracja/dyski': typeof AuthKonfiguracjaDyskiRoute
  '/konfiguracja/eksporty-plikowe': typeof AuthKonfiguracjaEksportyPlikoweRoute
  '/konfiguracja/email': typeof AuthKonfiguracjaEmailRoute
  '/konfiguracja/email-log': typeof AuthKonfiguracjaEmailLogRoute
  '/konfiguracja/grupy-aptek': typeof AuthKonfiguracjaGrupyAptekRoute
  '/konfiguracja/grupy-organizacyjne': typeof AuthKonfiguracjaGrupyOrganizacyjneRoute
  '/konfiguracja/grupy-uzytkownikow': typeof AuthKonfiguracjaGrupyUzytkownikowRoute
  '/konfiguracja/harmonogramy-powiadomien': typeof AuthKonfiguracjaHarmonogramyPowiadomienRoute
  '/konfiguracja/harmonogramy-raportow': typeof AuthKonfiguracjaHarmonogramyRaportowRoute
  '/konfiguracja/import-mshr': typeof AuthKonfiguracjaImportMshrRoute
  '/konfiguracja/iqvia': typeof AuthKonfiguracjaIqviaRoute
  '/konfiguracja/ksef': typeof AuthKonfiguracjaKsefRoute
  '/konfiguracja/ksef-certyfikaty': typeof AuthKonfiguracjaKsefCertyfikatyRoute
  '/konfiguracja/ksef-osoz-edi': typeof AuthKonfiguracjaKsefOsozEdiRoute
  '/konfiguracja/mcp': typeof AuthKonfiguracjaMcpRoute
  '/konfiguracja/mcp-statystyki': typeof AuthKonfiguracjaMcpStatystykiRoute
  '/konfiguracja/organizacje': typeof AuthKonfiguracjaOrganizacjeRoute
  '/konfiguracja/podglad-uzytkownika': typeof AuthKonfiguracjaPodgladUzytkownikaRoute
  '/konfiguracja/pracownicy': typeof AuthKonfiguracjaPracownicyRoute
  '/konfiguracja/reguly-zdarzen': typeof AuthKonfiguracjaRegulyZdarzenRoute
  '/konfiguracja/sfy': typeof AuthKonfiguracjaSfyRoute
  '/konfiguracja/sms': typeof AuthKonfiguracjaSmsRoute
  '/konfiguracja/spolki': typeof AuthKonfiguracjaSpolkiRoute
  '/konfiguracja/sql-konsola': typeof AuthKonfiguracjaSqlKonsolaRoute
  '/konfiguracja/sql-sfy': typeof AuthKonfiguracjaSqlSfyRoute
  '/konfiguracja/statystyki-uzycia': typeof AuthKonfiguracjaStatystykiUzyciaRoute
  '/konfiguracja/system': typeof AuthKonfiguracjaSystemRoute
  '/konfiguracja/tokeny-api': typeof AuthKonfiguracjaTokenyApiRoute
  '/konfiguracja/urzadzenia': typeof AuthKonfiguracjaUrzadzeniaRoute
  '/konfiguracja/uzytkownicy': typeof AuthKonfiguracjaUzytkownicyRoute
  '/kontrakty/$id': typeof AuthKontraktyIdRoute
  '/kontrakty/apteki-producentow': typeof AuthKontraktyAptekiProducentowRoute
  '/kontrakty/apteki-producentow-historia': typeof AuthKontraktyAptekiProducentowHistoriaRoute
  '/kontrakty/nieaktywne-apteki': typeof AuthKontraktyNieaktywneAptekiRoute
  '/kontrakty/nowy': typeof AuthKontraktyNowyRoute
  '/kontrakty/porownanie-z-producentem': typeof AuthKontraktyPorownanieZProducentemRoute
  '/kontrakty/producenci-dzzf': typeof AuthKontraktyProducenciDzzfRoute
  '/kontrakty/udzial': typeof AuthKontraktyUdzialRoute
  '/kontrakty/wykonanie': typeof AuthKontraktyWykonanieRoute
  '/raporty/analiza-zakupow-nowe-zam': typeof AuthRaportyAnalizaZakupowNoweZamRoute
  '/raporty/analiza-zakupy-indeksow': typeof AuthRaportyAnalizaZakupyIndeksowRoute
  '/raporty/dashboard-analityczny': typeof AuthRaportyDashboardAnalitycznyRoute
  '/raporty/dashboard-magazyn-szczegol': typeof AuthRaportyDashboardMagazynSzczegolRoute
  '/raporty/daty-waznosci': typeof AuthRaportyDatyWaznosciRoute
  '/raporty/dynamika-sprzedazy': typeof AuthRaportyDynamikaSprzedazyRoute
  '/raporty/ecom': typeof AuthRaportyEcomRoute
  '/raporty/jakosc-danych-wyjatki': typeof AuthRaportyJakoscDanychWyjatkiRoute
  '/raporty/kategoria-kwartalna': typeof AuthRaportyKategoriaKwartalnaRoute
  '/raporty/luki-powiazan': typeof AuthRaportyLukiPowiazanRoute
  '/raporty/odchylenia-cen-fv': typeof AuthRaportyOdchyleniaCenFvRoute
  '/raporty/raport-produktowy': typeof AuthRaportyRaportProduktowyRoute
  '/raporty/rozklad-marz': typeof AuthRaportyRozkladMarzRoute
  '/raporty/sprz-opiekun': typeof AuthRaportySprzOpiekunRoute
  '/raporty/sprz-wynik': typeof AuthRaportySprzWynikRoute
  '/raporty/sprz_kasjer_data': typeof AuthRaportySprz_kasjer_dataRoute
  '/raporty/sprzedaz-dzienna': typeof AuthRaportySprzedazDziennaRoute
  '/raporty/sprzedaz-zrealizowana': typeof AuthRaportySprzedazZrealizowanaRoute
  '/raporty/ujemne-marze': typeof AuthRaportyUjemneMarzeRoute
  '/raporty/weryfikacja-towr': typeof AuthRaportyWeryfikacjaTowrRoute
  '/raporty/wyprzedaz-magazynu': typeof AuthRaportyWyprzedazMagazynuRoute
  '/raporty/zmiany-blozu': typeof AuthRaportyZmianyBlozuRoute
  '/raporty/zwroty-dzienne': typeof AuthRaportyZwrotyDzienneRoute
  '/raporty/zwroty-kwartalne': typeof AuthRaportyZwrotyKwartalneRoute
  '/rda/analiza-korzysci': typeof AuthRdaAnalizaKorzysciRoute
  '/rda/lista-ofert-fm1': typeof AuthRdaListaOfertFm1Route
  '/receptura/protokoly': typeof AuthRecepturaProtokolyRoute
  '/receptura/surowce': typeof AuthRecepturaSurowceRoute
  '/receptura/szablony': typeof AuthRecepturaSzablonyRoute
  '/sms/kampanie': typeof AuthSmsKampanieRoute
  '/sms/kontakty': typeof AuthSmsKontaktyRoute
  '/sms/szablony': typeof AuthSmsSzablonyRoute
  '/sms/zuzycie': typeof AuthSmsZuzycieRoute
  '/strateg-cenowy/cenniki-centralne': typeof AuthStrategCenowyCennikiCentralneRoute
  '/strateg-cenowy/cenniki-wlasne': typeof AuthStrategCenowyCennikiWlasneRoute
  '/strateg-cenowy/kalkulator-marzy': typeof AuthStrategCenowyKalkulatorMarzyRoute
  '/strateg-cenowy/konfiguracja-top': typeof AuthStrategCenowyKonfiguracjaTopRoute
  '/strateg-cenowy/lider-franczyza': typeof AuthStrategCenowyLiderFranczyzaRoute
  '/strateg-cenowy/modyfikatory': typeof AuthStrategCenowyModyfikatoryRoute
  '/strateg-cenowy/strategie': typeof AuthStrategCenowyStrategieRoute
  '/strateg-cenowy/wykluczenia': typeof AuthStrategCenowyWykluczeniaRoute
  '/strateg-cenowy/wyniki': typeof AuthStrategCenowyWynikiRoute
  '/strateg-cenowy/wyniki-top': typeof AuthStrategCenowyWynikiTopRoute
  '/synchronizacja/konsola-sql': typeof AuthSynchronizacjaKonsolaSqlRoute
  '/synchronizacja/zatwierdzenia-sql': typeof AuthSynchronizacjaZatwierdzeniaSqlRoute
  '/dokumenty/': typeof AuthDokumentyIndexRoute
  '/helpdesk/': typeof AuthHelpdeskIndexRoute
  '/konfiguracja/': typeof AuthKonfiguracjaIndexRoute
  '/kontrakty/': typeof AuthKontraktyIndexRoute
  '/sms/': typeof AuthSmsIndexRoute
  '/strateg-cenowy/': typeof AuthStrategCenowyIndexRoute
  '/dokumenty/hurtownicy/$nip': typeof AuthDokumentyHurtownicyNipRoute
  '/dokumenty/ksef/$invoiceId': typeof AuthDokumentyKsefInvoiceIdRoute
  '/konfiguracja/issue-resolve/$number': typeof AuthKonfiguracjaIssueResolveNumberRoute
  '/konfiguracja/sfy/przeglad': typeof AuthKonfiguracjaSfyPrzegladRoute
  '/kontrakty/apteki-gap/$id': typeof AuthKontraktyAptekiGapIdRoute
  '/kontrakty/apteki-gap/nowy': typeof AuthKontraktyAptekiGapNowyRoute
  '/kontrakty/cenniki-exfactory/$id': typeof AuthKontraktyCennikiExfactoryIdRoute
  '/kontrakty/cenniki-exfactory/nowy': typeof AuthKontraktyCennikiExfactoryNowyRoute
  '/kontrakty/doplaty-gap/$id': typeof AuthKontraktyDoplatyGapIdRoute
  '/kontrakty/doplaty-gap/nowy': typeof AuthKontraktyDoplatyGapNowyRoute
  '/kontrakty/lider-zakupy/$id': typeof AuthKontraktyLiderZakupyIdRoute
  '/kontrakty/lider-zakupy/nowy': typeof AuthKontraktyLiderZakupyNowyRoute
  '/kontrakty/msl-dostepnosc/$id': typeof AuthKontraktyMslDostepnoscIdRoute
  '/kontrakty/msl-dostepnosc/nowy': typeof AuthKontraktyMslDostepnoscNowyRoute
  '/kontrakty/porownanie/$id': typeof AuthKontraktyPorownanieIdRoute
  '/kontrakty/raporty/kontrakt': typeof AuthKontraktyRaportyKontraktRoute
  '/kontrakty/raporty/lider': typeof AuthKontraktyRaportyLiderRoute
  '/kontrakty/raporty/podsumowanie': typeof AuthKontraktyRaportyPodsumowanieRoute
  '/kontrakty/raporty/producent': typeof AuthKontraktyRaportyProducentRoute
  '/kontrakty/rozliczenia-zakup/$id': typeof AuthKontraktyRozliczeniaZakupIdRouteWithChildren
  '/kontrakty/rozliczenia/$id': typeof AuthKontraktyRozliczeniaIdRouteWithChildren
  '/kontrakty/rozliczenia/aktywnosc-aptek': typeof AuthKontraktyRozliczeniaAktywnoscAptekRoute
  '/kontrakty/rozliczenia/prognoza-wsteczna': typeof AuthKontraktyRozliczeniaPrognozaWstecznaRoute
  '/kontrakty/rozliczenia/proporcje-kanalow': typeof AuthKontraktyRozliczeniaProporcjeKanalowRoute
  '/kontrakty/weryfikacja-wysylek/$id': typeof AuthKontraktyWeryfikacjaWysylekIdRoute
  '/kontrakty/weryfikacja-wysylek/klienci': typeof AuthKontraktyWeryfikacjaWysylekKlienciRoute
  '/kontrakty/weryfikacja-wysylek/polaczenia': typeof AuthKontraktyWeryfikacjaWysylekPolaczeniaRoute
  '/raporty/system-premiowy/lider-szczegolowo': typeof AuthRaportySystemPremiowyLiderSzczegolowoRoute
  '/raporty/weryfikacja-sprzedazy/faktura-do-paragonu': typeof AuthRaportyWeryfikacjaSprzedazyFakturaDoParagonuRoute
  '/raporty/weryfikacja-sprzedazy/zmiany': typeof AuthRaportyWeryfikacjaSprzedazyZmianyRoute
  '/rda/lista-ofert-fm1/$offerId': typeof AuthRdaListaOfertFm1OfferIdRoute
  '/receptura/protokoly/$id': typeof AuthRecepturaProtokolyIdRoute
  '/synchronizacja/apteki/$idfirm': typeof AuthSynchronizacjaAptekiIdfirmRoute
  '/konfiguracja/issue-resolve/': typeof AuthKonfiguracjaIssueResolveIndexRoute
  '/kontrakty/apteki-gap/': typeof AuthKontraktyAptekiGapIndexRoute
  '/kontrakty/cenniki-exfactory/': typeof AuthKontraktyCennikiExfactoryIndexRoute
  '/kontrakty/doplaty-gap/': typeof AuthKontraktyDoplatyGapIndexRoute
  '/kontrakty/lider-zakupy/': typeof AuthKontraktyLiderZakupyIndexRoute
  '/kontrakty/msl-dostepnosc/': typeof AuthKontraktyMslDostepnoscIndexRoute
  '/kontrakty/porownanie/': typeof AuthKontraktyPorownanieIndexRoute
  '/kontrakty/raporty/': typeof AuthKontraktyRaportyIndexRoute
  '/kontrakty/rozliczenia-zakup/': typeof AuthKontraktyRozliczeniaZakupIndexRoute
  '/kontrakty/rozliczenia/': typeof AuthKontraktyRozliczeniaIndexRoute
  '/kontrakty/weryfikacja-wysylek/': typeof AuthKontraktyWeryfikacjaWysylekIndexRoute
  '/raporty/sprz-wybranych-blozow/': typeof AuthRaportySprzWybranychBlozowIndexRoute
  '/raporty/weryfikacja-sprzedazy/': typeof AuthRaportyWeryfikacjaSprzedazyIndexRoute
  '/synchronizacja/apteki/': typeof AuthSynchronizacjaAptekiIndexRoute
  '/kontrakty/rozliczenia-zakup/$id/analiza-dzial-zakupow': typeof AuthKontraktyRozliczeniaZakupIdAnalizaDzialZakupowRoute
  '/kontrakty/rozliczenia-zakup/$id/analiza-per-spolka': typeof AuthKontraktyRozliczeniaZakupIdAnalizaPerSpolkaRoute
  '/kontrakty/rozliczenia/$id/miesiecznie': typeof AuthKontraktyRozliczeniaIdMiesiecznieRoute
  '/kontrakty/rozliczenia/$id/po-spolce': typeof AuthKontraktyRozliczeniaIdPoSpolceRoute
  '/raporty/sprz-wybranych-blozow/parametry/$id': typeof AuthRaportySprzWybranychBlozowParametryIdRoute
  '/raporty/sprz-wybranych-blozow/parametry/nowy': typeof AuthRaportySprzWybranychBlozowParametryNowyRoute
  '/raporty/system-premiowy/lider/$id': typeof AuthRaportySystemPremiowyLiderIdRoute
  '/raporty/system-premiowy/lider/nowy': typeof AuthRaportySystemPremiowyLiderNowyRoute
  '/raporty/system-premiowy/program-partnerski/$id': typeof AuthRaportySystemPremiowyProgramPartnerskiIdRoute
  '/raporty/system-premiowy/program-partnerski/nowy': typeof AuthRaportySystemPremiowyProgramPartnerskiNowyRoute
  '/raporty/system-premiowy/rentownosc/$id': typeof AuthRaportySystemPremiowyRentownoscIdRoute
  '/raporty/system-premiowy/rentownosc/nowa': typeof AuthRaportySystemPremiowyRentownoscNowaRoute
  '/raporty/system-premiowy/struktura/$id': typeof AuthRaportySystemPremiowyStrukturaIdRoute
  '/raporty/system-premiowy/struktura/nowa': typeof AuthRaportySystemPremiowyStrukturaNowaRoute
  '/receptura/protokoly/$id/drukuj': typeof AuthRecepturaProtokolyIdDrukujRoute
  '/receptura/protokoly/$id/etykieta': typeof AuthRecepturaProtokolyIdEtykietaRoute
  '/raporty/sprz-wybranych-blozow/parametry/': typeof AuthRaportySprzWybranychBlozowParametryIndexRoute
  '/raporty/system-premiowy/lider/': typeof AuthRaportySystemPremiowyLiderIndexRoute
  '/raporty/system-premiowy/program-partnerski/': typeof AuthRaportySystemPremiowyProgramPartnerskiIndexRoute
  '/raporty/system-premiowy/rentownosc/': typeof AuthRaportySystemPremiowyRentownoscIndexRoute
  '/raporty/system-premiowy/struktura/': typeof AuthRaportySystemPremiowyStrukturaIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/502': typeof R502Route
  '/login': typeof LoginRoute
  '/reset-hasla': typeof ResetHaslaRoute
  '/ustaw-haslo': typeof UstawHasloRoute
  '/zgloszenie': typeof ZgloszenieRoute
  '/asystent': typeof AuthAsystentRoute
  '/asystent-jakosc': typeof AuthAsystentJakoscRoute
  '/asystent-koszty': typeof AuthAsystentKosztyRoute
  '/asystent-statystyki-aptek': typeof AuthAsystentStatystykiAptekRoute
  '/dashboard': typeof AuthDashboardRoute
  '/moj-profil': typeof AuthMojProfilRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/polacz-ai/zgoda': typeof PolaczAiZgodaRoute
  '/publiczne/ksef': typeof PubliczneKsefRoute
  '/apteneo/porownanie': typeof AuthApteneoPorownanieRoute
  '/apteneo/rozliczenia': typeof AuthApteneoRozliczeniaRoute
  '/apteneo/zaczytaj-dane': typeof AuthApteneoZaczytajDaneRoute
  '/apteneo/zakupy': typeof AuthApteneoZakupyRoute
  '/dokumenty/hurtownicy': typeof AuthDokumentyHurtownicyRouteWithChildren
  '/dokumenty/kalendarz-platnosci': typeof AuthDokumentyKalendarzPlatnosciRoute
  '/dokumenty/ksef': typeof AuthDokumentyKsefRouteWithChildren
  '/helpdesk/awaria': typeof AuthHelpdeskAwariaRoute
  '/helpdesk/czat': typeof AuthHelpdeskCzatRoute
  '/helpdesk/konfiguracja': typeof AuthHelpdeskKonfiguracjaRoute
  '/helpdesk/szukaj': typeof AuthHelpdeskSzukajRoute
  '/helpdesk/zarzadzanie': typeof AuthHelpdeskZarzadzanieRoute
  '/kartoteka/cennik-najtaniej': typeof AuthKartotekaCennikNajtaniejRoute
  '/kartoteka/cennik-zgodnosc': typeof AuthKartotekaCennikZgodnoscRoute
  '/kartoteka/cenniki-historia': typeof AuthKartotekaCennikiHistoriaRoute
  '/kartoteka/cenniki-podglad': typeof AuthKartotekaCennikiPodgladRoute
  '/kartoteka/grupy-produktow': typeof AuthKartotekaGrupyProduktowRoute
  '/kartoteka/kategoryzacja': typeof AuthKartotekaKategoryzacjaRoute
  '/kartoteka/kontrahenci': typeof AuthKartotekaKontrahenciRoute
  '/kartoteka/mapowanie-apc': typeof AuthKartotekaMapowanieApcRoute
  '/kartoteka/producenci': typeof AuthKartotekaProducenciRoute
  '/kartoteka/stan-magazynu': typeof AuthKartotekaStanMagazynuRoute
  '/kartoteka/towary': typeof AuthKartotekaTowaryRoute
  '/konfiguracja/ai': typeof AuthKonfiguracjaAiRoute
  '/konfiguracja/aktualizacje': typeof AuthKonfiguracjaAktualizacjeRoute
  '/konfiguracja/apteki': typeof AuthKonfiguracjaAptekiRoute
  '/konfiguracja/audit-log': typeof AuthKonfiguracjaAuditLogRoute
  '/konfiguracja/drukarki': typeof AuthKonfiguracjaDrukarkiRoute
  '/konfiguracja/dyski': typeof AuthKonfiguracjaDyskiRoute
  '/konfiguracja/eksporty-plikowe': typeof AuthKonfiguracjaEksportyPlikoweRoute
  '/konfiguracja/email': typeof AuthKonfiguracjaEmailRoute
  '/konfiguracja/email-log': typeof AuthKonfiguracjaEmailLogRoute
  '/konfiguracja/grupy-aptek': typeof AuthKonfiguracjaGrupyAptekRoute
  '/konfiguracja/grupy-organizacyjne': typeof AuthKonfiguracjaGrupyOrganizacyjneRoute
  '/konfiguracja/grupy-uzytkownikow': typeof AuthKonfiguracjaGrupyUzytkownikowRoute
  '/konfiguracja/harmonogramy-powiadomien': typeof AuthKonfiguracjaHarmonogramyPowiadomienRoute
  '/konfiguracja/harmonogramy-raportow': typeof AuthKonfiguracjaHarmonogramyRaportowRoute
  '/konfiguracja/import-mshr': typeof AuthKonfiguracjaImportMshrRoute
  '/konfiguracja/iqvia': typeof AuthKonfiguracjaIqviaRoute
  '/konfiguracja/ksef': typeof AuthKonfiguracjaKsefRoute
  '/konfiguracja/ksef-certyfikaty': typeof AuthKonfiguracjaKsefCertyfikatyRoute
  '/konfiguracja/ksef-osoz-edi': typeof AuthKonfiguracjaKsefOsozEdiRoute
  '/konfiguracja/mcp': typeof AuthKonfiguracjaMcpRoute
  '/konfiguracja/mcp-statystyki': typeof AuthKonfiguracjaMcpStatystykiRoute
  '/konfiguracja/organizacje': typeof AuthKonfiguracjaOrganizacjeRoute
  '/konfiguracja/podglad-uzytkownika': typeof AuthKonfiguracjaPodgladUzytkownikaRoute
  '/konfiguracja/pracownicy': typeof AuthKonfiguracjaPracownicyRoute
  '/konfiguracja/reguly-zdarzen': typeof AuthKonfiguracjaRegulyZdarzenRoute
  '/konfiguracja/sfy': typeof AuthKonfiguracjaSfyRoute
  '/konfiguracja/sms': typeof AuthKonfiguracjaSmsRoute
  '/konfiguracja/spolki': typeof AuthKonfiguracjaSpolkiRoute
  '/konfiguracja/sql-konsola': typeof AuthKonfiguracjaSqlKonsolaRoute
  '/konfiguracja/sql-sfy': typeof AuthKonfiguracjaSqlSfyRoute
  '/konfiguracja/statystyki-uzycia': typeof AuthKonfiguracjaStatystykiUzyciaRoute
  '/konfiguracja/system': typeof AuthKonfiguracjaSystemRoute
  '/konfiguracja/tokeny-api': typeof AuthKonfiguracjaTokenyApiRoute
  '/konfiguracja/urzadzenia': typeof AuthKonfiguracjaUrzadzeniaRoute
  '/konfiguracja/uzytkownicy': typeof AuthKonfiguracjaUzytkownicyRoute
  '/kontrakty/$id': typeof AuthKontraktyIdRoute
  '/kontrakty/apteki-producentow': typeof AuthKontraktyAptekiProducentowRoute
  '/kontrakty/apteki-producentow-historia': typeof AuthKontraktyAptekiProducentowHistoriaRoute
  '/kontrakty/nieaktywne-apteki': typeof AuthKontraktyNieaktywneAptekiRoute
  '/kontrakty/nowy': typeof AuthKontraktyNowyRoute
  '/kontrakty/porownanie-z-producentem': typeof AuthKontraktyPorownanieZProducentemRoute
  '/kontrakty/producenci-dzzf': typeof AuthKontraktyProducenciDzzfRoute
  '/kontrakty/udzial': typeof AuthKontraktyUdzialRoute
  '/kontrakty/wykonanie': typeof AuthKontraktyWykonanieRoute
  '/raporty/analiza-zakupow-nowe-zam': typeof AuthRaportyAnalizaZakupowNoweZamRoute
  '/raporty/analiza-zakupy-indeksow': typeof AuthRaportyAnalizaZakupyIndeksowRoute
  '/raporty/dashboard-analityczny': typeof AuthRaportyDashboardAnalitycznyRoute
  '/raporty/dashboard-magazyn-szczegol': typeof AuthRaportyDashboardMagazynSzczegolRoute
  '/raporty/daty-waznosci': typeof AuthRaportyDatyWaznosciRoute
  '/raporty/dynamika-sprzedazy': typeof AuthRaportyDynamikaSprzedazyRoute
  '/raporty/ecom': typeof AuthRaportyEcomRoute
  '/raporty/jakosc-danych-wyjatki': typeof AuthRaportyJakoscDanychWyjatkiRoute
  '/raporty/kategoria-kwartalna': typeof AuthRaportyKategoriaKwartalnaRoute
  '/raporty/luki-powiazan': typeof AuthRaportyLukiPowiazanRoute
  '/raporty/odchylenia-cen-fv': typeof AuthRaportyOdchyleniaCenFvRoute
  '/raporty/raport-produktowy': typeof AuthRaportyRaportProduktowyRoute
  '/raporty/rozklad-marz': typeof AuthRaportyRozkladMarzRoute
  '/raporty/sprz-opiekun': typeof AuthRaportySprzOpiekunRoute
  '/raporty/sprz-wynik': typeof AuthRaportySprzWynikRoute
  '/raporty/sprz_kasjer_data': typeof AuthRaportySprz_kasjer_dataRoute
  '/raporty/sprzedaz-dzienna': typeof AuthRaportySprzedazDziennaRoute
  '/raporty/sprzedaz-zrealizowana': typeof AuthRaportySprzedazZrealizowanaRoute
  '/raporty/ujemne-marze': typeof AuthRaportyUjemneMarzeRoute
  '/raporty/weryfikacja-towr': typeof AuthRaportyWeryfikacjaTowrRoute
  '/raporty/wyprzedaz-magazynu': typeof AuthRaportyWyprzedazMagazynuRoute
  '/raporty/zmiany-blozu': typeof AuthRaportyZmianyBlozuRoute
  '/raporty/zwroty-dzienne': typeof AuthRaportyZwrotyDzienneRoute
  '/raporty/zwroty-kwartalne': typeof AuthRaportyZwrotyKwartalneRoute
  '/rda/analiza-korzysci': typeof AuthRdaAnalizaKorzysciRoute
  '/rda/lista-ofert-fm1': typeof AuthRdaListaOfertFm1Route
  '/receptura/protokoly': typeof AuthRecepturaProtokolyRoute
  '/receptura/surowce': typeof AuthRecepturaSurowceRoute
  '/receptura/szablony': typeof AuthRecepturaSzablonyRoute
  '/sms/kampanie': typeof AuthSmsKampanieRoute
  '/sms/kontakty': typeof AuthSmsKontaktyRoute
  '/sms/szablony': typeof AuthSmsSzablonyRoute
  '/sms/zuzycie': typeof AuthSmsZuzycieRoute
  '/strateg-cenowy/cenniki-centralne': typeof AuthStrategCenowyCennikiCentralneRoute
  '/strateg-cenowy/cenniki-wlasne': typeof AuthStrategCenowyCennikiWlasneRoute
  '/strateg-cenowy/kalkulator-marzy': typeof AuthStrategCenowyKalkulatorMarzyRoute
  '/strateg-cenowy/konfiguracja-top': typeof AuthStrategCenowyKonfiguracjaTopRoute
  '/strateg-cenowy/lider-franczyza': typeof AuthStrategCenowyLiderFranczyzaRoute
  '/strateg-cenowy/modyfikatory': typeof AuthStrategCenowyModyfikatoryRoute
  '/strateg-cenowy/strategie': typeof AuthStrategCenowyStrategieRoute
  '/strateg-cenowy/wykluczenia': typeof AuthStrategCenowyWykluczeniaRoute
  '/strateg-cenowy/wyniki': typeof AuthStrategCenowyWynikiRoute
  '/strateg-cenowy/wyniki-top': typeof AuthStrategCenowyWynikiTopRoute
  '/synchronizacja/konsola-sql': typeof AuthSynchronizacjaKonsolaSqlRoute
  '/synchronizacja/zatwierdzenia-sql': typeof AuthSynchronizacjaZatwierdzeniaSqlRoute
  '/dokumenty': typeof AuthDokumentyIndexRoute
  '/helpdesk': typeof AuthHelpdeskIndexRoute
  '/konfiguracja': typeof AuthKonfiguracjaIndexRoute
  '/kontrakty': typeof AuthKontraktyIndexRoute
  '/sms': typeof AuthSmsIndexRoute
  '/strateg-cenowy': typeof AuthStrategCenowyIndexRoute
  '/dokumenty/hurtownicy/$nip': typeof AuthDokumentyHurtownicyNipRoute
  '/dokumenty/ksef/$invoiceId': typeof AuthDokumentyKsefInvoiceIdRoute
  '/konfiguracja/issue-resolve/$number': typeof AuthKonfiguracjaIssueResolveNumberRoute
  '/konfiguracja/sfy/przeglad': typeof AuthKonfiguracjaSfyPrzegladRoute
  '/kontrakty/apteki-gap/$id': typeof AuthKontraktyAptekiGapIdRoute
  '/kontrakty/apteki-gap/nowy': typeof AuthKontraktyAptekiGapNowyRoute
  '/kontrakty/cenniki-exfactory/$id': typeof AuthKontraktyCennikiExfactoryIdRoute
  '/kontrakty/cenniki-exfactory/nowy': typeof AuthKontraktyCennikiExfactoryNowyRoute
  '/kontrakty/doplaty-gap/$id': typeof AuthKontraktyDoplatyGapIdRoute
  '/kontrakty/doplaty-gap/nowy': typeof AuthKontraktyDoplatyGapNowyRoute
  '/kontrakty/lider-zakupy/$id': typeof AuthKontraktyLiderZakupyIdRoute
  '/kontrakty/lider-zakupy/nowy': typeof AuthKontraktyLiderZakupyNowyRoute
  '/kontrakty/msl-dostepnosc/$id': typeof AuthKontraktyMslDostepnoscIdRoute
  '/kontrakty/msl-dostepnosc/nowy': typeof AuthKontraktyMslDostepnoscNowyRoute
  '/kontrakty/porownanie/$id': typeof AuthKontraktyPorownanieIdRoute
  '/kontrakty/raporty/kontrakt': typeof AuthKontraktyRaportyKontraktRoute
  '/kontrakty/raporty/lider': typeof AuthKontraktyRaportyLiderRoute
  '/kontrakty/raporty/podsumowanie': typeof AuthKontraktyRaportyPodsumowanieRoute
  '/kontrakty/raporty/producent': typeof AuthKontraktyRaportyProducentRoute
  '/kontrakty/rozliczenia-zakup/$id': typeof AuthKontraktyRozliczeniaZakupIdRouteWithChildren
  '/kontrakty/rozliczenia/$id': typeof AuthKontraktyRozliczeniaIdRouteWithChildren
  '/kontrakty/rozliczenia/aktywnosc-aptek': typeof AuthKontraktyRozliczeniaAktywnoscAptekRoute
  '/kontrakty/rozliczenia/prognoza-wsteczna': typeof AuthKontraktyRozliczeniaPrognozaWstecznaRoute
  '/kontrakty/rozliczenia/proporcje-kanalow': typeof AuthKontraktyRozliczeniaProporcjeKanalowRoute
  '/kontrakty/weryfikacja-wysylek/$id': typeof AuthKontraktyWeryfikacjaWysylekIdRoute
  '/kontrakty/weryfikacja-wysylek/klienci': typeof AuthKontraktyWeryfikacjaWysylekKlienciRoute
  '/kontrakty/weryfikacja-wysylek/polaczenia': typeof AuthKontraktyWeryfikacjaWysylekPolaczeniaRoute
  '/raporty/system-premiowy/lider-szczegolowo': typeof AuthRaportySystemPremiowyLiderSzczegolowoRoute
  '/raporty/weryfikacja-sprzedazy/faktura-do-paragonu': typeof AuthRaportyWeryfikacjaSprzedazyFakturaDoParagonuRoute
  '/raporty/weryfikacja-sprzedazy/zmiany': typeof AuthRaportyWeryfikacjaSprzedazyZmianyRoute
  '/rda/lista-ofert-fm1/$offerId': typeof AuthRdaListaOfertFm1OfferIdRoute
  '/receptura/protokoly/$id': typeof AuthRecepturaProtokolyIdRoute
  '/synchronizacja/apteki/$idfirm': typeof AuthSynchronizacjaAptekiIdfirmRoute
  '/konfiguracja/issue-resolve': typeof AuthKonfiguracjaIssueResolveIndexRoute
  '/kontrakty/apteki-gap': typeof AuthKontraktyAptekiGapIndexRoute
  '/kontrakty/cenniki-exfactory': typeof AuthKontraktyCennikiExfactoryIndexRoute
  '/kontrakty/doplaty-gap': typeof AuthKontraktyDoplatyGapIndexRoute
  '/kontrakty/lider-zakupy': typeof AuthKontraktyLiderZakupyIndexRoute
  '/kontrakty/msl-dostepnosc': typeof AuthKontraktyMslDostepnoscIndexRoute
  '/kontrakty/porownanie': typeof AuthKontraktyPorownanieIndexRoute
  '/kontrakty/raporty': typeof AuthKontraktyRaportyIndexRoute
  '/kontrakty/rozliczenia-zakup': typeof AuthKontraktyRozliczeniaZakupIndexRoute
  '/kontrakty/rozliczenia': typeof AuthKontraktyRozliczeniaIndexRoute
  '/kontrakty/weryfikacja-wysylek': typeof AuthKontraktyWeryfikacjaWysylekIndexRoute
  '/raporty/sprz-wybranych-blozow': typeof AuthRaportySprzWybranychBlozowIndexRoute
  '/raporty/weryfikacja-sprzedazy': typeof AuthRaportyWeryfikacjaSprzedazyIndexRoute
  '/synchronizacja/apteki': typeof AuthSynchronizacjaAptekiIndexRoute
  '/kontrakty/rozliczenia-zakup/$id/analiza-dzial-zakupow': typeof AuthKontraktyRozliczeniaZakupIdAnalizaDzialZakupowRoute
  '/kontrakty/rozliczenia-zakup/$id/analiza-per-spolka': typeof AuthKontraktyRozliczeniaZakupIdAnalizaPerSpolkaRoute
  '/kontrakty/rozliczenia/$id/miesiecznie': typeof AuthKontraktyRozliczeniaIdMiesiecznieRoute
  '/kontrakty/rozliczenia/$id/po-spolce': typeof AuthKontraktyRozliczeniaIdPoSpolceRoute
  '/raporty/sprz-wybranych-blozow/parametry/$id': typeof AuthRaportySprzWybranychBlozowParametryIdRoute
  '/raporty/sprz-wybranych-blozow/parametry/nowy': typeof AuthRaportySprzWybranychBlozowParametryNowyRoute
  '/raporty/system-premiowy/lider/$id': typeof AuthRaportySystemPremiowyLiderIdRoute
  '/raporty/system-premiowy/lider/nowy': typeof AuthRaportySystemPremiowyLiderNowyRoute
  '/raporty/system-premiowy/program-partnerski/$id': typeof AuthRaportySystemPremiowyProgramPartnerskiIdRoute
  '/raporty/system-premiowy/program-partnerski/nowy': typeof AuthRaportySystemPremiowyProgramPartnerskiNowyRoute
  '/raporty/system-premiowy/rentownosc/$id': typeof AuthRaportySystemPremiowyRentownoscIdRoute
  '/raporty/system-premiowy/rentownosc/nowa': typeof AuthRaportySystemPremiowyRentownoscNowaRoute
  '/raporty/system-premiowy/struktura/$id': typeof AuthRaportySystemPremiowyStrukturaIdRoute
  '/raporty/system-premiowy/struktura/nowa': typeof AuthRaportySystemPremiowyStrukturaNowaRoute
  '/receptura/protokoly/$id/drukuj': typeof AuthRecepturaProtokolyIdDrukujRoute
  '/receptura/protokoly/$id/etykieta': typeof AuthRecepturaProtokolyIdEtykietaRoute
  '/raporty/sprz-wybranych-blozow/parametry': typeof AuthRaportySprzWybranychBlozowParametryIndexRoute
  '/raporty/system-premiowy/lider': typeof AuthRaportySystemPremiowyLiderIndexRoute
  '/raporty/system-premiowy/program-partnerski': typeof AuthRaportySystemPremiowyProgramPartnerskiIndexRoute
  '/raporty/system-premiowy/rentownosc': typeof AuthRaportySystemPremiowyRentownoscIndexRoute
  '/raporty/system-premiowy/struktura': typeof AuthRaportySystemPremiowyStrukturaIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/403': typeof R403Route
  '/502': typeof R502Route
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-hasla': typeof ResetHaslaRoute
  '/ustaw-haslo': typeof UstawHasloRoute
  '/zgloszenie': typeof ZgloszenieRoute
  '/_auth/strateg-cenowy': typeof AuthStrategCenowyRouteRouteWithChildren
  '/_auth/asystent': typeof AuthAsystentRoute
  '/_auth/asystent-jakosc': typeof AuthAsystentJakoscRoute
  '/_auth/asystent-koszty': typeof AuthAsystentKosztyRoute
  '/_auth/asystent-statystyki-aptek': typeof AuthAsystentStatystykiAptekRoute
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/moj-profil': typeof AuthMojProfilRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/login': typeof AuthLoginRoute
  '/polacz-ai/zgoda': typeof PolaczAiZgodaRoute
  '/publiczne/ksef': typeof PubliczneKsefRoute
  '/_auth/apteneo/porownanie': typeof AuthApteneoPorownanieRoute
  '/_auth/apteneo/rozliczenia': typeof AuthApteneoRozliczeniaRoute
  '/_auth/apteneo/zaczytaj-dane': typeof AuthApteneoZaczytajDaneRoute
  '/_auth/apteneo/zakupy': typeof AuthApteneoZakupyRoute
  '/_auth/dokumenty/hurtownicy': typeof AuthDokumentyHurtownicyRouteWithChildren
  '/_auth/dokumenty/kalendarz-platnosci': typeof AuthDokumentyKalendarzPlatnosciRoute
  '/_auth/dokumenty/ksef': typeof AuthDokumentyKsefRouteWithChildren
  '/_auth/helpdesk/awaria': typeof AuthHelpdeskAwariaRoute
  '/_auth/helpdesk/czat': typeof AuthHelpdeskCzatRoute
  '/_auth/helpdesk/konfiguracja': typeof AuthHelpdeskKonfiguracjaRoute
  '/_auth/helpdesk/szukaj': typeof AuthHelpdeskSzukajRoute
  '/_auth/helpdesk/zarzadzanie': typeof AuthHelpdeskZarzadzanieRoute
  '/_auth/kartoteka/cennik-najtaniej': typeof AuthKartotekaCennikNajtaniejRoute
  '/_auth/kartoteka/cennik-zgodnosc': typeof AuthKartotekaCennikZgodnoscRoute
  '/_auth/kartoteka/cenniki-historia': typeof AuthKartotekaCennikiHistoriaRoute
  '/_auth/kartoteka/cenniki-podglad': typeof AuthKartotekaCennikiPodgladRoute
  '/_auth/kartoteka/grupy-produktow': typeof AuthKartotekaGrupyProduktowRoute
  '/_auth/kartoteka/kategoryzacja': typeof AuthKartotekaKategoryzacjaRoute
  '/_auth/kartoteka/kontrahenci': typeof AuthKartotekaKontrahenciRoute
  '/_auth/kartoteka/mapowanie-apc': typeof AuthKartotekaMapowanieApcRoute
  '/_auth/kartoteka/producenci': typeof AuthKartotekaProducenciRoute
  '/_auth/kartoteka/stan-magazynu': typeof AuthKartotekaStanMagazynuRoute
  '/_auth/kartoteka/towary': typeof AuthKartotekaTowaryRoute
  '/_auth/konfiguracja/ai': typeof AuthKonfiguracjaAiRoute
  '/_auth/konfiguracja/aktualizacje': typeof AuthKonfiguracjaAktualizacjeRoute
  '/_auth/konfiguracja/apteki': typeof AuthKonfiguracjaAptekiRoute
  '/_auth/konfiguracja/audit-log': typeof AuthKonfiguracjaAuditLogRoute
  '/_auth/konfiguracja/drukarki': typeof AuthKonfiguracjaDrukarkiRoute
  '/_auth/konfiguracja/dyski': typeof AuthKonfiguracjaDyskiRoute
  '/_auth/konfiguracja/eksporty-plikowe': typeof AuthKonfiguracjaEksportyPlikoweRoute
  '/_auth/konfiguracja/email': typeof AuthKonfiguracjaEmailRoute
  '/_auth/konfiguracja/email-log': typeof AuthKonfiguracjaEmailLogRoute
  '/_auth/konfiguracja/grupy-aptek': typeof AuthKonfiguracjaGrupyAptekRoute
  '/_auth/konfiguracja/grupy-organizacyjne': typeof AuthKonfiguracjaGrupyOrganizacyjneRoute
  '/_auth/konfiguracja/grupy-uzytkownikow': typeof AuthKonfiguracjaGrupyUzytkownikowRoute
  '/_auth/konfiguracja/harmonogramy-powiadomien': typeof AuthKonfiguracjaHarmonogramyPowiadomienRoute
  '/_auth/konfiguracja/harmonogramy-raportow': typeof AuthKonfiguracjaHarmonogramyRaportowRoute
  '/_auth/konfiguracja/import-mshr': typeof AuthKonfiguracjaImportMshrRoute
  '/_auth/konfiguracja/iqvia': typeof AuthKonfiguracjaIqviaRoute
  '/_auth/konfiguracja/ksef': typeof AuthKonfiguracjaKsefRoute
  '/_auth/konfiguracja/ksef-certyfikaty': typeof AuthKonfiguracjaKsefCertyfikatyRoute
  '/_auth/konfiguracja/ksef-osoz-edi': typeof AuthKonfiguracjaKsefOsozEdiRoute
  '/_auth/konfiguracja/mcp': typeof AuthKonfiguracjaMcpRoute
  '/_auth/konfiguracja/mcp-statystyki': typeof AuthKonfiguracjaMcpStatystykiRoute
  '/_auth/konfiguracja/organizacje': typeof AuthKonfiguracjaOrganizacjeRoute
  '/_auth/konfiguracja/podglad-uzytkownika': typeof AuthKonfiguracjaPodgladUzytkownikaRoute
  '/_auth/konfiguracja/pracownicy': typeof AuthKonfiguracjaPracownicyRoute
  '/_auth/konfiguracja/reguly-zdarzen': typeof AuthKonfiguracjaRegulyZdarzenRoute
  '/_auth/konfiguracja/sfy': typeof AuthKonfiguracjaSfyRoute
  '/_auth/konfiguracja/sms': typeof AuthKonfiguracjaSmsRoute
  '/_auth/konfiguracja/spolki': typeof AuthKonfiguracjaSpolkiRoute
  '/_auth/konfiguracja/sql-konsola': typeof AuthKonfiguracjaSqlKonsolaRoute
  '/_auth/konfiguracja/sql-sfy': typeof AuthKonfiguracjaSqlSfyRoute
  '/_auth/konfiguracja/statystyki-uzycia': typeof AuthKonfiguracjaStatystykiUzyciaRoute
  '/_auth/konfiguracja/system': typeof AuthKonfiguracjaSystemRoute
  '/_auth/konfiguracja/tokeny-api': typeof AuthKonfiguracjaTokenyApiRoute
  '/_auth/konfiguracja/urzadzenia': typeof AuthKonfiguracjaUrzadzeniaRoute
  '/_auth/konfiguracja/uzytkownicy': typeof AuthKonfiguracjaUzytkownicyRoute
  '/_auth/kontrakty/$id': typeof AuthKontraktyIdRoute
  '/_auth/kontrakty/apteki-producentow': typeof AuthKontraktyAptekiProducentowRoute
  '/_auth/kontrakty/apteki-producentow-historia': typeof AuthKontraktyAptekiProducentowHistoriaRoute
  '/_auth/kontrakty/nieaktywne-apteki': typeof AuthKontraktyNieaktywneAptekiRoute
  '/_auth/kontrakty/nowy': typeof AuthKontraktyNowyRoute
  '/_auth/kontrakty/porownanie-z-producentem': typeof AuthKontraktyPorownanieZProducentemRoute
  '/_auth/kontrakty/producenci-dzzf': typeof AuthKontraktyProducenciDzzfRoute
  '/_auth/kontrakty/udzial': typeof AuthKontraktyUdzialRoute
  '/_auth/kontrakty/wykonanie': typeof AuthKontraktyWykonanieRoute
  '/_auth/raporty/analiza-zakupow-nowe-zam': typeof AuthRaportyAnalizaZakupowNoweZamRoute
  '/_auth/raporty/analiza-zakupy-indeksow': typeof AuthRaportyAnalizaZakupyIndeksowRoute
  '/_auth/raporty/dashboard-analityczny': typeof AuthRaportyDashboardAnalitycznyRoute
  '/_auth/raporty/dashboard-magazyn-szczegol': typeof AuthRaportyDashboardMagazynSzczegolRoute
  '/_auth/raporty/daty-waznosci': typeof AuthRaportyDatyWaznosciRoute
  '/_auth/raporty/dynamika-sprzedazy': typeof AuthRaportyDynamikaSprzedazyRoute
  '/_auth/raporty/ecom': typeof AuthRaportyEcomRoute
  '/_auth/raporty/jakosc-danych-wyjatki': typeof AuthRaportyJakoscDanychWyjatkiRoute
  '/_auth/raporty/kategoria-kwartalna': typeof AuthRaportyKategoriaKwartalnaRoute
  '/_auth/raporty/luki-powiazan': typeof AuthRaportyLukiPowiazanRoute
  '/_auth/raporty/odchylenia-cen-fv': typeof AuthRaportyOdchyleniaCenFvRoute
  '/_auth/raporty/raport-produktowy': typeof AuthRaportyRaportProduktowyRoute
  '/_auth/raporty/rozklad-marz': typeof AuthRaportyRozkladMarzRoute
  '/_auth/raporty/sprz-opiekun': typeof AuthRaportySprzOpiekunRoute
  '/_auth/raporty/sprz-wynik': typeof AuthRaportySprzWynikRoute
  '/_auth/raporty/sprz_kasjer_data': typeof AuthRaportySprz_kasjer_dataRoute
  '/_auth/raporty/sprzedaz-dzienna': typeof AuthRaportySprzedazDziennaRoute
  '/_auth/raporty/sprzedaz-zrealizowana': typeof AuthRaportySprzedazZrealizowanaRoute
  '/_auth/raporty/ujemne-marze': typeof AuthRaportyUjemneMarzeRoute
  '/_auth/raporty/weryfikacja-towr': typeof AuthRaportyWeryfikacjaTowrRoute
  '/_auth/raporty/wyprzedaz-magazynu': typeof AuthRaportyWyprzedazMagazynuRoute
  '/_auth/raporty/zmiany-blozu': typeof AuthRaportyZmianyBlozuRoute
  '/_auth/raporty/zwroty-dzienne': typeof AuthRaportyZwrotyDzienneRoute
  '/_auth/raporty/zwroty-kwartalne': typeof AuthRaportyZwrotyKwartalneRoute
  '/_auth/rda/analiza-korzysci': typeof AuthRdaAnalizaKorzysciRoute
  '/_auth/rda/lista-ofert-fm1': typeof AuthRdaListaOfertFm1Route
  '/_auth/receptura/protokoly': typeof AuthRecepturaProtokolyRoute
  '/_auth/receptura/surowce': typeof AuthRecepturaSurowceRoute
  '/_auth/receptura/szablony': typeof AuthRecepturaSzablonyRoute
  '/_auth/sms/kampanie': typeof AuthSmsKampanieRoute
  '/_auth/sms/kontakty': typeof AuthSmsKontaktyRoute
  '/_auth/sms/szablony': typeof AuthSmsSzablonyRoute
  '/_auth/sms/zuzycie': typeof AuthSmsZuzycieRoute
  '/_auth/strateg-cenowy/cenniki-centralne': typeof AuthStrategCenowyCennikiCentralneRoute
  '/_auth/strateg-cenowy/cenniki-wlasne': typeof AuthStrategCenowyCennikiWlasneRoute
  '/_auth/strateg-cenowy/kalkulator-marzy': typeof AuthStrategCenowyKalkulatorMarzyRoute
  '/_auth/strateg-cenowy/konfiguracja-top': typeof AuthStrategCenowyKonfiguracjaTopRoute
  '/_auth/strateg-cenowy/lider-franczyza': typeof AuthStrategCenowyLiderFranczyzaRoute
  '/_auth/strateg-cenowy/modyfikatory': typeof AuthStrategCenowyModyfikatoryRoute
  '/_auth/strateg-cenowy/strategie': typeof AuthStrategCenowyStrategieRoute
  '/_auth/strateg-cenowy/wykluczenia': typeof AuthStrategCenowyWykluczeniaRoute
  '/_auth/strateg-cenowy/wyniki': typeof AuthStrategCenowyWynikiRoute
  '/_auth/strateg-cenowy/wyniki-top': typeof AuthStrategCenowyWynikiTopRoute
  '/_auth/synchronizacja/konsola-sql': typeof AuthSynchronizacjaKonsolaSqlRoute
  '/_auth/synchronizacja/zatwierdzenia-sql': typeof AuthSynchronizacjaZatwierdzeniaSqlRoute
  '/_auth/dokumenty/': typeof AuthDokumentyIndexRoute
  '/_auth/helpdesk/': typeof AuthHelpdeskIndexRoute
  '/_auth/konfiguracja/': typeof AuthKonfiguracjaIndexRoute
  '/_auth/kontrakty/': typeof AuthKontraktyIndexRoute
  '/_auth/sms/': typeof AuthSmsIndexRoute
  '/_auth/strateg-cenowy/': typeof AuthStrategCenowyIndexRoute
  '/_auth/dokumenty/hurtownicy/$nip': typeof AuthDokumentyHurtownicyNipRoute
  '/_auth/dokumenty/ksef/$invoiceId': typeof AuthDokumentyKsefInvoiceIdRoute
  '/_auth/konfiguracja/issue-resolve/$number': typeof AuthKonfiguracjaIssueResolveNumberRoute
  '/_auth/konfiguracja/sfy_/przeglad': typeof AuthKonfiguracjaSfyPrzegladRoute
  '/_auth/kontrakty/apteki-gap/$id': typeof AuthKontraktyAptekiGapIdRoute
  '/_auth/kontrakty/apteki-gap/nowy': typeof AuthKontraktyAptekiGapNowyRoute
  '/_auth/kontrakty/cenniki-exfactory/$id': typeof AuthKontraktyCennikiExfactoryIdRoute
  '/_auth/kontrakty/cenniki-exfactory/nowy': typeof AuthKontraktyCennikiExfactoryNowyRoute
  '/_auth/kontrakty/doplaty-gap/$id': typeof AuthKontraktyDoplatyGapIdRoute
  '/_auth/kontrakty/doplaty-gap/nowy': typeof AuthKontraktyDoplatyGapNowyRoute
  '/_auth/kontrakty/lider-zakupy/$id': typeof AuthKontraktyLiderZakupyIdRoute
  '/_auth/kontrakty/lider-zakupy/nowy': typeof AuthKontraktyLiderZakupyNowyRoute
  '/_auth/kontrakty/msl-dostepnosc/$id': typeof AuthKontraktyMslDostepnoscIdRoute
  '/_auth/kontrakty/msl-dostepnosc/nowy': typeof AuthKontraktyMslDostepnoscNowyRoute
  '/_auth/kontrakty/porownanie/$id': typeof AuthKontraktyPorownanieIdRoute
  '/_auth/kontrakty/raporty/kontrakt': typeof AuthKontraktyRaportyKontraktRoute
  '/_auth/kontrakty/raporty/lider': typeof AuthKontraktyRaportyLiderRoute
  '/_auth/kontrakty/raporty/podsumowanie': typeof AuthKontraktyRaportyPodsumowanieRoute
  '/_auth/kontrakty/raporty/producent': typeof AuthKontraktyRaportyProducentRoute
  '/_auth/kontrakty/rozliczenia-zakup/$id': typeof AuthKontraktyRozliczeniaZakupIdRouteWithChildren
  '/_auth/kontrakty/rozliczenia/$id': typeof AuthKontraktyRozliczeniaIdRouteWithChildren
  '/_auth/kontrakty/rozliczenia/aktywnosc-aptek': typeof AuthKontraktyRozliczeniaAktywnoscAptekRoute
  '/_auth/kontrakty/rozliczenia/prognoza-wsteczna': typeof AuthKontraktyRozliczeniaPrognozaWstecznaRoute
  '/_auth/kontrakty/rozliczenia/proporcje-kanalow': typeof AuthKontraktyRozliczeniaProporcjeKanalowRoute
  '/_auth/kontrakty/weryfikacja-wysylek/$id': typeof AuthKontraktyWeryfikacjaWysylekIdRoute
  '/_auth/kontrakty/weryfikacja-wysylek/klienci': typeof AuthKontraktyWeryfikacjaWysylekKlienciRoute
  '/_auth/kontrakty/weryfikacja-wysylek/polaczenia': typeof AuthKontraktyWeryfikacjaWysylekPolaczeniaRoute
  '/_auth/raporty/system-premiowy/lider-szczegolowo': typeof AuthRaportySystemPremiowyLiderSzczegolowoRoute
  '/_auth/raporty/weryfikacja-sprzedazy/faktura-do-paragonu': typeof AuthRaportyWeryfikacjaSprzedazyFakturaDoParagonuRoute
  '/_auth/raporty/weryfikacja-sprzedazy/zmiany': typeof AuthRaportyWeryfikacjaSprzedazyZmianyRoute
  '/_auth/rda/lista-ofert-fm1_/$offerId': typeof AuthRdaListaOfertFm1OfferIdRoute
  '/_auth/receptura/protokoly_/$id': typeof AuthRecepturaProtokolyIdRoute
  '/_auth/synchronizacja/apteki/$idfirm': typeof AuthSynchronizacjaAptekiIdfirmRoute
  '/_auth/konfiguracja/issue-resolve/': typeof AuthKonfiguracjaIssueResolveIndexRoute
  '/_auth/kontrakty/apteki-gap/': typeof AuthKontraktyAptekiGapIndexRoute
  '/_auth/kontrakty/cenniki-exfactory/': typeof AuthKontraktyCennikiExfactoryIndexRoute
  '/_auth/kontrakty/doplaty-gap/': typeof AuthKontraktyDoplatyGapIndexRoute
  '/_auth/kontrakty/lider-zakupy/': typeof AuthKontraktyLiderZakupyIndexRoute
  '/_auth/kontrakty/msl-dostepnosc/': typeof AuthKontraktyMslDostepnoscIndexRoute
  '/_auth/kontrakty/porownanie/': typeof AuthKontraktyPorownanieIndexRoute
  '/_auth/kontrakty/raporty/': typeof AuthKontraktyRaportyIndexRoute
  '/_auth/kontrakty/rozliczenia-zakup/': typeof AuthKontraktyRozliczeniaZakupIndexRoute
  '/_auth/kontrakty/rozliczenia/': typeof AuthKontraktyRozliczeniaIndexRoute
  '/_auth/kontrakty/weryfikacja-wysylek/': typeof AuthKontraktyWeryfikacjaWysylekIndexRoute
  '/_auth/raporty/sprz-wybranych-blozow/': typeof AuthRaportySprzWybranychBlozowIndexRoute
  '/_auth/raporty/weryfikacja-sprzedazy/': typeof AuthRaportyWeryfikacjaSprzedazyIndexRoute
  '/_auth/synchronizacja/apteki/': typeof AuthSynchronizacjaAptekiIndexRoute
  '/_auth/kontrakty/rozliczenia-zakup/$id/analiza-dzial-zakupow': typeof AuthKontraktyRozliczeniaZakupIdAnalizaDzialZakupowRoute
  '/_auth/kontrakty/rozliczenia-zakup/$id/analiza-per-spolka': typeof AuthKontraktyRozliczeniaZakupIdAnalizaPerSpolkaRoute
  '/_auth/kontrakty/rozliczenia/$id/miesiecznie': typeof AuthKontraktyRozliczeniaIdMiesiecznieRoute
  '/_auth/kontrakty/rozliczenia/$id/po-spolce': typeof AuthKontraktyRozliczeniaIdPoSpolceRoute
  '/_auth/raporty/sprz-wybranych-blozow/parametry/$id': typeof AuthRaportySprzWybranychBlozowParametryIdRoute
  '/_auth/raporty/sprz-wybranych-blozow/parametry/nowy': typeof AuthRaportySprzWybranychBlozowParametryNowyRoute
  '/_auth/raporty/system-premiowy/lider/$id': typeof AuthRaportySystemPremiowyLiderIdRoute
  '/_auth/raporty/system-premiowy/lider/nowy': typeof AuthRaportySystemPremiowyLiderNowyRoute
  '/_auth/raporty/system-premiowy/program-partnerski/$id': typeof AuthRaportySystemPremiowyProgramPartnerskiIdRoute
  '/_auth/raporty/system-premiowy/program-partnerski/nowy': typeof AuthRaportySystemPremiowyProgramPartnerskiNowyRoute
  '/_auth/raporty/system-premiowy/rentownosc/$id': typeof AuthRaportySystemPremiowyRentownoscIdRoute
  '/_auth/raporty/system-premiowy/rentownosc/nowa': typeof AuthRaportySystemPremiowyRentownoscNowaRoute
  '/_auth/raporty/system-premiowy/struktura/$id': typeof AuthRaportySystemPremiowyStrukturaIdRoute
  '/_auth/raporty/system-premiowy/struktura/nowa': typeof AuthRaportySystemPremiowyStrukturaNowaRoute
  '/_auth/receptura/protokoly_/$id_/drukuj': typeof AuthRecepturaProtokolyIdDrukujRoute
  '/_auth/receptura/protokoly_/$id_/etykieta': typeof AuthRecepturaProtokolyIdEtykietaRoute
  '/_auth/raporty/sprz-wybranych-blozow/parametry/': typeof AuthRaportySprzWybranychBlozowParametryIndexRoute
  '/_auth/raporty/system-premiowy/lider/': typeof AuthRaportySystemPremiowyLiderIndexRoute
  '/_auth/raporty/system-premiowy/program-partnerski/': typeof AuthRaportySystemPremiowyProgramPartnerskiIndexRoute
  '/_auth/raporty/system-premiowy/rentownosc/': typeof AuthRaportySystemPremiowyRentownoscIndexRoute
  '/_auth/raporty/system-premiowy/struktura/': typeof AuthRaportySystemPremiowyStrukturaIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/403'
    | '/502'
    | '/login'
    | '/reset-hasla'
    | '/ustaw-haslo'
    | '/zgloszenie'
    | '/strateg-cenowy'
    | '/asystent'
    | '/asystent-jakosc'
    | '/asystent-koszty'
    | '/asystent-statystyki-aptek'
    | '/dashboard'
    | '/moj-profil'
    | '/auth/callback'
    | '/auth/login'
    | '/polacz-ai/zgoda'
    | '/publiczne/ksef'
    | '/apteneo/porownanie'
    | '/apteneo/rozliczenia'
    | '/apteneo/zaczytaj-dane'
    | '/apteneo/zakupy'
    | '/dokumenty/hurtownicy'
    | '/dokumenty/kalendarz-platnosci'
    | '/dokumenty/ksef'
    | '/helpdesk/awaria'
    | '/helpdesk/czat'
    | '/helpdesk/konfiguracja'
    | '/helpdesk/szukaj'
    | '/helpdesk/zarzadzanie'
    | '/kartoteka/cennik-najtaniej'
    | '/kartoteka/cennik-zgodnosc'
    | '/kartoteka/cenniki-historia'
    | '/kartoteka/cenniki-podglad'
    | '/kartoteka/grupy-produktow'
    | '/kartoteka/kategoryzacja'
    | '/kartoteka/kontrahenci'
    | '/kartoteka/mapowanie-apc'
    | '/kartoteka/producenci'
    | '/kartoteka/stan-magazynu'
    | '/kartoteka/towary'
    | '/konfiguracja/ai'
    | '/konfiguracja/aktualizacje'
    | '/konfiguracja/apteki'
    | '/konfiguracja/audit-log'
    | '/konfiguracja/drukarki'
    | '/konfiguracja/dyski'
    | '/konfiguracja/eksporty-plikowe'
    | '/konfiguracja/email'
    | '/konfiguracja/email-log'
    | '/konfiguracja/grupy-aptek'
    | '/konfiguracja/grupy-organizacyjne'
    | '/konfiguracja/grupy-uzytkownikow'
    | '/konfiguracja/harmonogramy-powiadomien'
    | '/konfiguracja/harmonogramy-raportow'
    | '/konfiguracja/import-mshr'
    | '/konfiguracja/iqvia'
    | '/konfiguracja/ksef'
    | '/konfiguracja/ksef-certyfikaty'
    | '/konfiguracja/ksef-osoz-edi'
    | '/konfiguracja/mcp'
    | '/konfiguracja/mcp-statystyki'
    | '/konfiguracja/organizacje'
    | '/konfiguracja/podglad-uzytkownika'
    | '/konfiguracja/pracownicy'
    | '/konfiguracja/reguly-zdarzen'
    | '/konfiguracja/sfy'
    | '/konfiguracja/sms'
    | '/konfiguracja/spolki'
    | '/konfiguracja/sql-konsola'
    | '/konfiguracja/sql-sfy'
    | '/konfiguracja/statystyki-uzycia'
    | '/konfiguracja/system'
    | '/konfiguracja/tokeny-api'
    | '/konfiguracja/urzadzenia'
    | '/konfiguracja/uzytkownicy'
    | '/kontrakty/$id'
    | '/kontrakty/apteki-producentow'
    | '/kontrakty/apteki-producentow-historia'
    | '/kontrakty/nieaktywne-apteki'
    | '/kontrakty/nowy'
    | '/kontrakty/porownanie-z-producentem'
    | '/kontrakty/producenci-dzzf'
    | '/kontrakty/udzial'
    | '/kontrakty/wykonanie'
    | '/raporty/analiza-zakupow-nowe-zam'
    | '/raporty/analiza-zakupy-indeksow'
    | '/raporty/dashboard-analityczny'
    | '/raporty/dashboard-magazyn-szczegol'
    | '/raporty/daty-waznosci'
    | '/raporty/dynamika-sprzedazy'
    | '/raporty/ecom'
    | '/raporty/jakosc-danych-wyjatki'
    | '/raporty/kategoria-kwartalna'
    | '/raporty/luki-powiazan'
    | '/raporty/odchylenia-cen-fv'
    | '/raporty/raport-produktowy'
    | '/raporty/rozklad-marz'
    | '/raporty/sprz-opiekun'
    | '/raporty/sprz-wynik'
    | '/raporty/sprz_kasjer_data'
    | '/raporty/sprzedaz-dzienna'
    | '/raporty/sprzedaz-zrealizowana'
    | '/raporty/ujemne-marze'
    | '/raporty/weryfikacja-towr'
    | '/raporty/wyprzedaz-magazynu'
    | '/raporty/zmiany-blozu'
    | '/raporty/zwroty-dzienne'
    | '/raporty/zwroty-kwartalne'
    | '/rda/analiza-korzysci'
    | '/rda/lista-ofert-fm1'
    | '/receptura/protokoly'
    | '/receptura/surowce'
    | '/receptura/szablony'
    | '/sms/kampanie'
    | '/sms/kontakty'
    | '/sms/szablony'
    | '/sms/zuzycie'
    | '/strateg-cenowy/cenniki-centralne'
    | '/strateg-cenowy/cenniki-wlasne'
    | '/strateg-cenowy/kalkulator-marzy'
    | '/strateg-cenowy/konfiguracja-top'
    | '/strateg-cenowy/lider-franczyza'
    | '/strateg-cenowy/modyfikatory'
    | '/strateg-cenowy/strategie'
    | '/strateg-cenowy/wykluczenia'
    | '/strateg-cenowy/wyniki'
    | '/strateg-cenowy/wyniki-top'
    | '/synchronizacja/konsola-sql'
    | '/synchronizacja/zatwierdzenia-sql'
    | '/dokumenty/'
    | '/helpdesk/'
    | '/konfiguracja/'
    | '/kontrakty/'
    | '/sms/'
    | '/strateg-cenowy/'
    | '/dokumenty/hurtownicy/$nip'
    | '/dokumenty/ksef/$invoiceId'
    | '/konfiguracja/issue-resolve/$number'
    | '/konfiguracja/sfy/przeglad'
    | '/kontrakty/apteki-gap/$id'
    | '/kontrakty/apteki-gap/nowy'
    | '/kontrakty/cenniki-exfactory/$id'
    | '/kontrakty/cenniki-exfactory/nowy'
    | '/kontrakty/doplaty-gap/$id'
    | '/kontrakty/doplaty-gap/nowy'
    | '/kontrakty/lider-zakupy/$id'
    | '/kontrakty/lider-zakupy/nowy'
    | '/kontrakty/msl-dostepnosc/$id'
    | '/kontrakty/msl-dostepnosc/nowy'
    | '/kontrakty/porownanie/$id'
    | '/kontrakty/raporty/kontrakt'
    | '/kontrakty/raporty/lider'
    | '/kontrakty/raporty/podsumowanie'
    | '/kontrakty/raporty/producent'
    | '/kontrakty/rozliczenia-zakup/$id'
    | '/kontrakty/rozliczenia/$id'
    | '/kontrakty/rozliczenia/aktywnosc-aptek'
    | '/kontrakty/rozliczenia/prognoza-wsteczna'
    | '/kontrakty/rozliczenia/proporcje-kanalow'
    | '/kontrakty/weryfikacja-wysylek/$id'
    | '/kontrakty/weryfikacja-wysylek/klienci'
    | '/kontrakty/weryfikacja-wysylek/polaczenia'
    | '/raporty/system-premiowy/lider-szczegolowo'
    | '/raporty/weryfikacja-sprzedazy/faktura-do-paragonu'
    | '/raporty/weryfikacja-sprzedazy/zmiany'
    | '/rda/lista-ofert-fm1/$offerId'
    | '/receptura/protokoly/$id'
    | '/synchronizacja/apteki/$idfirm'
    | '/konfiguracja/issue-resolve/'
    | '/kontrakty/apteki-gap/'
    | '/kontrakty/cenniki-exfactory/'
    | '/kontrakty/doplaty-gap/'
    | '/kontrakty/lider-zakupy/'
    | '/kontrakty/msl-dostepnosc/'
    | '/kontrakty/porownanie/'
    | '/kontrakty/raporty/'
    | '/kontrakty/rozliczenia-zakup/'
    | '/kontrakty/rozliczenia/'
    | '/kontrakty/weryfikacja-wysylek/'
    | '/raporty/sprz-wybranych-blozow/'
    | '/raporty/weryfikacja-sprzedazy/'
    | '/synchronizacja/apteki/'
    | '/kontrakty/rozliczenia-zakup/$id/analiza-dzial-zakupow'
    | '/kontrakty/rozliczenia-zakup/$id/analiza-per-spolka'
    | '/kontrakty/rozliczenia/$id/miesiecznie'
    | '/kontrakty/rozliczenia/$id/po-spolce'
    | '/raporty/sprz-wybranych-blozow/parametry/$id'
    | '/raporty/sprz-wybranych-blozow/parametry/nowy'
    | '/raporty/system-premiowy/lider/$id'
    | '/raporty/system-premiowy/lider/nowy'
    | '/raporty/system-premiowy/program-partnerski/$id'
    | '/raporty/system-premiowy/program-partnerski/nowy'
    | '/raporty/system-premiowy/rentownosc/$id'
    | '/raporty/system-premiowy/rentownosc/nowa'
    | '/raporty/system-premiowy/struktura/$id'
    | '/raporty/system-premiowy/struktura/nowa'
    | '/receptura/protokoly/$id/drukuj'
    | '/receptura/protokoly/$id/etykieta'
    | '/raporty/sprz-wybranych-blozow/parametry/'
    | '/raporty/system-premiowy/lider/'
    | '/raporty/system-premiowy/program-partnerski/'
    | '/raporty/system-premiowy/rentownosc/'
    | '/raporty/system-premiowy/struktura/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/403'
    | '/502'
    | '/login'
    | '/reset-hasla'
    | '/ustaw-haslo'
    | '/zgloszenie'
    | '/asystent'
    | '/asystent-jakosc'
    | '/asystent-koszty'
    | '/asystent-statystyki-aptek'
    | '/dashboard'
    | '/moj-profil'
    | '/auth/callback'
    | '/auth/login'
    | '/polacz-ai/zgoda'
    | '/publiczne/ksef'
    | '/apteneo/porownanie'
    | '/apteneo/rozliczenia'
    | '/apteneo/zaczytaj-dane'
    | '/apteneo/zakupy'
    | '/dokumenty/hurtownicy'
    | '/dokumenty/kalendarz-platnosci'
    | '/dokumenty/ksef'
    | '/helpdesk/awaria'
    | '/helpdesk/czat'
    | '/helpdesk/konfiguracja'
    | '/helpdesk/szukaj'
    | '/helpdesk/zarzadzanie'
    | '/kartoteka/cennik-najtaniej'
    | '/kartoteka/cennik-zgodnosc'
    | '/kartoteka/cenniki-historia'
    | '/kartoteka/cenniki-podglad'
    | '/kartoteka/grupy-produktow'
    | '/kartoteka/kategoryzacja'
    | '/kartoteka/kontrahenci'
    | '/kartoteka/mapowanie-apc'
    | '/kartoteka/producenci'
    | '/kartoteka/stan-magazynu'
    | '/kartoteka/towary'
    | '/konfiguracja/ai'
    | '/konfiguracja/aktualizacje'
    | '/konfiguracja/apteki'
    | '/konfiguracja/audit-log'
    | '/konfiguracja/drukarki'
    | '/konfiguracja/dyski'
    | '/konfiguracja/eksporty-plikowe'
    | '/konfiguracja/email'
    | '/konfiguracja/email-log'
    | '/konfiguracja/grupy-aptek'
    | '/konfiguracja/grupy-organizacyjne'
    | '/konfiguracja/grupy-uzytkownikow'
    | '/konfiguracja/harmonogramy-powiadomien'
    | '/konfiguracja/harmonogramy-raportow'
    | '/konfiguracja/import-mshr'
    | '/konfiguracja/iqvia'
    | '/konfiguracja/ksef'
    | '/konfiguracja/ksef-certyfikaty'
    | '/konfiguracja/ksef-osoz-edi'
    | '/konfiguracja/mcp'
    | '/konfiguracja/mcp-statystyki'
    | '/konfiguracja/organizacje'
    | '/konfiguracja/podglad-uzytkownika'
    | '/konfiguracja/pracownicy'
    | '/konfiguracja/reguly-zdarzen'
    | '/konfiguracja/sfy'
    | '/konfiguracja/sms'
    | '/konfiguracja/spolki'
    | '/konfiguracja/sql-konsola'
    | '/konfiguracja/sql-sfy'
    | '/konfiguracja/statystyki-uzycia'
    | '/konfiguracja/system'
    | '/konfiguracja/tokeny-api'
    | '/konfiguracja/urzadzenia'
    | '/konfiguracja/uzytkownicy'
    | '/kontrakty/$id'
    | '/kontrakty/apteki-producentow'
    | '/kontrakty/apteki-producentow-historia'
    | '/kontrakty/nieaktywne-apteki'
    | '/kontrakty/nowy'
    | '/kontrakty/porownanie-z-producentem'
    | '/kontrakty/producenci-dzzf'
    | '/kontrakty/udzial'
    | '/kontrakty/wykonanie'
    | '/raporty/analiza-zakupow-nowe-zam'
    | '/raporty/analiza-zakupy-indeksow'
    | '/raporty/dashboard-analityczny'
    | '/raporty/dashboard-magazyn-szczegol'
    | '/raporty/daty-waznosci'
    | '/raporty/dynamika-sprzedazy'
    | '/raporty/ecom'
    | '/raporty/jakosc-danych-wyjatki'
    | '/raporty/kategoria-kwartalna'
    | '/raporty/luki-powiazan'
    | '/raporty/odchylenia-cen-fv'
    | '/raporty/raport-produktowy'
    | '/raporty/rozklad-marz'
    | '/raporty/sprz-opiekun'
    | '/raporty/sprz-wynik'
    | '/raporty/sprz_kasjer_data'
    | '/raporty/sprzedaz-dzienna'
    | '/raporty/sprzedaz-zrealizowana'
    | '/raporty/ujemne-marze'
    | '/raporty/weryfikacja-towr'
    | '/raporty/wyprzedaz-magazynu'
    | '/raporty/zmiany-blozu'
    | '/raporty/zwroty-dzienne'
    | '/raporty/zwroty-kwartalne'
    | '/rda/analiza-korzysci'
    | '/rda/lista-ofert-fm1'
    | '/receptura/protokoly'
    | '/receptura/surowce'
    | '/receptura/szablony'
    | '/sms/kampanie'
    | '/sms/kontakty'
    | '/sms/szablony'
    | '/sms/zuzycie'
    | '/strateg-cenowy/cenniki-centralne'
    | '/strateg-cenowy/cenniki-wlasne'
    | '/strateg-cenowy/kalkulator-marzy'
    | '/strateg-cenowy/konfiguracja-top'
    | '/strateg-cenowy/lider-franczyza'
    | '/strateg-cenowy/modyfikatory'
    | '/strateg-cenowy/strategie'
    | '/strateg-cenowy/wykluczenia'
    | '/strateg-cenowy/wyniki'
    | '/strateg-cenowy/wyniki-top'
    | '/synchronizacja/konsola-sql'
    | '/synchronizacja/zatwierdzenia-sql'
    | '/dokumenty'
    | '/helpdesk'
    | '/konfiguracja'
    | '/kontrakty'
    | '/sms'
    | '/strateg-cenowy'
    | '/dokumenty/hurtownicy/$nip'
    | '/dokumenty/ksef/$invoiceId'
    | '/konfiguracja/issue-resolve/$number'
    | '/konfiguracja/sfy/przeglad'
    | '/kontrakty/apteki-gap/$id'
    | '/kontrakty/apteki-gap/nowy'
    | '/kontrakty/cenniki-exfactory/$id'
    | '/kontrakty/cenniki-exfactory/nowy'
    | '/kontrakty/doplaty-gap/$id'
    | '/kontrakty/doplaty-gap/nowy'
    | '/kontrakty/lider-zakupy/$id'
    | '/kontrakty/lider-zakupy/nowy'
    | '/kontrakty/msl-dostepnosc/$id'
    | '/kontrakty/msl-dostepnosc/nowy'
    | '/kontrakty/porownanie/$id'
    | '/kontrakty/raporty/kontrakt'
    | '/kontrakty/raporty/lider'
    | '/kontrakty/raporty/podsumowanie'
    | '/kontrakty/raporty/producent'
    | '/kontrakty/rozliczenia-zakup/$id'
    | '/kontrakty/rozliczenia/$id'
    | '/kontrakty/rozliczenia/aktywnosc-aptek'
    | '/kontrakty/rozliczenia/prognoza-wsteczna'
    | '/kontrakty/rozliczenia/proporcje-kanalow'
    | '/kontrakty/weryfikacja-wysylek/$id'
    | '/kontrakty/weryfikacja-wysylek/klienci'
    | '/kontrakty/weryfikacja-wysylek/polaczenia'
    | '/raporty/system-premiowy/lider-szczegolowo'
    | '/raporty/weryfikacja-sprzedazy/faktura-do-paragonu'
    | '/raporty/weryfikacja-sprzedazy/zmiany'
    | '/rda/lista-ofert-fm1/$offerId'
    | '/receptura/protokoly/$id'
    | '/synchronizacja/apteki/$idfirm'
    | '/konfiguracja/issue-resolve'
    | '/kontrakty/apteki-gap'
    | '/kontrakty/cenniki-exfactory'
    | '/kontrakty/doplaty-gap'
    | '/kontrakty/lider-zakupy'
    | '/kontrakty/msl-dostepnosc'
    | '/kontrakty/porownanie'
    | '/kontrakty/raporty'
    | '/kontrakty/rozliczenia-zakup'
    | '/kontrakty/rozliczenia'
    | '/kontrakty/weryfikacja-wysylek'
    | '/raporty/sprz-wybranych-blozow'
    | '/raporty/weryfikacja-sprzedazy'
    | '/synchronizacja/apteki'
    | '/kontrakty/rozliczenia-zakup/$id/analiza-dzial-zakupow'
    | '/kontrakty/rozliczenia-zakup/$id/analiza-per-spolka'
    | '/kontrakty/rozliczenia/$id/miesiecznie'
    | '/kontrakty/rozliczenia/$id/po-spolce'
    | '/raporty/sprz-wybranych-blozow/parametry/$id'
    | '/raporty/sprz-wybranych-blozow/parametry/nowy'
    | '/raporty/system-premiowy/lider/$id'
    | '/raporty/system-premiowy/lider/nowy'
    | '/raporty/system-premiowy/program-partnerski/$id'
    | '/raporty/system-premiowy/program-partnerski/nowy'
    | '/raporty/system-premiowy/rentownosc/$id'
    | '/raporty/system-premiowy/rentownosc/nowa'
    | '/raporty/system-premiowy/struktura/$id'
    | '/raporty/system-premiowy/struktura/nowa'
    | '/receptura/protokoly/$id/drukuj'
    | '/receptura/protokoly/$id/etykieta'
    | '/raporty/sprz-wybranych-blozow/parametry'
    | '/raporty/system-premiowy/lider'
    | '/raporty/system-premiowy/program-partnerski'
    | '/raporty/system-premiowy/rentownosc'
    | '/raporty/system-premiowy/struktura'
  id:
    | '__root__'
    | '/'
    | '/403'
    | '/502'
    | '/_auth'
    | '/login'
    | '/reset-hasla'
    | '/ustaw-haslo'
    | '/zgloszenie'
    | '/_auth/strateg-cenowy'
    | '/_auth/asystent'
    | '/_auth/asystent-jakosc'
    | '/_auth/asystent-koszty'
    | '/_auth/asystent-statystyki-aptek'
    | '/_auth/dashboard'
    | '/_auth/moj-profil'
    | '/auth/callback'
    | '/auth/login'
    | '/polacz-ai/zgoda'
    | '/publiczne/ksef'
    | '/_auth/apteneo/porownanie'
    | '/_auth/apteneo/rozliczenia'
    | '/_auth/apteneo/zaczytaj-dane'
    | '/_auth/apteneo/zakupy'
    | '/_auth/dokumenty/hurtownicy'
    | '/_auth/dokumenty/kalendarz-platnosci'
    | '/_auth/dokumenty/ksef'
    | '/_auth/helpdesk/awaria'
    | '/_auth/helpdesk/czat'
    | '/_auth/helpdesk/konfiguracja'
    | '/_auth/helpdesk/szukaj'
    | '/_auth/helpdesk/zarzadzanie'
    | '/_auth/kartoteka/cennik-najtaniej'
    | '/_auth/kartoteka/cennik-zgodnosc'
    | '/_auth/kartoteka/cenniki-historia'
    | '/_auth/kartoteka/cenniki-podglad'
    | '/_auth/kartoteka/grupy-produktow'
    | '/_auth/kartoteka/kategoryzacja'
    | '/_auth/kartoteka/kontrahenci'
    | '/_auth/kartoteka/mapowanie-apc'
    | '/_auth/kartoteka/producenci'
    | '/_auth/kartoteka/stan-magazynu'
    | '/_auth/kartoteka/towary'
    | '/_auth/konfiguracja/ai'
    | '/_auth/konfiguracja/aktualizacje'
    | '/_auth/konfiguracja/apteki'
    | '/_auth/konfiguracja/audit-log'
    | '/_auth/konfiguracja/drukarki'
    | '/_auth/konfiguracja/dyski'
    | '/_auth/konfiguracja/eksporty-plikowe'
    | '/_auth/konfiguracja/email'
    | '/_auth/konfiguracja/email-log'
    | '/_auth/konfiguracja/grupy-aptek'
    | '/_auth/konfiguracja/grupy-organizacyjne'
    | '/_auth/konfiguracja/grupy-uzytkownikow'
    | '/_auth/konfiguracja/harmonogramy-powiadomien'
    | '/_auth/konfiguracja/harmonogramy-raportow'
    | '/_auth/konfiguracja/import-mshr'
    | '/_auth/konfiguracja/iqvia'
    | '/_auth/konfiguracja/ksef'
    | '/_auth/konfiguracja/ksef-certyfikaty'
    | '/_auth/konfiguracja/ksef-osoz-edi'
    | '/_auth/konfiguracja/mcp'
    | '/_auth/konfiguracja/mcp-statystyki'
    | '/_auth/konfiguracja/organizacje'
    | '/_auth/konfiguracja/podglad-uzytkownika'
    | '/_auth/konfiguracja/pracownicy'
    | '/_auth/konfiguracja/reguly-zdarzen'
    | '/_auth/konfiguracja/sfy'
    | '/_auth/konfiguracja/sms'
    | '/_auth/konfiguracja/spolki'
    | '/_auth/konfiguracja/sql-konsola'
    | '/_auth/konfiguracja/sql-sfy'
    | '/_auth/konfiguracja/statystyki-uzycia'
    | '/_auth/konfiguracja/system'
    | '/_auth/konfiguracja/tokeny-api'
    | '/_auth/konfiguracja/urzadzenia'
    | '/_auth/konfiguracja/uzytkownicy'
    | '/_auth/kontrakty/$id'
    | '/_auth/kontrakty/apteki-producentow'
    | '/_auth/kontrakty/apteki-producentow-historia'
    | '/_auth/kontrakty/nieaktywne-apteki'
    | '/_auth/kontrakty/nowy'
    | '/_auth/kontrakty/porownanie-z-producentem'
    | '/_auth/kontrakty/producenci-dzzf'
    | '/_auth/kontrakty/udzial'
    | '/_auth/kontrakty/wykonanie'
    | '/_auth/raporty/analiza-zakupow-nowe-zam'
    | '/_auth/raporty/analiza-zakupy-indeksow'
    | '/_auth/raporty/dashboard-analityczny'
    | '/_auth/raporty/dashboard-magazyn-szczegol'
    | '/_auth/raporty/daty-waznosci'
    | '/_auth/raporty/dynamika-sprzedazy'
    | '/_auth/raporty/ecom'
    | '/_auth/raporty/jakosc-danych-wyjatki'
    | '/_auth/raporty/kategoria-kwartalna'
    | '/_auth/raporty/luki-powiazan'
    | '/_auth/raporty/odchylenia-cen-fv'
    | '/_auth/raporty/raport-produktowy'
    | '/_auth/raporty/rozklad-marz'
    | '/_auth/raporty/sprz-opiekun'
    | '/_auth/raporty/sprz-wynik'
    | '/_auth/raporty/sprz_kasjer_data'
    | '/_auth/raporty/sprzedaz-dzienna'
    | '/_auth/raporty/sprzedaz-zrealizowana'
    | '/_auth/raporty/ujemne-marze'
    | '/_auth/raporty/weryfikacja-towr'
    | '/_auth/raporty/wyprzedaz-magazynu'
    | '/_auth/raporty/zmiany-blozu'
    | '/_auth/raporty/zwroty-dzienne'
    | '/_auth/raporty/zwroty-kwartalne'
    | '/_auth/rda/analiza-korzysci'
    | '/_auth/rda/lista-ofert-fm1'
    | '/_auth/receptura/protokoly'
    | '/_auth/receptura/surowce'
    | '/_auth/receptura/szablony'
    | '/_auth/sms/kampanie'
    | '/_auth/sms/kontakty'
    | '/_auth/sms/szablony'
    | '/_auth/sms/zuzycie'
    | '/_auth/strateg-cenowy/cenniki-centralne'
    | '/_auth/strateg-cenowy/cenniki-wlasne'
    | '/_auth/strateg-cenowy/kalkulator-marzy'
    | '/_auth/strateg-cenowy/konfiguracja-top'
    | '/_auth/strateg-cenowy/lider-franczyza'
    | '/_auth/strateg-cenowy/modyfikatory'
    | '/_auth/strateg-cenowy/strategie'
    | '/_auth/strateg-cenowy/wykluczenia'
    | '/_auth/strateg-cenowy/wyniki'
    | '/_auth/strateg-cenowy/wyniki-top'
    | '/_auth/synchronizacja/konsola-sql'
    | '/_auth/synchronizacja/zatwierdzenia-sql'
    | '/_auth/dokumenty/'
    | '/_auth/helpdesk/'
    | '/_auth/konfiguracja/'
    | '/_auth/kontrakty/'
    | '/_auth/sms/'
    | '/_auth/strateg-cenowy/'
    | '/_auth/dokumenty/hurtownicy/$nip'
    | '/_auth/dokumenty/ksef/$invoiceId'
    | '/_auth/konfiguracja/issue-resolve/$number'
    | '/_auth/konfiguracja/sfy_/przeglad'
    | '/_auth/kontrakty/apteki-gap/$id'
    | '/_auth/kontrakty/apteki-gap/nowy'
    | '/_auth/kontrakty/cenniki-exfactory/$id'
    | '/_auth/kontrakty/cenniki-exfactory/nowy'
    | '/_auth/kontrakty/doplaty-gap/$id'
    | '/_auth/kontrakty/doplaty-gap/nowy'
    | '/_auth/kontrakty/lider-zakupy/$id'
    | '/_auth/kontrakty/lider-zakupy/nowy'
    | '/_auth/kontrakty/msl-dostepnosc/$id'
    | '/_auth/kontrakty/msl-dostepnosc/nowy'
    | '/_auth/kontrakty/porownanie/$id'
    | '/_auth/kontrakty/raporty/kontrakt'
    | '/_auth/kontrakty/raporty/lider'
    | '/_auth/kontrakty/raporty/podsumowanie'
    | '/_auth/kontrakty/raporty/producent'
    | '/_auth/kontrakty/rozliczenia-zakup/$id'
    | '/_auth/kontrakty/rozliczenia/$id'
    | '/_auth/kontrakty/rozliczenia/aktywnosc-aptek'
    | '/_auth/kontrakty/rozliczenia/prognoza-wsteczna'
    | '/_auth/kontrakty/rozliczenia/proporcje-kanalow'
    | '/_auth/kontrakty/weryfikacja-wysylek/$id'
    | '/_auth/kontrakty/weryfikacja-wysylek/klienci'
    | '/_auth/kontrakty/weryfikacja-wysylek/polaczenia'
    | '/_auth/raporty/system-premiowy/lider-szczegolowo'
    | '/_auth/raporty/weryfikacja-sprzedazy/faktura-do-paragonu'
    | '/_auth/raporty/weryfikacja-sprzedazy/zmiany'
    | '/_auth/rda/lista-ofert-fm1_/$offerId'
    | '/_auth/receptura/protokoly_/$id'
    | '/_auth/synchronizacja/apteki/$idfirm'
    | '/_auth/konfiguracja/issue-resolve/'
    | '/_auth/kontrakty/apteki-gap/'
    | '/_auth/kontrakty/cenniki-exfactory/'
    | '/_auth/kontrakty/doplaty-gap/'
    | '/_auth/kontrakty/lider-zakupy/'
    | '/_auth/kontrakty/msl-dostepnosc/'
    | '/_auth/kontrakty/porownanie/'
    | '/_auth/kontrakty/raporty/'
    | '/_auth/kontrakty/rozliczenia-zakup/'
    | '/_auth/kontrakty/rozliczenia/'
    | '/_auth/kontrakty/weryfikacja-wysylek/'
    | '/_auth/raporty/sprz-wybranych-blozow/'
    | '/_auth/raporty/weryfikacja-sprzedazy/'
    | '/_auth/synchronizacja/apteki/'
    | '/_auth/kontrakty/rozliczenia-zakup/$id/analiza-dzial-zakupow'
    | '/_auth/kontrakty/rozliczenia-zakup/$id/analiza-per-spolka'
    | '/_auth/kontrakty/rozliczenia/$id/miesiecznie'
    | '/_auth/kontrakty/rozliczenia/$id/po-spolce'
    | '/_auth/raporty/sprz-wybranych-blozow/parametry/$id'
    | '/_auth/raporty/sprz-wybranych-blozow/parametry/nowy'
    | '/_auth/raporty/system-premiowy/lider/$id'
    | '/_auth/raporty/system-premiowy/lider/nowy'
    | '/_auth/raporty/system-premiowy/program-partnerski/$id'
    | '/_auth/raporty/system-premiowy/program-partnerski/nowy'
    | '/_auth/raporty/system-premiowy/rentownosc/$id'
    | '/_auth/raporty/system-premiowy/rentownosc/nowa'
    | '/_auth/raporty/system-premiowy/struktura/$id'
    | '/_auth/raporty/system-premiowy/struktura/nowa'
    | '/_auth/receptura/protokoly_/$id_/drukuj'
    | '/_auth/receptura/protokoly_/$id_/etykieta'
    | '/_auth/raporty/sprz-wybranych-blozow/parametry/'
    | '/_auth/raporty/system-premiowy/lider/'
    | '/_auth/raporty/system-premiowy/program-partnerski/'
    | '/_auth/raporty/system-premiowy/rentownosc/'
    | '/_auth/raporty/system-premiowy/struktura/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R403Route: typeof R403Route
  R502Route: typeof R502Route
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  ResetHaslaRoute: typeof ResetHaslaRoute
  UstawHasloRoute: typeof UstawHasloRoute
  ZgloszenieRoute: typeof ZgloszenieRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthLoginRoute: typeof AuthLoginRoute
  PolaczAiZgodaRoute: typeof PolaczAiZgodaRoute
  PubliczneKsefRoute: typeof PubliczneKsefRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/403': {
      id: '/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof R403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/502': {
      id: '/502'
      path: '/502'
      fullPath: '/502'
      preLoaderRoute: typeof R502RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-hasla': {
      id: '/reset-hasla'
      path: '/reset-hasla'
      fullPath: '/reset-hasla'
      preLoaderRoute: typeof ResetHaslaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ustaw-haslo': {
      id: '/ustaw-haslo'
      path: '/ustaw-haslo'
      fullPath: '/ustaw-haslo'
      preLoaderRoute: typeof UstawHasloRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/zgloszenie': {
      id: '/zgloszenie'
      path: '/zgloszenie'
      fullPath: '/zgloszenie'
      preLoaderRoute: typeof ZgloszenieRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/asystent': {
      id: '/_auth/asystent'
      path: '/asystent'
      fullPath: '/asystent'
      preLoaderRoute: typeof AuthAsystentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/asystent-jakosc': {
      id: '/_auth/asystent-jakosc'
      path: '/asystent-jakosc'
      fullPath: '/asystent-jakosc'
      preLoaderRoute: typeof AuthAsystentJakoscRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/asystent-koszty': {
      id: '/_auth/asystent-koszty'
      path: '/asystent-koszty'
      fullPath: '/asystent-koszty'
      preLoaderRoute: typeof AuthAsystentKosztyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/asystent-statystyki-aptek': {
      id: '/_auth/asystent-statystyki-aptek'
      path: '/asystent-statystyki-aptek'
      fullPath: '/asystent-statystyki-aptek'
      preLoaderRoute: typeof AuthAsystentStatystykiAptekRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/moj-profil': {
      id: '/_auth/moj-profil'
      path: '/moj-profil'
      fullPath: '/moj-profil'
      preLoaderRoute: typeof AuthMojProfilRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/strateg-cenowy': {
      id: '/_auth/strateg-cenowy'
      path: '/strateg-cenowy'
      fullPath: '/strateg-cenowy'
      preLoaderRoute: typeof AuthStrategCenowyRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/polacz-ai/zgoda': {
      id: '/polacz-ai/zgoda'
      path: '/polacz-ai/zgoda'
      fullPath: '/polacz-ai/zgoda'
      preLoaderRoute: typeof PolaczAiZgodaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/publiczne/ksef': {
      id: '/publiczne/ksef'
      path: '/publiczne/ksef'
      fullPath: '/publiczne/ksef'
      preLoaderRoute: typeof PubliczneKsefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/apteneo/porownanie': {
      id: '/_auth/apteneo/porownanie'
      path: '/apteneo/porownanie'
      fullPath: '/apteneo/porownanie'
      preLoaderRoute: typeof AuthApteneoPorownanieRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/apteneo/rozliczenia': {
      id: '/_auth/apteneo/rozliczenia'
      path: '/apteneo/rozliczenia'
      fullPath: '/apteneo/rozliczenia'
      preLoaderRoute: typeof AuthApteneoRozliczeniaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/apteneo/zaczytaj-dane': {
      id: '/_auth/apteneo/zaczytaj-dane'
      path: '/apteneo/zaczytaj-dane'
      fullPath: '/apteneo/zaczytaj-dane'
      preLoaderRoute: typeof AuthApteneoZaczytajDaneRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/apteneo/zakupy': {
      id: '/_auth/apteneo/zakupy'
      path: '/apteneo/zakupy'
      fullPath: '/apteneo/zakupy'
      preLoaderRoute: typeof AuthApteneoZakupyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dokumenty/': {
      id: '/_auth/dokumenty/'
      path: '/dokumenty'
      fullPath: '/dokumenty/'
      preLoaderRoute: typeof AuthDokumentyIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dokumenty/hurtownicy': {
      id: '/_auth/dokumenty/hurtownicy'
      path: '/dokumenty/hurtownicy'
      fullPath: '/dokumenty/hurtownicy'
      preLoaderRoute: typeof AuthDokumentyHurtownicyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dokumenty/kalendarz-platnosci': {
      id: '/_auth/dokumenty/kalendarz-platnosci'
      path: '/dokumenty/kalendarz-platnosci'
      fullPath: '/dokumenty/kalendarz-platnosci'
      preLoaderRoute: typeof AuthDokumentyKalendarzPlatnosciRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dokumenty/ksef': {
      id: '/_auth/dokumenty/ksef'
      path: '/dokumenty/ksef'
      fullPath: '/dokumenty/ksef'
      preLoaderRoute: typeof AuthDokumentyKsefRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/helpdesk/': {
      id: '/_auth/helpdesk/'
      path: '/helpdesk'
      fullPath: '/helpdesk/'
      preLoaderRoute: typeof AuthHelpdeskIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/helpdesk/awaria': {
      id: '/_auth/helpdesk/awaria'
      path: '/helpdesk/awaria'
      fullPath: '/helpdesk/awaria'
      preLoaderRoute: typeof AuthHelpdeskAwariaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/helpdesk/czat': {
      id: '/_auth/helpdesk/czat'
      path: '/helpdesk/czat'
      fullPath: '/helpdesk/czat'
      preLoaderRoute: typeof AuthHelpdeskCzatRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/helpdesk/konfiguracja': {
      id: '/_auth/helpdesk/konfiguracja'
      path: '/helpdesk/konfiguracja'
      fullPath: '/helpdesk/konfiguracja'
      preLoaderRoute: typeof AuthHelpdeskKonfiguracjaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/helpdesk/szukaj': {
      id: '/_auth/helpdesk/szukaj'
      path: '/helpdesk/szukaj'
      fullPath: '/helpdesk/szukaj'
      preLoaderRoute: typeof AuthHelpdeskSzukajRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/helpdesk/zarzadzanie': {
      id: '/_auth/helpdesk/zarzadzanie'
      path: '/helpdesk/zarzadzanie'
      fullPath: '/helpdesk/zarzadzanie'
      preLoaderRoute: typeof AuthHelpdeskZarzadzanieRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kartoteka/cennik-najtaniej': {
      id: '/_auth/kartoteka/cennik-najtaniej'
      path: '/kartoteka/cennik-najtaniej'
      fullPath: '/kartoteka/cennik-najtaniej'
      preLoaderRoute: typeof AuthKartotekaCennikNajtaniejRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kartoteka/cennik-zgodnosc': {
      id: '/_auth/kartoteka/cennik-zgodnosc'
      path: '/kartoteka/cennik-zgodnosc'
      fullPath: '/kartoteka/cennik-zgodnosc'
      preLoaderRoute: typeof AuthKartotekaCennikZgodnoscRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kartoteka/cenniki-historia': {
      id: '/_auth/kartoteka/cenniki-historia'
      path: '/kartoteka/cenniki-historia'
      fullPath: '/kartoteka/cenniki-historia'
      preLoaderRoute: typeof AuthKartotekaCennikiHistoriaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kartoteka/cenniki-podglad': {
      id: '/_auth/kartoteka/cenniki-podglad'
      path: '/kartoteka/cenniki-podglad'
      fullPath: '/kartoteka/cenniki-podglad'
      preLoaderRoute: typeof AuthKartotekaCennikiPodgladRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kartoteka/grupy-produktow': {
      id: '/_auth/kartoteka/grupy-produktow'
      path: '/kartoteka/grupy-produktow'
      fullPath: '/kartoteka/grupy-produktow'
      preLoaderRoute: typeof AuthKartotekaGrupyProduktowRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kartoteka/kategoryzacja': {
      id: '/_auth/kartoteka/kategoryzacja'
      path: '/kartoteka/kategoryzacja'
      fullPath: '/kartoteka/kategoryzacja'
      preLoaderRoute: typeof AuthKartotekaKategoryzacjaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kartoteka/kontrahenci': {
      id: '/_auth/kartoteka/kontrahenci'
      path: '/kartoteka/kontrahenci'
      fullPath: '/kartoteka/kontrahenci'
      preLoaderRoute: typeof AuthKartotekaKontrahenciRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kartoteka/mapowanie-apc': {
      id: '/_auth/kartoteka/mapowanie-apc'
      path: '/kartoteka/mapowanie-apc'
      fullPath: '/kartoteka/mapowanie-apc'
      preLoaderRoute: typeof AuthKartotekaMapowanieApcRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kartoteka/producenci': {
      id: '/_auth/kartoteka/producenci'
      path: '/kartoteka/producenci'
      fullPath: '/kartoteka/producenci'
      preLoaderRoute: typeof AuthKartotekaProducenciRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kartoteka/stan-magazynu': {
      id: '/_auth/kartoteka/stan-magazynu'
      path: '/kartoteka/stan-magazynu'
      fullPath: '/kartoteka/stan-magazynu'
      preLoaderRoute: typeof AuthKartotekaStanMagazynuRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kartoteka/towary': {
      id: '/_auth/kartoteka/towary'
      path: '/kartoteka/towary'
      fullPath: '/kartoteka/towary'
      preLoaderRoute: typeof AuthKartotekaTowaryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/': {
      id: '/_auth/konfiguracja/'
      path: '/konfiguracja'
      fullPath: '/konfiguracja/'
      preLoaderRoute: typeof AuthKonfiguracjaIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/ai': {
      id: '/_auth/konfiguracja/ai'
      path: '/konfiguracja/ai'
      fullPath: '/konfiguracja/ai'
      preLoaderRoute: typeof AuthKonfiguracjaAiRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/aktualizacje': {
      id: '/_auth/konfiguracja/aktualizacje'
      path: '/konfiguracja/aktualizacje'
      fullPath: '/konfiguracja/aktualizacje'
      preLoaderRoute: typeof AuthKonfiguracjaAktualizacjeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/apteki': {
      id: '/_auth/konfiguracja/apteki'
      path: '/konfiguracja/apteki'
      fullPath: '/konfiguracja/apteki'
      preLoaderRoute: typeof AuthKonfiguracjaAptekiRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/audit-log': {
      id: '/_auth/konfiguracja/audit-log'
      path: '/konfiguracja/audit-log'
      fullPath: '/konfiguracja/audit-log'
      preLoaderRoute: typeof AuthKonfiguracjaAuditLogRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/drukarki': {
      id: '/_auth/konfiguracja/drukarki'
      path: '/konfiguracja/drukarki'
      fullPath: '/konfiguracja/drukarki'
      preLoaderRoute: typeof AuthKonfiguracjaDrukarkiRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/dyski': {
      id: '/_auth/konfiguracja/dyski'
      path: '/konfiguracja/dyski'
      fullPath: '/konfiguracja/dyski'
      preLoaderRoute: typeof AuthKonfiguracjaDyskiRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/eksporty-plikowe': {
      id: '/_auth/konfiguracja/eksporty-plikowe'
      path: '/konfiguracja/eksporty-plikowe'
      fullPath: '/konfiguracja/eksporty-plikowe'
      preLoaderRoute: typeof AuthKonfiguracjaEksportyPlikoweRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/email': {
      id: '/_auth/konfiguracja/email'
      path: '/konfiguracja/email'
      fullPath: '/konfiguracja/email'
      preLoaderRoute: typeof AuthKonfiguracjaEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/email-log': {
      id: '/_auth/konfiguracja/email-log'
      path: '/konfiguracja/email-log'
      fullPath: '/konfiguracja/email-log'
      preLoaderRoute: typeof AuthKonfiguracjaEmailLogRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/grupy-aptek': {
      id: '/_auth/konfiguracja/grupy-aptek'
      path: '/konfiguracja/grupy-aptek'
      fullPath: '/konfiguracja/grupy-aptek'
      preLoaderRoute: typeof AuthKonfiguracjaGrupyAptekRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/grupy-organizacyjne': {
      id: '/_auth/konfiguracja/grupy-organizacyjne'
      path: '/konfiguracja/grupy-organizacyjne'
      fullPath: '/konfiguracja/grupy-organizacyjne'
      preLoaderRoute: typeof AuthKonfiguracjaGrupyOrganizacyjneRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/grupy-uzytkownikow': {
      id: '/_auth/konfiguracja/grupy-uzytkownikow'
      path: '/konfiguracja/grupy-uzytkownikow'
      fullPath: '/konfiguracja/grupy-uzytkownikow'
      preLoaderRoute: typeof AuthKonfiguracjaGrupyUzytkownikowRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/harmonogramy-powiadomien': {
      id: '/_auth/konfiguracja/harmonogramy-powiadomien'
      path: '/konfiguracja/harmonogramy-powiadomien'
      fullPath: '/konfiguracja/harmonogramy-powiadomien'
      preLoaderRoute: typeof AuthKonfiguracjaHarmonogramyPowiadomienRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/harmonogramy-raportow': {
      id: '/_auth/konfiguracja/harmonogramy-raportow'
      path: '/konfiguracja/harmonogramy-raportow'
      fullPath: '/konfiguracja/harmonogramy-raportow'
      preLoaderRoute: typeof AuthKonfiguracjaHarmonogramyRaportowRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/import-mshr': {
      id: '/_auth/konfiguracja/import-mshr'
      path: '/konfiguracja/import-mshr'
      fullPath: '/konfiguracja/import-mshr'
      preLoaderRoute: typeof AuthKonfiguracjaImportMshrRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/iqvia': {
      id: '/_auth/konfiguracja/iqvia'
      path: '/konfiguracja/iqvia'
      fullPath: '/konfiguracja/iqvia'
      preLoaderRoute: typeof AuthKonfiguracjaIqviaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/ksef': {
      id: '/_auth/konfiguracja/ksef'
      path: '/konfiguracja/ksef'
      fullPath: '/konfiguracja/ksef'
      preLoaderRoute: typeof AuthKonfiguracjaKsefRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/ksef-certyfikaty': {
      id: '/_auth/konfiguracja/ksef-certyfikaty'
      path: '/konfiguracja/ksef-certyfikaty'
      fullPath: '/konfiguracja/ksef-certyfikaty'
      preLoaderRoute: typeof AuthKonfiguracjaKsefCertyfikatyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/ksef-osoz-edi': {
      id: '/_auth/konfiguracja/ksef-osoz-edi'
      path: '/konfiguracja/ksef-osoz-edi'
      fullPath: '/konfiguracja/ksef-osoz-edi'
      preLoaderRoute: typeof AuthKonfiguracjaKsefOsozEdiRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/mcp': {
      id: '/_auth/konfiguracja/mcp'
      path: '/konfiguracja/mcp'
      fullPath: '/konfiguracja/mcp'
      preLoaderRoute: typeof AuthKonfiguracjaMcpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/mcp-statystyki': {
      id: '/_auth/konfiguracja/mcp-statystyki'
      path: '/konfiguracja/mcp-statystyki'
      fullPath: '/konfiguracja/mcp-statystyki'
      preLoaderRoute: typeof AuthKonfiguracjaMcpStatystykiRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/organizacje': {
      id: '/_auth/konfiguracja/organizacje'
      path: '/konfiguracja/organizacje'
      fullPath: '/konfiguracja/organizacje'
      preLoaderRoute: typeof AuthKonfiguracjaOrganizacjeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/podglad-uzytkownika': {
      id: '/_auth/konfiguracja/podglad-uzytkownika'
      path: '/konfiguracja/podglad-uzytkownika'
      fullPath: '/konfiguracja/podglad-uzytkownika'
      preLoaderRoute: typeof AuthKonfiguracjaPodgladUzytkownikaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/pracownicy': {
      id: '/_auth/konfiguracja/pracownicy'
      path: '/konfiguracja/pracownicy'
      fullPath: '/konfiguracja/pracownicy'
      preLoaderRoute: typeof AuthKonfiguracjaPracownicyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/reguly-zdarzen': {
      id: '/_auth/konfiguracja/reguly-zdarzen'
      path: '/konfiguracja/reguly-zdarzen'
      fullPath: '/konfiguracja/reguly-zdarzen'
      preLoaderRoute: typeof AuthKonfiguracjaRegulyZdarzenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/sfy': {
      id: '/_auth/konfiguracja/sfy'
      path: '/konfiguracja/sfy'
      fullPath: '/konfiguracja/sfy'
      preLoaderRoute: typeof AuthKonfiguracjaSfyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/sms': {
      id: '/_auth/konfiguracja/sms'
      path: '/konfiguracja/sms'
      fullPath: '/konfiguracja/sms'
      preLoaderRoute: typeof AuthKonfiguracjaSmsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/spolki': {
      id: '/_auth/konfiguracja/spolki'
      path: '/konfiguracja/spolki'
      fullPath: '/konfiguracja/spolki'
      preLoaderRoute: typeof AuthKonfiguracjaSpolkiRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/sql-konsola': {
      id: '/_auth/konfiguracja/sql-konsola'
      path: '/konfiguracja/sql-konsola'
      fullPath: '/konfiguracja/sql-konsola'
      preLoaderRoute: typeof AuthKonfiguracjaSqlKonsolaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/sql-sfy': {
      id: '/_auth/konfiguracja/sql-sfy'
      path: '/konfiguracja/sql-sfy'
      fullPath: '/konfiguracja/sql-sfy'
      preLoaderRoute: typeof AuthKonfiguracjaSqlSfyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/statystyki-uzycia': {
      id: '/_auth/konfiguracja/statystyki-uzycia'
      path: '/konfiguracja/statystyki-uzycia'
      fullPath: '/konfiguracja/statystyki-uzycia'
      preLoaderRoute: typeof AuthKonfiguracjaStatystykiUzyciaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/system': {
      id: '/_auth/konfiguracja/system'
      path: '/konfiguracja/system'
      fullPath: '/konfiguracja/system'
      preLoaderRoute: typeof AuthKonfiguracjaSystemRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/tokeny-api': {
      id: '/_auth/konfiguracja/tokeny-api'
      path: '/konfiguracja/tokeny-api'
      fullPath: '/konfiguracja/tokeny-api'
      preLoaderRoute: typeof AuthKonfiguracjaTokenyApiRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/urzadzenia': {
      id: '/_auth/konfiguracja/urzadzenia'
      path: '/konfiguracja/urzadzenia'
      fullPath: '/konfiguracja/urzadzenia'
      preLoaderRoute: typeof AuthKonfiguracjaUrzadzeniaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/uzytkownicy': {
      id: '/_auth/konfiguracja/uzytkownicy'
      path: '/konfiguracja/uzytkownicy'
      fullPath: '/konfiguracja/uzytkownicy'
      preLoaderRoute: typeof AuthKonfiguracjaUzytkownicyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/': {
      id: '/_auth/kontrakty/'
      path: '/kontrakty'
      fullPath: '/kontrakty/'
      preLoaderRoute: typeof AuthKontraktyIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/$id': {
      id: '/_auth/kontrakty/$id'
      path: '/kontrakty/$id'
      fullPath: '/kontrakty/$id'
      preLoaderRoute: typeof AuthKontraktyIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/apteki-producentow': {
      id: '/_auth/kontrakty/apteki-producentow'
      path: '/kontrakty/apteki-producentow'
      fullPath: '/kontrakty/apteki-producentow'
      preLoaderRoute: typeof AuthKontraktyAptekiProducentowRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/apteki-producentow-historia': {
      id: '/_auth/kontrakty/apteki-producentow-historia'
      path: '/kontrakty/apteki-producentow-historia'
      fullPath: '/kontrakty/apteki-producentow-historia'
      preLoaderRoute: typeof AuthKontraktyAptekiProducentowHistoriaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/nieaktywne-apteki': {
      id: '/_auth/kontrakty/nieaktywne-apteki'
      path: '/kontrakty/nieaktywne-apteki'
      fullPath: '/kontrakty/nieaktywne-apteki'
      preLoaderRoute: typeof AuthKontraktyNieaktywneAptekiRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/nowy': {
      id: '/_auth/kontrakty/nowy'
      path: '/kontrakty/nowy'
      fullPath: '/kontrakty/nowy'
      preLoaderRoute: typeof AuthKontraktyNowyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/porownanie-z-producentem': {
      id: '/_auth/kontrakty/porownanie-z-producentem'
      path: '/kontrakty/porownanie-z-producentem'
      fullPath: '/kontrakty/porownanie-z-producentem'
      preLoaderRoute: typeof AuthKontraktyPorownanieZProducentemRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/producenci-dzzf': {
      id: '/_auth/kontrakty/producenci-dzzf'
      path: '/kontrakty/producenci-dzzf'
      fullPath: '/kontrakty/producenci-dzzf'
      preLoaderRoute: typeof AuthKontraktyProducenciDzzfRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/udzial': {
      id: '/_auth/kontrakty/udzial'
      path: '/kontrakty/udzial'
      fullPath: '/kontrakty/udzial'
      preLoaderRoute: typeof AuthKontraktyUdzialRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/wykonanie': {
      id: '/_auth/kontrakty/wykonanie'
      path: '/kontrakty/wykonanie'
      fullPath: '/kontrakty/wykonanie'
      preLoaderRoute: typeof AuthKontraktyWykonanieRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/analiza-zakupow-nowe-zam': {
      id: '/_auth/raporty/analiza-zakupow-nowe-zam'
      path: '/raporty/analiza-zakupow-nowe-zam'
      fullPath: '/raporty/analiza-zakupow-nowe-zam'
      preLoaderRoute: typeof AuthRaportyAnalizaZakupowNoweZamRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/analiza-zakupy-indeksow': {
      id: '/_auth/raporty/analiza-zakupy-indeksow'
      path: '/raporty/analiza-zakupy-indeksow'
      fullPath: '/raporty/analiza-zakupy-indeksow'
      preLoaderRoute: typeof AuthRaportyAnalizaZakupyIndeksowRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/dashboard-analityczny': {
      id: '/_auth/raporty/dashboard-analityczny'
      path: '/raporty/dashboard-analityczny'
      fullPath: '/raporty/dashboard-analityczny'
      preLoaderRoute: typeof AuthRaportyDashboardAnalitycznyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/dashboard-magazyn-szczegol': {
      id: '/_auth/raporty/dashboard-magazyn-szczegol'
      path: '/raporty/dashboard-magazyn-szczegol'
      fullPath: '/raporty/dashboard-magazyn-szczegol'
      preLoaderRoute: typeof AuthRaportyDashboardMagazynSzczegolRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/daty-waznosci': {
      id: '/_auth/raporty/daty-waznosci'
      path: '/raporty/daty-waznosci'
      fullPath: '/raporty/daty-waznosci'
      preLoaderRoute: typeof AuthRaportyDatyWaznosciRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/dynamika-sprzedazy': {
      id: '/_auth/raporty/dynamika-sprzedazy'
      path: '/raporty/dynamika-sprzedazy'
      fullPath: '/raporty/dynamika-sprzedazy'
      preLoaderRoute: typeof AuthRaportyDynamikaSprzedazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/ecom': {
      id: '/_auth/raporty/ecom'
      path: '/raporty/ecom'
      fullPath: '/raporty/ecom'
      preLoaderRoute: typeof AuthRaportyEcomRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/jakosc-danych-wyjatki': {
      id: '/_auth/raporty/jakosc-danych-wyjatki'
      path: '/raporty/jakosc-danych-wyjatki'
      fullPath: '/raporty/jakosc-danych-wyjatki'
      preLoaderRoute: typeof AuthRaportyJakoscDanychWyjatkiRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/kategoria-kwartalna': {
      id: '/_auth/raporty/kategoria-kwartalna'
      path: '/raporty/kategoria-kwartalna'
      fullPath: '/raporty/kategoria-kwartalna'
      preLoaderRoute: typeof AuthRaportyKategoriaKwartalnaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/luki-powiazan': {
      id: '/_auth/raporty/luki-powiazan'
      path: '/raporty/luki-powiazan'
      fullPath: '/raporty/luki-powiazan'
      preLoaderRoute: typeof AuthRaportyLukiPowiazanRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/odchylenia-cen-fv': {
      id: '/_auth/raporty/odchylenia-cen-fv'
      path: '/raporty/odchylenia-cen-fv'
      fullPath: '/raporty/odchylenia-cen-fv'
      preLoaderRoute: typeof AuthRaportyOdchyleniaCenFvRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/raport-produktowy': {
      id: '/_auth/raporty/raport-produktowy'
      path: '/raporty/raport-produktowy'
      fullPath: '/raporty/raport-produktowy'
      preLoaderRoute: typeof AuthRaportyRaportProduktowyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/rozklad-marz': {
      id: '/_auth/raporty/rozklad-marz'
      path: '/raporty/rozklad-marz'
      fullPath: '/raporty/rozklad-marz'
      preLoaderRoute: typeof AuthRaportyRozkladMarzRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/sprz-opiekun': {
      id: '/_auth/raporty/sprz-opiekun'
      path: '/raporty/sprz-opiekun'
      fullPath: '/raporty/sprz-opiekun'
      preLoaderRoute: typeof AuthRaportySprzOpiekunRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/sprz-wynik': {
      id: '/_auth/raporty/sprz-wynik'
      path: '/raporty/sprz-wynik'
      fullPath: '/raporty/sprz-wynik'
      preLoaderRoute: typeof AuthRaportySprzWynikRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/sprz_kasjer_data': {
      id: '/_auth/raporty/sprz_kasjer_data'
      path: '/raporty/sprz_kasjer_data'
      fullPath: '/raporty/sprz_kasjer_data'
      preLoaderRoute: typeof AuthRaportySprz_kasjer_dataRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/sprzedaz-dzienna': {
      id: '/_auth/raporty/sprzedaz-dzienna'
      path: '/raporty/sprzedaz-dzienna'
      fullPath: '/raporty/sprzedaz-dzienna'
      preLoaderRoute: typeof AuthRaportySprzedazDziennaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/sprzedaz-zrealizowana': {
      id: '/_auth/raporty/sprzedaz-zrealizowana'
      path: '/raporty/sprzedaz-zrealizowana'
      fullPath: '/raporty/sprzedaz-zrealizowana'
      preLoaderRoute: typeof AuthRaportySprzedazZrealizowanaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/ujemne-marze': {
      id: '/_auth/raporty/ujemne-marze'
      path: '/raporty/ujemne-marze'
      fullPath: '/raporty/ujemne-marze'
      preLoaderRoute: typeof AuthRaportyUjemneMarzeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/weryfikacja-towr': {
      id: '/_auth/raporty/weryfikacja-towr'
      path: '/raporty/weryfikacja-towr'
      fullPath: '/raporty/weryfikacja-towr'
      preLoaderRoute: typeof AuthRaportyWeryfikacjaTowrRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/wyprzedaz-magazynu': {
      id: '/_auth/raporty/wyprzedaz-magazynu'
      path: '/raporty/wyprzedaz-magazynu'
      fullPath: '/raporty/wyprzedaz-magazynu'
      preLoaderRoute: typeof AuthRaportyWyprzedazMagazynuRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/zmiany-blozu': {
      id: '/_auth/raporty/zmiany-blozu'
      path: '/raporty/zmiany-blozu'
      fullPath: '/raporty/zmiany-blozu'
      preLoaderRoute: typeof AuthRaportyZmianyBlozuRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/zwroty-dzienne': {
      id: '/_auth/raporty/zwroty-dzienne'
      path: '/raporty/zwroty-dzienne'
      fullPath: '/raporty/zwroty-dzienne'
      preLoaderRoute: typeof AuthRaportyZwrotyDzienneRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/zwroty-kwartalne': {
      id: '/_auth/raporty/zwroty-kwartalne'
      path: '/raporty/zwroty-kwartalne'
      fullPath: '/raporty/zwroty-kwartalne'
      preLoaderRoute: typeof AuthRaportyZwrotyKwartalneRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/rda/analiza-korzysci': {
      id: '/_auth/rda/analiza-korzysci'
      path: '/rda/analiza-korzysci'
      fullPath: '/rda/analiza-korzysci'
      preLoaderRoute: typeof AuthRdaAnalizaKorzysciRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/rda/lista-ofert-fm1': {
      id: '/_auth/rda/lista-ofert-fm1'
      path: '/rda/lista-ofert-fm1'
      fullPath: '/rda/lista-ofert-fm1'
      preLoaderRoute: typeof AuthRdaListaOfertFm1RouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/receptura/protokoly': {
      id: '/_auth/receptura/protokoly'
      path: '/receptura/protokoly'
      fullPath: '/receptura/protokoly'
      preLoaderRoute: typeof AuthRecepturaProtokolyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/receptura/surowce': {
      id: '/_auth/receptura/surowce'
      path: '/receptura/surowce'
      fullPath: '/receptura/surowce'
      preLoaderRoute: typeof AuthRecepturaSurowceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/receptura/szablony': {
      id: '/_auth/receptura/szablony'
      path: '/receptura/szablony'
      fullPath: '/receptura/szablony'
      preLoaderRoute: typeof AuthRecepturaSzablonyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sms/': {
      id: '/_auth/sms/'
      path: '/sms'
      fullPath: '/sms/'
      preLoaderRoute: typeof AuthSmsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sms/kampanie': {
      id: '/_auth/sms/kampanie'
      path: '/sms/kampanie'
      fullPath: '/sms/kampanie'
      preLoaderRoute: typeof AuthSmsKampanieRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sms/kontakty': {
      id: '/_auth/sms/kontakty'
      path: '/sms/kontakty'
      fullPath: '/sms/kontakty'
      preLoaderRoute: typeof AuthSmsKontaktyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sms/szablony': {
      id: '/_auth/sms/szablony'
      path: '/sms/szablony'
      fullPath: '/sms/szablony'
      preLoaderRoute: typeof AuthSmsSzablonyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sms/zuzycie': {
      id: '/_auth/sms/zuzycie'
      path: '/sms/zuzycie'
      fullPath: '/sms/zuzycie'
      preLoaderRoute: typeof AuthSmsZuzycieRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/strateg-cenowy/': {
      id: '/_auth/strateg-cenowy/'
      path: '/'
      fullPath: '/strateg-cenowy/'
      preLoaderRoute: typeof AuthStrategCenowyIndexRouteImport
      parentRoute: typeof AuthStrategCenowyRouteRoute
    }
    '/_auth/strateg-cenowy/cenniki-centralne': {
      id: '/_auth/strateg-cenowy/cenniki-centralne'
      path: '/cenniki-centralne'
      fullPath: '/strateg-cenowy/cenniki-centralne'
      preLoaderRoute: typeof AuthStrategCenowyCennikiCentralneRouteImport
      parentRoute: typeof AuthStrategCenowyRouteRoute
    }
    '/_auth/strateg-cenowy/cenniki-wlasne': {
      id: '/_auth/strateg-cenowy/cenniki-wlasne'
      path: '/cenniki-wlasne'
      fullPath: '/strateg-cenowy/cenniki-wlasne'
      preLoaderRoute: typeof AuthStrategCenowyCennikiWlasneRouteImport
      parentRoute: typeof AuthStrategCenowyRouteRoute
    }
    '/_auth/strateg-cenowy/kalkulator-marzy': {
      id: '/_auth/strateg-cenowy/kalkulator-marzy'
      path: '/kalkulator-marzy'
      fullPath: '/strateg-cenowy/kalkulator-marzy'
      preLoaderRoute: typeof AuthStrategCenowyKalkulatorMarzyRouteImport
      parentRoute: typeof AuthStrategCenowyRouteRoute
    }
    '/_auth/strateg-cenowy/konfiguracja-top': {
      id: '/_auth/strateg-cenowy/konfiguracja-top'
      path: '/konfiguracja-top'
      fullPath: '/strateg-cenowy/konfiguracja-top'
      preLoaderRoute: typeof AuthStrategCenowyKonfiguracjaTopRouteImport
      parentRoute: typeof AuthStrategCenowyRouteRoute
    }
    '/_auth/strateg-cenowy/lider-franczyza': {
      id: '/_auth/strateg-cenowy/lider-franczyza'
      path: '/lider-franczyza'
      fullPath: '/strateg-cenowy/lider-franczyza'
      preLoaderRoute: typeof AuthStrategCenowyLiderFranczyzaRouteImport
      parentRoute: typeof AuthStrategCenowyRouteRoute
    }
    '/_auth/strateg-cenowy/modyfikatory': {
      id: '/_auth/strateg-cenowy/modyfikatory'
      path: '/modyfikatory'
      fullPath: '/strateg-cenowy/modyfikatory'
      preLoaderRoute: typeof AuthStrategCenowyModyfikatoryRouteImport
      parentRoute: typeof AuthStrategCenowyRouteRoute
    }
    '/_auth/strateg-cenowy/strategie': {
      id: '/_auth/strateg-cenowy/strategie'
      path: '/strategie'
      fullPath: '/strateg-cenowy/strategie'
      preLoaderRoute: typeof AuthStrategCenowyStrategieRouteImport
      parentRoute: typeof AuthStrategCenowyRouteRoute
    }
    '/_auth/strateg-cenowy/wykluczenia': {
      id: '/_auth/strateg-cenowy/wykluczenia'
      path: '/wykluczenia'
      fullPath: '/strateg-cenowy/wykluczenia'
      preLoaderRoute: typeof AuthStrategCenowyWykluczeniaRouteImport
      parentRoute: typeof AuthStrategCenowyRouteRoute
    }
    '/_auth/strateg-cenowy/wyniki': {
      id: '/_auth/strateg-cenowy/wyniki'
      path: '/wyniki'
      fullPath: '/strateg-cenowy/wyniki'
      preLoaderRoute: typeof AuthStrategCenowyWynikiRouteImport
      parentRoute: typeof AuthStrategCenowyRouteRoute
    }
    '/_auth/strateg-cenowy/wyniki-top': {
      id: '/_auth/strateg-cenowy/wyniki-top'
      path: '/wyniki-top'
      fullPath: '/strateg-cenowy/wyniki-top'
      preLoaderRoute: typeof AuthStrategCenowyWynikiTopRouteImport
      parentRoute: typeof AuthStrategCenowyRouteRoute
    }
    '/_auth/synchronizacja/konsola-sql': {
      id: '/_auth/synchronizacja/konsola-sql'
      path: '/synchronizacja/konsola-sql'
      fullPath: '/synchronizacja/konsola-sql'
      preLoaderRoute: typeof AuthSynchronizacjaKonsolaSqlRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/synchronizacja/zatwierdzenia-sql': {
      id: '/_auth/synchronizacja/zatwierdzenia-sql'
      path: '/synchronizacja/zatwierdzenia-sql'
      fullPath: '/synchronizacja/zatwierdzenia-sql'
      preLoaderRoute: typeof AuthSynchronizacjaZatwierdzeniaSqlRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dokumenty/hurtownicy/$nip': {
      id: '/_auth/dokumenty/hurtownicy/$nip'
      path: '/$nip'
      fullPath: '/dokumenty/hurtownicy/$nip'
      preLoaderRoute: typeof AuthDokumentyHurtownicyNipRouteImport
      parentRoute: typeof AuthDokumentyHurtownicyRoute
    }
    '/_auth/dokumenty/ksef/$invoiceId': {
      id: '/_auth/dokumenty/ksef/$invoiceId'
      path: '/$invoiceId'
      fullPath: '/dokumenty/ksef/$invoiceId'
      preLoaderRoute: typeof AuthDokumentyKsefInvoiceIdRouteImport
      parentRoute: typeof AuthDokumentyKsefRoute
    }
    '/_auth/konfiguracja/issue-resolve/': {
      id: '/_auth/konfiguracja/issue-resolve/'
      path: '/konfiguracja/issue-resolve'
      fullPath: '/konfiguracja/issue-resolve/'
      preLoaderRoute: typeof AuthKonfiguracjaIssueResolveIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/issue-resolve/$number': {
      id: '/_auth/konfiguracja/issue-resolve/$number'
      path: '/konfiguracja/issue-resolve/$number'
      fullPath: '/konfiguracja/issue-resolve/$number'
      preLoaderRoute: typeof AuthKonfiguracjaIssueResolveNumberRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/konfiguracja/sfy_/przeglad': {
      id: '/_auth/konfiguracja/sfy_/przeglad'
      path: '/konfiguracja/sfy/przeglad'
      fullPath: '/konfiguracja/sfy/przeglad'
      preLoaderRoute: typeof AuthKonfiguracjaSfyPrzegladRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/apteki-gap/': {
      id: '/_auth/kontrakty/apteki-gap/'
      path: '/kontrakty/apteki-gap'
      fullPath: '/kontrakty/apteki-gap/'
      preLoaderRoute: typeof AuthKontraktyAptekiGapIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/apteki-gap/$id': {
      id: '/_auth/kontrakty/apteki-gap/$id'
      path: '/kontrakty/apteki-gap/$id'
      fullPath: '/kontrakty/apteki-gap/$id'
      preLoaderRoute: typeof AuthKontraktyAptekiGapIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/apteki-gap/nowy': {
      id: '/_auth/kontrakty/apteki-gap/nowy'
      path: '/kontrakty/apteki-gap/nowy'
      fullPath: '/kontrakty/apteki-gap/nowy'
      preLoaderRoute: typeof AuthKontraktyAptekiGapNowyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/cenniki-exfactory/': {
      id: '/_auth/kontrakty/cenniki-exfactory/'
      path: '/kontrakty/cenniki-exfactory'
      fullPath: '/kontrakty/cenniki-exfactory/'
      preLoaderRoute: typeof AuthKontraktyCennikiExfactoryIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/cenniki-exfactory/$id': {
      id: '/_auth/kontrakty/cenniki-exfactory/$id'
      path: '/kontrakty/cenniki-exfactory/$id'
      fullPath: '/kontrakty/cenniki-exfactory/$id'
      preLoaderRoute: typeof AuthKontraktyCennikiExfactoryIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/cenniki-exfactory/nowy': {
      id: '/_auth/kontrakty/cenniki-exfactory/nowy'
      path: '/kontrakty/cenniki-exfactory/nowy'
      fullPath: '/kontrakty/cenniki-exfactory/nowy'
      preLoaderRoute: typeof AuthKontraktyCennikiExfactoryNowyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/doplaty-gap/': {
      id: '/_auth/kontrakty/doplaty-gap/'
      path: '/kontrakty/doplaty-gap'
      fullPath: '/kontrakty/doplaty-gap/'
      preLoaderRoute: typeof AuthKontraktyDoplatyGapIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/doplaty-gap/$id': {
      id: '/_auth/kontrakty/doplaty-gap/$id'
      path: '/kontrakty/doplaty-gap/$id'
      fullPath: '/kontrakty/doplaty-gap/$id'
      preLoaderRoute: typeof AuthKontraktyDoplatyGapIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/doplaty-gap/nowy': {
      id: '/_auth/kontrakty/doplaty-gap/nowy'
      path: '/kontrakty/doplaty-gap/nowy'
      fullPath: '/kontrakty/doplaty-gap/nowy'
      preLoaderRoute: typeof AuthKontraktyDoplatyGapNowyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/lider-zakupy/': {
      id: '/_auth/kontrakty/lider-zakupy/'
      path: '/kontrakty/lider-zakupy'
      fullPath: '/kontrakty/lider-zakupy/'
      preLoaderRoute: typeof AuthKontraktyLiderZakupyIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/lider-zakupy/$id': {
      id: '/_auth/kontrakty/lider-zakupy/$id'
      path: '/kontrakty/lider-zakupy/$id'
      fullPath: '/kontrakty/lider-zakupy/$id'
      preLoaderRoute: typeof AuthKontraktyLiderZakupyIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/lider-zakupy/nowy': {
      id: '/_auth/kontrakty/lider-zakupy/nowy'
      path: '/kontrakty/lider-zakupy/nowy'
      fullPath: '/kontrakty/lider-zakupy/nowy'
      preLoaderRoute: typeof AuthKontraktyLiderZakupyNowyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/msl-dostepnosc/': {
      id: '/_auth/kontrakty/msl-dostepnosc/'
      path: '/kontrakty/msl-dostepnosc'
      fullPath: '/kontrakty/msl-dostepnosc/'
      preLoaderRoute: typeof AuthKontraktyMslDostepnoscIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/msl-dostepnosc/$id': {
      id: '/_auth/kontrakty/msl-dostepnosc/$id'
      path: '/kontrakty/msl-dostepnosc/$id'
      fullPath: '/kontrakty/msl-dostepnosc/$id'
      preLoaderRoute: typeof AuthKontraktyMslDostepnoscIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/msl-dostepnosc/nowy': {
      id: '/_auth/kontrakty/msl-dostepnosc/nowy'
      path: '/kontrakty/msl-dostepnosc/nowy'
      fullPath: '/kontrakty/msl-dostepnosc/nowy'
      preLoaderRoute: typeof AuthKontraktyMslDostepnoscNowyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/porownanie/': {
      id: '/_auth/kontrakty/porownanie/'
      path: '/kontrakty/porownanie'
      fullPath: '/kontrakty/porownanie/'
      preLoaderRoute: typeof AuthKontraktyPorownanieIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/porownanie/$id': {
      id: '/_auth/kontrakty/porownanie/$id'
      path: '/kontrakty/porownanie/$id'
      fullPath: '/kontrakty/porownanie/$id'
      preLoaderRoute: typeof AuthKontraktyPorownanieIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/raporty/': {
      id: '/_auth/kontrakty/raporty/'
      path: '/kontrakty/raporty'
      fullPath: '/kontrakty/raporty/'
      preLoaderRoute: typeof AuthKontraktyRaportyIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/raporty/kontrakt': {
      id: '/_auth/kontrakty/raporty/kontrakt'
      path: '/kontrakty/raporty/kontrakt'
      fullPath: '/kontrakty/raporty/kontrakt'
      preLoaderRoute: typeof AuthKontraktyRaportyKontraktRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/raporty/lider': {
      id: '/_auth/kontrakty/raporty/lider'
      path: '/kontrakty/raporty/lider'
      fullPath: '/kontrakty/raporty/lider'
      preLoaderRoute: typeof AuthKontraktyRaportyLiderRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/raporty/podsumowanie': {
      id: '/_auth/kontrakty/raporty/podsumowanie'
      path: '/kontrakty/raporty/podsumowanie'
      fullPath: '/kontrakty/raporty/podsumowanie'
      preLoaderRoute: typeof AuthKontraktyRaportyPodsumowanieRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/raporty/producent': {
      id: '/_auth/kontrakty/raporty/producent'
      path: '/kontrakty/raporty/producent'
      fullPath: '/kontrakty/raporty/producent'
      preLoaderRoute: typeof AuthKontraktyRaportyProducentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/rozliczenia-zakup/': {
      id: '/_auth/kontrakty/rozliczenia-zakup/'
      path: '/kontrakty/rozliczenia-zakup'
      fullPath: '/kontrakty/rozliczenia-zakup/'
      preLoaderRoute: typeof AuthKontraktyRozliczeniaZakupIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/rozliczenia-zakup/$id': {
      id: '/_auth/kontrakty/rozliczenia-zakup/$id'
      path: '/kontrakty/rozliczenia-zakup/$id'
      fullPath: '/kontrakty/rozliczenia-zakup/$id'
      preLoaderRoute: typeof AuthKontraktyRozliczeniaZakupIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/rozliczenia/': {
      id: '/_auth/kontrakty/rozliczenia/'
      path: '/kontrakty/rozliczenia'
      fullPath: '/kontrakty/rozliczenia/'
      preLoaderRoute: typeof AuthKontraktyRozliczeniaIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/rozliczenia/$id': {
      id: '/_auth/kontrakty/rozliczenia/$id'
      path: '/kontrakty/rozliczenia/$id'
      fullPath: '/kontrakty/rozliczenia/$id'
      preLoaderRoute: typeof AuthKontraktyRozliczeniaIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/rozliczenia/aktywnosc-aptek': {
      id: '/_auth/kontrakty/rozliczenia/aktywnosc-aptek'
      path: '/kontrakty/rozliczenia/aktywnosc-aptek'
      fullPath: '/kontrakty/rozliczenia/aktywnosc-aptek'
      preLoaderRoute: typeof AuthKontraktyRozliczeniaAktywnoscAptekRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/rozliczenia/prognoza-wsteczna': {
      id: '/_auth/kontrakty/rozliczenia/prognoza-wsteczna'
      path: '/kontrakty/rozliczenia/prognoza-wsteczna'
      fullPath: '/kontrakty/rozliczenia/prognoza-wsteczna'
      preLoaderRoute: typeof AuthKontraktyRozliczeniaPrognozaWstecznaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/rozliczenia/proporcje-kanalow': {
      id: '/_auth/kontrakty/rozliczenia/proporcje-kanalow'
      path: '/kontrakty/rozliczenia/proporcje-kanalow'
      fullPath: '/kontrakty/rozliczenia/proporcje-kanalow'
      preLoaderRoute: typeof AuthKontraktyRozliczeniaProporcjeKanalowRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/weryfikacja-wysylek/': {
      id: '/_auth/kontrakty/weryfikacja-wysylek/'
      path: '/kontrakty/weryfikacja-wysylek'
      fullPath: '/kontrakty/weryfikacja-wysylek/'
      preLoaderRoute: typeof AuthKontraktyWeryfikacjaWysylekIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/weryfikacja-wysylek/$id': {
      id: '/_auth/kontrakty/weryfikacja-wysylek/$id'
      path: '/kontrakty/weryfikacja-wysylek/$id'
      fullPath: '/kontrakty/weryfikacja-wysylek/$id'
      preLoaderRoute: typeof AuthKontraktyWeryfikacjaWysylekIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/weryfikacja-wysylek/klienci': {
      id: '/_auth/kontrakty/weryfikacja-wysylek/klienci'
      path: '/kontrakty/weryfikacja-wysylek/klienci'
      fullPath: '/kontrakty/weryfikacja-wysylek/klienci'
      preLoaderRoute: typeof AuthKontraktyWeryfikacjaWysylekKlienciRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/weryfikacja-wysylek/polaczenia': {
      id: '/_auth/kontrakty/weryfikacja-wysylek/polaczenia'
      path: '/kontrakty/weryfikacja-wysylek/polaczenia'
      fullPath: '/kontrakty/weryfikacja-wysylek/polaczenia'
      preLoaderRoute: typeof AuthKontraktyWeryfikacjaWysylekPolaczeniaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/sprz-wybranych-blozow/': {
      id: '/_auth/raporty/sprz-wybranych-blozow/'
      path: '/raporty/sprz-wybranych-blozow'
      fullPath: '/raporty/sprz-wybranych-blozow/'
      preLoaderRoute: typeof AuthRaportySprzWybranychBlozowIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/system-premiowy/lider-szczegolowo': {
      id: '/_auth/raporty/system-premiowy/lider-szczegolowo'
      path: '/raporty/system-premiowy/lider-szczegolowo'
      fullPath: '/raporty/system-premiowy/lider-szczegolowo'
      preLoaderRoute: typeof AuthRaportySystemPremiowyLiderSzczegolowoRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/weryfikacja-sprzedazy/': {
      id: '/_auth/raporty/weryfikacja-sprzedazy/'
      path: '/raporty/weryfikacja-sprzedazy'
      fullPath: '/raporty/weryfikacja-sprzedazy/'
      preLoaderRoute: typeof AuthRaportyWeryfikacjaSprzedazyIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/weryfikacja-sprzedazy/faktura-do-paragonu': {
      id: '/_auth/raporty/weryfikacja-sprzedazy/faktura-do-paragonu'
      path: '/raporty/weryfikacja-sprzedazy/faktura-do-paragonu'
      fullPath: '/raporty/weryfikacja-sprzedazy/faktura-do-paragonu'
      preLoaderRoute: typeof AuthRaportyWeryfikacjaSprzedazyFakturaDoParagonuRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/weryfikacja-sprzedazy/zmiany': {
      id: '/_auth/raporty/weryfikacja-sprzedazy/zmiany'
      path: '/raporty/weryfikacja-sprzedazy/zmiany'
      fullPath: '/raporty/weryfikacja-sprzedazy/zmiany'
      preLoaderRoute: typeof AuthRaportyWeryfikacjaSprzedazyZmianyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/rda/lista-ofert-fm1_/$offerId': {
      id: '/_auth/rda/lista-ofert-fm1_/$offerId'
      path: '/rda/lista-ofert-fm1/$offerId'
      fullPath: '/rda/lista-ofert-fm1/$offerId'
      preLoaderRoute: typeof AuthRdaListaOfertFm1OfferIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/receptura/protokoly_/$id': {
      id: '/_auth/receptura/protokoly_/$id'
      path: '/receptura/protokoly/$id'
      fullPath: '/receptura/protokoly/$id'
      preLoaderRoute: typeof AuthRecepturaProtokolyIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/synchronizacja/apteki/': {
      id: '/_auth/synchronizacja/apteki/'
      path: '/synchronizacja/apteki'
      fullPath: '/synchronizacja/apteki/'
      preLoaderRoute: typeof AuthSynchronizacjaAptekiIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/synchronizacja/apteki/$idfirm': {
      id: '/_auth/synchronizacja/apteki/$idfirm'
      path: '/synchronizacja/apteki/$idfirm'
      fullPath: '/synchronizacja/apteki/$idfirm'
      preLoaderRoute: typeof AuthSynchronizacjaAptekiIdfirmRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/kontrakty/rozliczenia-zakup/$id/analiza-dzial-zakupow': {
      id: '/_auth/kontrakty/rozliczenia-zakup/$id/analiza-dzial-zakupow'
      path: '/analiza-dzial-zakupow'
      fullPath: '/kontrakty/rozliczenia-zakup/$id/analiza-dzial-zakupow'
      preLoaderRoute: typeof AuthKontraktyRozliczeniaZakupIdAnalizaDzialZakupowRouteImport
      parentRoute: typeof AuthKontraktyRozliczeniaZakupIdRoute
    }
    '/_auth/kontrakty/rozliczenia-zakup/$id/analiza-per-spolka': {
      id: '/_auth/kontrakty/rozliczenia-zakup/$id/analiza-per-spolka'
      path: '/analiza-per-spolka'
      fullPath: '/kontrakty/rozliczenia-zakup/$id/analiza-per-spolka'
      preLoaderRoute: typeof AuthKontraktyRozliczeniaZakupIdAnalizaPerSpolkaRouteImport
      parentRoute: typeof AuthKontraktyRozliczeniaZakupIdRoute
    }
    '/_auth/kontrakty/rozliczenia/$id/miesiecznie': {
      id: '/_auth/kontrakty/rozliczenia/$id/miesiecznie'
      path: '/miesiecznie'
      fullPath: '/kontrakty/rozliczenia/$id/miesiecznie'
      preLoaderRoute: typeof AuthKontraktyRozliczeniaIdMiesiecznieRouteImport
      parentRoute: typeof AuthKontraktyRozliczeniaIdRoute
    }
    '/_auth/kontrakty/rozliczenia/$id/po-spolce': {
      id: '/_auth/kontrakty/rozliczenia/$id/po-spolce'
      path: '/po-spolce'
      fullPath: '/kontrakty/rozliczenia/$id/po-spolce'
      preLoaderRoute: typeof AuthKontraktyRozliczeniaIdPoSpolceRouteImport
      parentRoute: typeof AuthKontraktyRozliczeniaIdRoute
    }
    '/_auth/raporty/sprz-wybranych-blozow/parametry/': {
      id: '/_auth/raporty/sprz-wybranych-blozow/parametry/'
      path: '/raporty/sprz-wybranych-blozow/parametry'
      fullPath: '/raporty/sprz-wybranych-blozow/parametry/'
      preLoaderRoute: typeof AuthRaportySprzWybranychBlozowParametryIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/sprz-wybranych-blozow/parametry/$id': {
      id: '/_auth/raporty/sprz-wybranych-blozow/parametry/$id'
      path: '/raporty/sprz-wybranych-blozow/parametry/$id'
      fullPath: '/raporty/sprz-wybranych-blozow/parametry/$id'
      preLoaderRoute: typeof AuthRaportySprzWybranychBlozowParametryIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/sprz-wybranych-blozow/parametry/nowy': {
      id: '/_auth/raporty/sprz-wybranych-blozow/parametry/nowy'
      path: '/raporty/sprz-wybranych-blozow/parametry/nowy'
      fullPath: '/raporty/sprz-wybranych-blozow/parametry/nowy'
      preLoaderRoute: typeof AuthRaportySprzWybranychBlozowParametryNowyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/system-premiowy/lider/': {
      id: '/_auth/raporty/system-premiowy/lider/'
      path: '/raporty/system-premiowy/lider'
      fullPath: '/raporty/system-premiowy/lider/'
      preLoaderRoute: typeof AuthRaportySystemPremiowyLiderIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/system-premiowy/lider/$id': {
      id: '/_auth/raporty/system-premiowy/lider/$id'
      path: '/raporty/system-premiowy/lider/$id'
      fullPath: '/raporty/system-premiowy/lider/$id'
      preLoaderRoute: typeof AuthRaportySystemPremiowyLiderIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/system-premiowy/lider/nowy': {
      id: '/_auth/raporty/system-premiowy/lider/nowy'
      path: '/raporty/system-premiowy/lider/nowy'
      fullPath: '/raporty/system-premiowy/lider/nowy'
      preLoaderRoute: typeof AuthRaportySystemPremiowyLiderNowyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/system-premiowy/program-partnerski/': {
      id: '/_auth/raporty/system-premiowy/program-partnerski/'
      path: '/raporty/system-premiowy/program-partnerski'
      fullPath: '/raporty/system-premiowy/program-partnerski/'
      preLoaderRoute: typeof AuthRaportySystemPremiowyProgramPartnerskiIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/system-premiowy/program-partnerski/$id': {
      id: '/_auth/raporty/system-premiowy/program-partnerski/$id'
      path: '/raporty/system-premiowy/program-partnerski/$id'
      fullPath: '/raporty/system-premiowy/program-partnerski/$id'
      preLoaderRoute: typeof AuthRaportySystemPremiowyProgramPartnerskiIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/system-premiowy/program-partnerski/nowy': {
      id: '/_auth/raporty/system-premiowy/program-partnerski/nowy'
      path: '/raporty/system-premiowy/program-partnerski/nowy'
      fullPath: '/raporty/system-premiowy/program-partnerski/nowy'
      preLoaderRoute: typeof AuthRaportySystemPremiowyProgramPartnerskiNowyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/system-premiowy/rentownosc/': {
      id: '/_auth/raporty/system-premiowy/rentownosc/'
      path: '/raporty/system-premiowy/rentownosc'
      fullPath: '/raporty/system-premiowy/rentownosc/'
      preLoaderRoute: typeof AuthRaportySystemPremiowyRentownoscIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/system-premiowy/rentownosc/$id': {
      id: '/_auth/raporty/system-premiowy/rentownosc/$id'
      path: '/raporty/system-premiowy/rentownosc/$id'
      fullPath: '/raporty/system-premiowy/rentownosc/$id'
      preLoaderRoute: typeof AuthRaportySystemPremiowyRentownoscIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/system-premiowy/rentownosc/nowa': {
      id: '/_auth/raporty/system-premiowy/rentownosc/nowa'
      path: '/raporty/system-premiowy/rentownosc/nowa'
      fullPath: '/raporty/system-premiowy/rentownosc/nowa'
      preLoaderRoute: typeof AuthRaportySystemPremiowyRentownoscNowaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/system-premiowy/struktura/': {
      id: '/_auth/raporty/system-premiowy/struktura/'
      path: '/raporty/system-premiowy/struktura'
      fullPath: '/raporty/system-premiowy/struktura/'
      preLoaderRoute: typeof AuthRaportySystemPremiowyStrukturaIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/system-premiowy/struktura/$id': {
      id: '/_auth/raporty/system-premiowy/struktura/$id'
      path: '/raporty/system-premiowy/struktura/$id'
      fullPath: '/raporty/system-premiowy/struktura/$id'
      preLoaderRoute: typeof AuthRaportySystemPremiowyStrukturaIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/raporty/system-premiowy/struktura/nowa': {
      id: '/_auth/raporty/system-premiowy/struktura/nowa'
      path: '/raporty/system-premiowy/struktura/nowa'
      fullPath: '/raporty/system-premiowy/struktura/nowa'
      preLoaderRoute: typeof AuthRaportySystemPremiowyStrukturaNowaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/receptura/protokoly_/$id_/drukuj': {
      id: '/_auth/receptura/protokoly_/$id_/drukuj'
      path: '/receptura/protokoly/$id/drukuj'
      fullPath: '/receptura/protokoly/$id/drukuj'
      preLoaderRoute: typeof AuthRecepturaProtokolyIdDrukujRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/receptura/protokoly_/$id_/etykieta': {
      id: '/_auth/receptura/protokoly_/$id_/etykieta'
      path: '/receptura/protokoly/$id/etykieta'
      fullPath: '/receptura/protokoly/$id/etykieta'
      preLoaderRoute: typeof AuthRecepturaProtokolyIdEtykietaRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthStrategCenowyRouteRouteChildren {
  AuthStrategCenowyCennikiCentralneRoute: typeof AuthStrategCenowyCennikiCentralneRoute
  AuthStrategCenowyCennikiWlasneRoute: typeof AuthStrategCenowyCennikiWlasneRoute
  AuthStrategCenowyKalkulatorMarzyRoute: typeof AuthStrategCenowyKalkulatorMarzyRoute
  AuthStrategCenowyKonfiguracjaTopRoute: typeof AuthStrategCenowyKonfiguracjaTopRoute
  AuthStrategCenowyLiderFranczyzaRoute: typeof AuthStrategCenowyLiderFranczyzaRoute
  AuthStrategCenowyModyfikatoryRoute: typeof AuthStrategCenowyModyfikatoryRoute
  AuthStrategCenowyStrategieRoute: typeof AuthStrategCenowyStrategieRoute
  AuthStrategCenowyWykluczeniaRoute: typeof AuthStrategCenowyWykluczeniaRoute
  AuthStrategCenowyWynikiRoute: typeof AuthStrategCenowyWynikiRoute
  AuthStrategCenowyWynikiTopRoute: typeof AuthStrategCenowyWynikiTopRoute
  AuthStrategCenowyIndexRoute: typeof AuthStrategCenowyIndexRoute
}

const AuthStrategCenowyRouteRouteChildren: AuthStrategCenowyRouteRouteChildren =
  {
    AuthStrategCenowyCennikiCentralneRoute:
      AuthStrategCenowyCennikiCentralneRoute,
    AuthStrategCenowyCennikiWlasneRoute: AuthStrategCenowyCennikiWlasneRoute,
    AuthStrategCenowyKalkulatorMarzyRoute:
      AuthStrategCenowyKalkulatorMarzyRoute,
    AuthStrategCenowyKonfiguracjaTopRoute:
      AuthStrategCenowyKonfiguracjaTopRoute,
    AuthStrategCenowyLiderFranczyzaRoute: AuthStrategCenowyLiderFranczyzaRoute,
    AuthStrategCenowyModyfikatoryRoute: AuthStrategCenowyModyfikatoryRoute,
    AuthStrategCenowyStrategieRoute: AuthStrategCenowyStrategieRoute,
    AuthStrategCenowyWykluczeniaRoute: AuthStrategCenowyWykluczeniaRoute,
    AuthStrategCenowyWynikiRoute: AuthStrategCenowyWynikiRoute,
    AuthStrategCenowyWynikiTopRoute: AuthStrategCenowyWynikiTopRoute,
    AuthStrategCenowyIndexRoute: AuthStrategCenowyIndexRoute,
  }

const AuthStrategCenowyRouteRouteWithChildren =
  AuthStrategCenowyRouteRoute._addFileChildren(
    AuthStrategCenowyRouteRouteChildren,
  )

interface AuthDokumentyHurtownicyRouteChildren {
  AuthDokumentyHurtownicyNipRoute: typeof AuthDokumentyHurtownicyNipRoute
}

const AuthDokumentyHurtownicyRouteChildren: AuthDokumentyHurtownicyRouteChildren =
  {
    AuthDokumentyHurtownicyNipRoute: AuthDokumentyHurtownicyNipRoute,
  }

const AuthDokumentyHurtownicyRouteWithChildren =
  AuthDokumentyHurtownicyRoute._addFileChildren(
    AuthDokumentyHurtownicyRouteChildren,
  )

interface AuthDokumentyKsefRouteChildren {
  AuthDokumentyKsefInvoiceIdRoute: typeof AuthDokumentyKsefInvoiceIdRoute
}

const AuthDokumentyKsefRouteChildren: AuthDokumentyKsefRouteChildren = {
  AuthDokumentyKsefInvoiceIdRoute: AuthDokumentyKsefInvoiceIdRoute,
}

const AuthDokumentyKsefRouteWithChildren =
  AuthDokumentyKsefRoute._addFileChildren(AuthDokumentyKsefRouteChildren)

interface AuthKontraktyRozliczeniaZakupIdRouteChildren {
  AuthKontraktyRozliczeniaZakupIdAnalizaDzialZakupowRoute: typeof AuthKontraktyRozliczeniaZakupIdAnalizaDzialZakupowRoute
  AuthKontraktyRozliczeniaZakupIdAnalizaPerSpolkaRoute: typeof AuthKontraktyRozliczeniaZakupIdAnalizaPerSpolkaRoute
}

const AuthKontraktyRozliczeniaZakupIdRouteChildren: AuthKontraktyRozliczeniaZakupIdRouteChildren =
  {
    AuthKontraktyRozliczeniaZakupIdAnalizaDzialZakupowRoute:
      AuthKontraktyRozliczeniaZakupIdAnalizaDzialZakupowRoute,
    AuthKontraktyRozliczeniaZakupIdAnalizaPerSpolkaRoute:
      AuthKontraktyRozliczeniaZakupIdAnalizaPerSpolkaRoute,
  }

const AuthKontraktyRozliczeniaZakupIdRouteWithChildren =
  AuthKontraktyRozliczeniaZakupIdRoute._addFileChildren(
    AuthKontraktyRozliczeniaZakupIdRouteChildren,
  )

interface AuthKontraktyRozliczeniaIdRouteChildren {
  AuthKontraktyRozliczeniaIdMiesiecznieRoute: typeof AuthKontraktyRozliczeniaIdMiesiecznieRoute
  AuthKontraktyRozliczeniaIdPoSpolceRoute: typeof AuthKontraktyRozliczeniaIdPoSpolceRoute
}

const AuthKontraktyRozliczeniaIdRouteChildren: AuthKontraktyRozliczeniaIdRouteChildren =
  {
    AuthKontraktyRozliczeniaIdMiesiecznieRoute:
      AuthKontraktyRozliczeniaIdMiesiecznieRoute,
    AuthKontraktyRozliczeniaIdPoSpolceRoute:
      AuthKontraktyRozliczeniaIdPoSpolceRoute,
  }

const AuthKontraktyRozliczeniaIdRouteWithChildren =
  AuthKontraktyRozliczeniaIdRoute._addFileChildren(
    AuthKontraktyRozliczeniaIdRouteChildren,
  )

interface AuthRouteChildren {
  AuthStrategCenowyRouteRoute: typeof AuthStrategCenowyRouteRouteWithChildren
  AuthAsystentRoute: typeof AuthAsystentRoute
  AuthAsystentJakoscRoute: typeof AuthAsystentJakoscRoute
  AuthAsystentKosztyRoute: typeof AuthAsystentKosztyRoute
  AuthAsystentStatystykiAptekRoute: typeof AuthAsystentStatystykiAptekRoute
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthMojProfilRoute: typeof AuthMojProfilRoute
  AuthApteneoPorownanieRoute: typeof AuthApteneoPorownanieRoute
  AuthApteneoRozliczeniaRoute: typeof AuthApteneoRozliczeniaRoute
  AuthApteneoZaczytajDaneRoute: typeof AuthApteneoZaczytajDaneRoute
  AuthApteneoZakupyRoute: typeof AuthApteneoZakupyRoute
  AuthDokumentyHurtownicyRoute: typeof AuthDokumentyHurtownicyRouteWithChildren
  AuthDokumentyKalendarzPlatnosciRoute: typeof AuthDokumentyKalendarzPlatnosciRoute
  AuthDokumentyKsefRoute: typeof AuthDokumentyKsefRouteWithChildren
  AuthHelpdeskAwariaRoute: typeof AuthHelpdeskAwariaRoute
  AuthHelpdeskCzatRoute: typeof AuthHelpdeskCzatRoute
  AuthHelpdeskKonfiguracjaRoute: typeof AuthHelpdeskKonfiguracjaRoute
  AuthHelpdeskSzukajRoute: typeof AuthHelpdeskSzukajRoute
  AuthHelpdeskZarzadzanieRoute: typeof AuthHelpdeskZarzadzanieRoute
  AuthKartotekaCennikNajtaniejRoute: typeof AuthKartotekaCennikNajtaniejRoute
  AuthKartotekaCennikZgodnoscRoute: typeof AuthKartotekaCennikZgodnoscRoute
  AuthKartotekaCennikiHistoriaRoute: typeof AuthKartotekaCennikiHistoriaRoute
  AuthKartotekaCennikiPodgladRoute: typeof AuthKartotekaCennikiPodgladRoute
  AuthKartotekaGrupyProduktowRoute: typeof AuthKartotekaGrupyProduktowRoute
  AuthKartotekaKategoryzacjaRoute: typeof AuthKartotekaKategoryzacjaRoute
  AuthKartotekaKontrahenciRoute: typeof AuthKartotekaKontrahenciRoute
  AuthKartotekaMapowanieApcRoute: typeof AuthKartotekaMapowanieApcRoute
  AuthKartotekaProducenciRoute: typeof AuthKartotekaProducenciRoute
  AuthKartotekaStanMagazynuRoute: typeof AuthKartotekaStanMagazynuRoute
  AuthKartotekaTowaryRoute: typeof AuthKartotekaTowaryRoute
  AuthKonfiguracjaAiRoute: typeof AuthKonfiguracjaAiRoute
  AuthKonfiguracjaAktualizacjeRoute: typeof AuthKonfiguracjaAktualizacjeRoute
  AuthKonfiguracjaAptekiRoute: typeof AuthKonfiguracjaAptekiRoute
  AuthKonfiguracjaAuditLogRoute: typeof AuthKonfiguracjaAuditLogRoute
  AuthKonfiguracjaDrukarkiRoute: typeof AuthKonfiguracjaDrukarkiRoute
  AuthKonfiguracjaDyskiRoute: typeof AuthKonfiguracjaDyskiRoute
  AuthKonfiguracjaEksportyPlikoweRoute: typeof AuthKonfiguracjaEksportyPlikoweRoute
  AuthKonfiguracjaEmailRoute: typeof AuthKonfiguracjaEmailRoute
  AuthKonfiguracjaEmailLogRoute: typeof AuthKonfiguracjaEmailLogRoute
  AuthKonfiguracjaGrupyAptekRoute: typeof AuthKonfiguracjaGrupyAptekRoute
  AuthKonfiguracjaGrupyOrganizacyjneRoute: typeof AuthKonfiguracjaGrupyOrganizacyjneRoute
  AuthKonfiguracjaGrupyUzytkownikowRoute: typeof AuthKonfiguracjaGrupyUzytkownikowRoute
  AuthKonfiguracjaHarmonogramyPowiadomienRoute: typeof AuthKonfiguracjaHarmonogramyPowiadomienRoute
  AuthKonfiguracjaHarmonogramyRaportowRoute: typeof AuthKonfiguracjaHarmonogramyRaportowRoute
  AuthKonfiguracjaImportMshrRoute: typeof AuthKonfiguracjaImportMshrRoute
  AuthKonfiguracjaIqviaRoute: typeof AuthKonfiguracjaIqviaRoute
  AuthKonfiguracjaKsefRoute: typeof AuthKonfiguracjaKsefRoute
  AuthKonfiguracjaKsefCertyfikatyRoute: typeof AuthKonfiguracjaKsefCertyfikatyRoute
  AuthKonfiguracjaKsefOsozEdiRoute: typeof AuthKonfiguracjaKsefOsozEdiRoute
  AuthKonfiguracjaMcpRoute: typeof AuthKonfiguracjaMcpRoute
  AuthKonfiguracjaMcpStatystykiRoute: typeof AuthKonfiguracjaMcpStatystykiRoute
  AuthKonfiguracjaOrganizacjeRoute: typeof AuthKonfiguracjaOrganizacjeRoute
  AuthKonfiguracjaPodgladUzytkownikaRoute: typeof AuthKonfiguracjaPodgladUzytkownikaRoute
  AuthKonfiguracjaPracownicyRoute: typeof AuthKonfiguracjaPracownicyRoute
  AuthKonfiguracjaRegulyZdarzenRoute: typeof AuthKonfiguracjaRegulyZdarzenRoute
  AuthKonfiguracjaSfyRoute: typeof AuthKonfiguracjaSfyRoute
  AuthKonfiguracjaSmsRoute: typeof AuthKonfiguracjaSmsRoute
  AuthKonfiguracjaSpolkiRoute: typeof AuthKonfiguracjaSpolkiRoute
  AuthKonfiguracjaSqlKonsolaRoute: typeof AuthKonfiguracjaSqlKonsolaRoute
  AuthKonfiguracjaSqlSfyRoute: typeof AuthKonfiguracjaSqlSfyRoute
  AuthKonfiguracjaStatystykiUzyciaRoute: typeof AuthKonfiguracjaStatystykiUzyciaRoute
  AuthKonfiguracjaSystemRoute: typeof AuthKonfiguracjaSystemRoute
  AuthKonfiguracjaTokenyApiRoute: typeof AuthKonfiguracjaTokenyApiRoute
  AuthKonfiguracjaUrzadzeniaRoute: typeof AuthKonfiguracjaUrzadzeniaRoute
  AuthKonfiguracjaUzytkownicyRoute: typeof AuthKonfiguracjaUzytkownicyRoute
  AuthKontraktyIdRoute: typeof AuthKontraktyIdRoute
  AuthKontraktyAptekiProducentowRoute: typeof AuthKontraktyAptekiProducentowRoute
  AuthKontraktyAptekiProducentowHistoriaRoute: typeof AuthKontraktyAptekiProducentowHistoriaRoute
  AuthKontraktyNieaktywneAptekiRoute: typeof AuthKontraktyNieaktywneAptekiRoute
  AuthKontraktyNowyRoute: typeof AuthKontraktyNowyRoute
  AuthKontraktyPorownanieZProducentemRoute: typeof AuthKontraktyPorownanieZProducentemRoute
  AuthKontraktyProducenciDzzfRoute: typeof AuthKontraktyProducenciDzzfRoute
  AuthKontraktyUdzialRoute: typeof AuthKontraktyUdzialRoute
  AuthKontraktyWykonanieRoute: typeof AuthKontraktyWykonanieRoute
  AuthRaportyAnalizaZakupowNoweZamRoute: typeof AuthRaportyAnalizaZakupowNoweZamRoute
  AuthRaportyAnalizaZakupyIndeksowRoute: typeof AuthRaportyAnalizaZakupyIndeksowRoute
  AuthRaportyDashboardAnalitycznyRoute: typeof AuthRaportyDashboardAnalitycznyRoute
  AuthRaportyDashboardMagazynSzczegolRoute: typeof AuthRaportyDashboardMagazynSzczegolRoute
  AuthRaportyDatyWaznosciRoute: typeof AuthRaportyDatyWaznosciRoute
  AuthRaportyDynamikaSprzedazyRoute: typeof AuthRaportyDynamikaSprzedazyRoute
  AuthRaportyEcomRoute: typeof AuthRaportyEcomRoute
  AuthRaportyJakoscDanychWyjatkiRoute: typeof AuthRaportyJakoscDanychWyjatkiRoute
  AuthRaportyKategoriaKwartalnaRoute: typeof AuthRaportyKategoriaKwartalnaRoute
  AuthRaportyLukiPowiazanRoute: typeof AuthRaportyLukiPowiazanRoute
  AuthRaportyOdchyleniaCenFvRoute: typeof AuthRaportyOdchyleniaCenFvRoute
  AuthRaportyRaportProduktowyRoute: typeof AuthRaportyRaportProduktowyRoute
  AuthRaportyRozkladMarzRoute: typeof AuthRaportyRozkladMarzRoute
  AuthRaportySprzOpiekunRoute: typeof AuthRaportySprzOpiekunRoute
  AuthRaportySprzWynikRoute: typeof AuthRaportySprzWynikRoute
  AuthRaportySprz_kasjer_dataRoute: typeof AuthRaportySprz_kasjer_dataRoute
  AuthRaportySprzedazDziennaRoute: typeof AuthRaportySprzedazDziennaRoute
  AuthRaportySprzedazZrealizowanaRoute: typeof AuthRaportySprzedazZrealizowanaRoute
  AuthRaportyUjemneMarzeRoute: typeof AuthRaportyUjemneMarzeRoute
  AuthRaportyWeryfikacjaTowrRoute: typeof AuthRaportyWeryfikacjaTowrRoute
  AuthRaportyWyprzedazMagazynuRoute: typeof AuthRaportyWyprzedazMagazynuRoute
  AuthRaportyZmianyBlozuRoute: typeof AuthRaportyZmianyBlozuRoute
  AuthRaportyZwrotyDzienneRoute: typeof AuthRaportyZwrotyDzienneRoute
  AuthRaportyZwrotyKwartalneRoute: typeof AuthRaportyZwrotyKwartalneRoute
  AuthRdaAnalizaKorzysciRoute: typeof AuthRdaAnalizaKorzysciRoute
  AuthRdaListaOfertFm1Route: typeof AuthRdaListaOfertFm1Route
  AuthRecepturaProtokolyRoute: typeof AuthRecepturaProtokolyRoute
  AuthRecepturaSurowceRoute: typeof AuthRecepturaSurowceRoute
  AuthRecepturaSzablonyRoute: typeof AuthRecepturaSzablonyRoute
  AuthSmsKampanieRoute: typeof AuthSmsKampanieRoute
  AuthSmsKontaktyRoute: typeof AuthSmsKontaktyRoute
  AuthSmsSzablonyRoute: typeof AuthSmsSzablonyRoute
  AuthSmsZuzycieRoute: typeof AuthSmsZuzycieRoute
  AuthSynchronizacjaKonsolaSqlRoute: typeof AuthSynchronizacjaKonsolaSqlRoute
  AuthSynchronizacjaZatwierdzeniaSqlRoute: typeof AuthSynchronizacjaZatwierdzeniaSqlRoute
  AuthDokumentyIndexRoute: typeof AuthDokumentyIndexRoute
  AuthHelpdeskIndexRoute: typeof AuthHelpdeskIndexRoute
  AuthKonfiguracjaIndexRoute: typeof AuthKonfiguracjaIndexRoute
  AuthKontraktyIndexRoute: typeof AuthKontraktyIndexRoute
  AuthSmsIndexRoute: typeof AuthSmsIndexRoute
  AuthKonfiguracjaIssueResolveNumberRoute: typeof AuthKonfiguracjaIssueResolveNumberRoute
  AuthKonfiguracjaSfyPrzegladRoute: typeof AuthKonfiguracjaSfyPrzegladRoute
  AuthKontraktyAptekiGapIdRoute: typeof AuthKontraktyAptekiGapIdRoute
  AuthKontraktyAptekiGapNowyRoute: typeof AuthKontraktyAptekiGapNowyRoute
  AuthKontraktyCennikiExfactoryIdRoute: typeof AuthKontraktyCennikiExfactoryIdRoute
  AuthKontraktyCennikiExfactoryNowyRoute: typeof AuthKontraktyCennikiExfactoryNowyRoute
  AuthKontraktyDoplatyGapIdRoute: typeof AuthKontraktyDoplatyGapIdRoute
  AuthKontraktyDoplatyGapNowyRoute: typeof AuthKontraktyDoplatyGapNowyRoute
  AuthKontraktyLiderZakupyIdRoute: typeof AuthKontraktyLiderZakupyIdRoute
  AuthKontraktyLiderZakupyNowyRoute: typeof AuthKontraktyLiderZakupyNowyRoute
  AuthKontraktyMslDostepnoscIdRoute: typeof AuthKontraktyMslDostepnoscIdRoute
  AuthKontraktyMslDostepnoscNowyRoute: typeof AuthKontraktyMslDostepnoscNowyRoute
  AuthKontraktyPorownanieIdRoute: typeof AuthKontraktyPorownanieIdRoute
  AuthKontraktyRaportyKontraktRoute: typeof AuthKontraktyRaportyKontraktRoute
  AuthKontraktyRaportyLiderRoute: typeof AuthKontraktyRaportyLiderRoute
  AuthKontraktyRaportyPodsumowanieRoute: typeof AuthKontraktyRaportyPodsumowanieRoute
  AuthKontraktyRaportyProducentRoute: typeof AuthKontraktyRaportyProducentRoute
  AuthKontraktyRozliczeniaZakupIdRoute: typeof AuthKontraktyRozliczeniaZakupIdRouteWithChildren
  AuthKontraktyRozliczeniaIdRoute: typeof AuthKontraktyRozliczeniaIdRouteWithChildren
  AuthKontraktyRozliczeniaAktywnoscAptekRoute: typeof AuthKontraktyRozliczeniaAktywnoscAptekRoute
  AuthKontraktyRozliczeniaPrognozaWstecznaRoute: typeof AuthKontraktyRozliczeniaPrognozaWstecznaRoute
  AuthKontraktyRozliczeniaProporcjeKanalowRoute: typeof AuthKontraktyRozliczeniaProporcjeKanalowRoute
  AuthKontraktyWeryfikacjaWysylekIdRoute: typeof AuthKontraktyWeryfikacjaWysylekIdRoute
  AuthKontraktyWeryfikacjaWysylekKlienciRoute: typeof AuthKontraktyWeryfikacjaWysylekKlienciRoute
  AuthKontraktyWeryfikacjaWysylekPolaczeniaRoute: typeof AuthKontraktyWeryfikacjaWysylekPolaczeniaRoute
  AuthRaportySystemPremiowyLiderSzczegolowoRoute: typeof AuthRaportySystemPremiowyLiderSzczegolowoRoute
  AuthRaportyWeryfikacjaSprzedazyFakturaDoParagonuRoute: typeof AuthRaportyWeryfikacjaSprzedazyFakturaDoParagonuRoute
  AuthRaportyWeryfikacjaSprzedazyZmianyRoute: typeof AuthRaportyWeryfikacjaSprzedazyZmianyRoute
  AuthRdaListaOfertFm1OfferIdRoute: typeof AuthRdaListaOfertFm1OfferIdRoute
  AuthRecepturaProtokolyIdRoute: typeof AuthRecepturaProtokolyIdRoute
  AuthSynchronizacjaAptekiIdfirmRoute: typeof AuthSynchronizacjaAptekiIdfirmRoute
  AuthKonfiguracjaIssueResolveIndexRoute: typeof AuthKonfiguracjaIssueResolveIndexRoute
  AuthKontraktyAptekiGapIndexRoute: typeof AuthKontraktyAptekiGapIndexRoute
  AuthKontraktyCennikiExfactoryIndexRoute: typeof AuthKontraktyCennikiExfactoryIndexRoute
  AuthKontraktyDoplatyGapIndexRoute: typeof AuthKontraktyDoplatyGapIndexRoute
  AuthKontraktyLiderZakupyIndexRoute: typeof AuthKontraktyLiderZakupyIndexRoute
  AuthKontraktyMslDostepnoscIndexRoute: typeof AuthKontraktyMslDostepnoscIndexRoute
  AuthKontraktyPorownanieIndexRoute: typeof AuthKontraktyPorownanieIndexRoute
  AuthKontraktyRaportyIndexRoute: typeof AuthKontraktyRaportyIndexRoute
  AuthKontraktyRozliczeniaZakupIndexRoute: typeof AuthKontraktyRozliczeniaZakupIndexRoute
  AuthKontraktyRozliczeniaIndexRoute: typeof AuthKontraktyRozliczeniaIndexRoute
  AuthKontraktyWeryfikacjaWysylekIndexRoute: typeof AuthKontraktyWeryfikacjaWysylekIndexRoute
  AuthRaportySprzWybranychBlozowIndexRoute: typeof AuthRaportySprzWybranychBlozowIndexRoute
  AuthRaportyWeryfikacjaSprzedazyIndexRoute: typeof AuthRaportyWeryfikacjaSprzedazyIndexRoute
  AuthSynchronizacjaAptekiIndexRoute: typeof AuthSynchronizacjaAptekiIndexRoute
  AuthRaportySprzWybranychBlozowParametryIdRoute: typeof AuthRaportySprzWybranychBlozowParametryIdRoute
  AuthRaportySprzWybranychBlozowParametryNowyRoute: typeof AuthRaportySprzWybranychBlozowParametryNowyRoute
  AuthRaportySystemPremiowyLiderIdRoute: typeof AuthRaportySystemPremiowyLiderIdRoute
  AuthRaportySystemPremiowyLiderNowyRoute: typeof AuthRaportySystemPremiowyLiderNowyRoute
  AuthRaportySystemPremiowyProgramPartnerskiIdRoute: typeof AuthRaportySystemPremiowyProgramPartnerskiIdRoute
  AuthRaportySystemPremiowyProgramPartnerskiNowyRoute: typeof AuthRaportySystemPremiowyProgramPartnerskiNowyRoute
  AuthRaportySystemPremiowyRentownoscIdRoute: typeof AuthRaportySystemPremiowyRentownoscIdRoute
  AuthRaportySystemPremiowyRentownoscNowaRoute: typeof AuthRaportySystemPremiowyRentownoscNowaRoute
  AuthRaportySystemPremiowyStrukturaIdRoute: typeof AuthRaportySystemPremiowyStrukturaIdRoute
  AuthRaportySystemPremiowyStrukturaNowaRoute: typeof AuthRaportySystemPremiowyStrukturaNowaRoute
  AuthRecepturaProtokolyIdDrukujRoute: typeof AuthRecepturaProtokolyIdDrukujRoute
  AuthRecepturaProtokolyIdEtykietaRoute: typeof AuthRecepturaProtokolyIdEtykietaRoute
  AuthRaportySprzWybranychBlozowParametryIndexRoute: typeof AuthRaportySprzWybranychBlozowParametryIndexRoute
  AuthRaportySystemPremiowyLiderIndexRoute: typeof AuthRaportySystemPremiowyLiderIndexRoute
  AuthRaportySystemPremiowyProgramPartnerskiIndexRoute: typeof AuthRaportySystemPremiowyProgramPartnerskiIndexRoute
  AuthRaportySystemPremiowyRentownoscIndexRoute: typeof AuthRaportySystemPremiowyRentownoscIndexRoute
  AuthRaportySystemPremiowyStrukturaIndexRoute: typeof AuthRaportySystemPremiowyStrukturaIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthStrategCenowyRouteRoute: AuthStrategCenowyRouteRouteWithChildren,
  AuthAsystentRoute: AuthAsystentRoute,
  AuthAsystentJakoscRoute: AuthAsystentJakoscRoute,
  AuthAsystentKosztyRoute: AuthAsystentKosztyRoute,
  AuthAsystentStatystykiAptekRoute: AuthAsystentStatystykiAptekRoute,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthMojProfilRoute: AuthMojProfilRoute,
  AuthApteneoPorownanieRoute: AuthApteneoPorownanieRoute,
  AuthApteneoRozliczeniaRoute: AuthApteneoRozliczeniaRoute,
  AuthApteneoZaczytajDaneRoute: AuthApteneoZaczytajDaneRoute,
  AuthApteneoZakupyRoute: AuthApteneoZakupyRoute,
  AuthDokumentyHurtownicyRoute: AuthDokumentyHurtownicyRouteWithChildren,
  AuthDokumentyKalendarzPlatnosciRoute: AuthDokumentyKalendarzPlatnosciRoute,
  AuthDokumentyKsefRoute: AuthDokumentyKsefRouteWithChildren,
  AuthHelpdeskAwariaRoute: AuthHelpdeskAwariaRoute,
  AuthHelpdeskCzatRoute: AuthHelpdeskCzatRoute,
  AuthHelpdeskKonfiguracjaRoute: AuthHelpdeskKonfiguracjaRoute,
  AuthHelpdeskSzukajRoute: AuthHelpdeskSzukajRoute,
  AuthHelpdeskZarzadzanieRoute: AuthHelpdeskZarzadzanieRoute,
  AuthKartotekaCennikNajtaniejRoute: AuthKartotekaCennikNajtaniejRoute,
  AuthKartotekaCennikZgodnoscRoute: AuthKartotekaCennikZgodnoscRoute,
  AuthKartotekaCennikiHistoriaRoute: AuthKartotekaCennikiHistoriaRoute,
  AuthKartotekaCennikiPodgladRoute: AuthKartotekaCennikiPodgladRoute,
  AuthKartotekaGrupyProduktowRoute: AuthKartotekaGrupyProduktowRoute,
  AuthKartotekaKategoryzacjaRoute: AuthKartotekaKategoryzacjaRoute,
  AuthKartotekaKontrahenciRoute: AuthKartotekaKontrahenciRoute,
  AuthKartotekaMapowanieApcRoute: AuthKartotekaMapowanieApcRoute,
  AuthKartotekaProducenciRoute: AuthKartotekaProducenciRoute,
  AuthKartotekaStanMagazynuRoute: AuthKartotekaStanMagazynuRoute,
  AuthKartotekaTowaryRoute: AuthKartotekaTowaryRoute,
  AuthKonfiguracjaAiRoute: AuthKonfiguracjaAiRoute,
  AuthKonfiguracjaAktualizacjeRoute: AuthKonfiguracjaAktualizacjeRoute,
  AuthKonfiguracjaAptekiRoute: AuthKonfiguracjaAptekiRoute,
  AuthKonfiguracjaAuditLogRoute: AuthKonfiguracjaAuditLogRoute,
  AuthKonfiguracjaDrukarkiRoute: AuthKonfiguracjaDrukarkiRoute,
  AuthKonfiguracjaDyskiRoute: AuthKonfiguracjaDyskiRoute,
  AuthKonfiguracjaEksportyPlikoweRoute: AuthKonfiguracjaEksportyPlikoweRoute,
  AuthKonfiguracjaEmailRoute: AuthKonfiguracjaEmailRoute,
  AuthKonfiguracjaEmailLogRoute: AuthKonfiguracjaEmailLogRoute,
  AuthKonfiguracjaGrupyAptekRoute: AuthKonfiguracjaGrupyAptekRoute,
  AuthKonfiguracjaGrupyOrganizacyjneRoute:
    AuthKonfiguracjaGrupyOrganizacyjneRoute,
  AuthKonfiguracjaGrupyUzytkownikowRoute:
    AuthKonfiguracjaGrupyUzytkownikowRoute,
  AuthKonfiguracjaHarmonogramyPowiadomienRoute:
    AuthKonfiguracjaHarmonogramyPowiadomienRoute,
  AuthKonfiguracjaHarmonogramyRaportowRoute:
    AuthKonfiguracjaHarmonogramyRaportowRoute,
  AuthKonfiguracjaImportMshrRoute: AuthKonfiguracjaImportMshrRoute,
  AuthKonfiguracjaIqviaRoute: AuthKonfiguracjaIqviaRoute,
  AuthKonfiguracjaKsefRoute: AuthKonfiguracjaKsefRoute,
  AuthKonfiguracjaKsefCertyfikatyRoute: AuthKonfiguracjaKsefCertyfikatyRoute,
  AuthKonfiguracjaKsefOsozEdiRoute: AuthKonfiguracjaKsefOsozEdiRoute,
  AuthKonfiguracjaMcpRoute: AuthKonfiguracjaMcpRoute,
  AuthKonfiguracjaMcpStatystykiRoute: AuthKonfiguracjaMcpStatystykiRoute,
  AuthKonfiguracjaOrganizacjeRoute: AuthKonfiguracjaOrganizacjeRoute,
  AuthKonfiguracjaPodgladUzytkownikaRoute:
    AuthKonfiguracjaPodgladUzytkownikaRoute,
  AuthKonfiguracjaPracownicyRoute: AuthKonfiguracjaPracownicyRoute,
  AuthKonfiguracjaRegulyZdarzenRoute: AuthKonfiguracjaRegulyZdarzenRoute,
  AuthKonfiguracjaSfyRoute: AuthKonfiguracjaSfyRoute,
  AuthKonfiguracjaSmsRoute: AuthKonfiguracjaSmsRoute,
  AuthKonfiguracjaSpolkiRoute: AuthKonfiguracjaSpolkiRoute,
  AuthKonfiguracjaSqlKonsolaRoute: AuthKonfiguracjaSqlKonsolaRoute,
  AuthKonfiguracjaSqlSfyRoute: AuthKonfiguracjaSqlSfyRoute,
  AuthKonfiguracjaStatystykiUzyciaRoute: AuthKonfiguracjaStatystykiUzyciaRoute,
  AuthKonfiguracjaSystemRoute: AuthKonfiguracjaSystemRoute,
  AuthKonfiguracjaTokenyApiRoute: AuthKonfiguracjaTokenyApiRoute,
  AuthKonfiguracjaUrzadzeniaRoute: AuthKonfiguracjaUrzadzeniaRoute,
  AuthKonfiguracjaUzytkownicyRoute: AuthKonfiguracjaUzytkownicyRoute,
  AuthKontraktyIdRoute: AuthKontraktyIdRoute,
  AuthKontraktyAptekiProducentowRoute: AuthKontraktyAptekiProducentowRoute,
  AuthKontraktyAptekiProducentowHistoriaRoute:
    AuthKontraktyAptekiProducentowHistoriaRoute,
  AuthKontraktyNieaktywneAptekiRoute: AuthKontraktyNieaktywneAptekiRoute,
  AuthKontraktyNowyRoute: AuthKontraktyNowyRoute,
  AuthKontraktyPorownanieZProducentemRoute:
    AuthKontraktyPorownanieZProducentemRoute,
  AuthKontraktyProducenciDzzfRoute: AuthKontraktyProducenciDzzfRoute,
  AuthKontraktyUdzialRoute: AuthKontraktyUdzialRoute,
  AuthKontraktyWykonanieRoute: AuthKontraktyWykonanieRoute,
  AuthRaportyAnalizaZakupowNoweZamRoute: AuthRaportyAnalizaZakupowNoweZamRoute,
  AuthRaportyAnalizaZakupyIndeksowRoute: AuthRaportyAnalizaZakupyIndeksowRoute,
  AuthRaportyDashboardAnalitycznyRoute: AuthRaportyDashboardAnalitycznyRoute,
  AuthRaportyDashboardMagazynSzczegolRoute:
    AuthRaportyDashboardMagazynSzczegolRoute,
  AuthRaportyDatyWaznosciRoute: AuthRaportyDatyWaznosciRoute,
  AuthRaportyDynamikaSprzedazyRoute: AuthRaportyDynamikaSprzedazyRoute,
  AuthRaportyEcomRoute: AuthRaportyEcomRoute,
  AuthRaportyJakoscDanychWyjatkiRoute: AuthRaportyJakoscDanychWyjatkiRoute,
  AuthRaportyKategoriaKwartalnaRoute: AuthRaportyKategoriaKwartalnaRoute,
  AuthRaportyLukiPowiazanRoute: AuthRaportyLukiPowiazanRoute,
  AuthRaportyOdchyleniaCenFvRoute: AuthRaportyOdchyleniaCenFvRoute,
  AuthRaportyRaportProduktowyRoute: AuthRaportyRaportProduktowyRoute,
  AuthRaportyRozkladMarzRoute: AuthRaportyRozkladMarzRoute,
  AuthRaportySprzOpiekunRoute: AuthRaportySprzOpiekunRoute,
  AuthRaportySprzWynikRoute: AuthRaportySprzWynikRoute,
  AuthRaportySprz_kasjer_dataRoute: AuthRaportySprz_kasjer_dataRoute,
  AuthRaportySprzedazDziennaRoute: AuthRaportySprzedazDziennaRoute,
  AuthRaportySprzedazZrealizowanaRoute: AuthRaportySprzedazZrealizowanaRoute,
  AuthRaportyUjemneMarzeRoute: AuthRaportyUjemneMarzeRoute,
  AuthRaportyWeryfikacjaTowrRoute: AuthRaportyWeryfikacjaTowrRoute,
  AuthRaportyWyprzedazMagazynuRoute: AuthRaportyWyprzedazMagazynuRoute,
  AuthRaportyZmianyBlozuRoute: AuthRaportyZmianyBlozuRoute,
  AuthRaportyZwrotyDzienneRoute: AuthRaportyZwrotyDzienneRoute,
  AuthRaportyZwrotyKwartalneRoute: AuthRaportyZwrotyKwartalneRoute,
  AuthRdaAnalizaKorzysciRoute: AuthRdaAnalizaKorzysciRoute,
  AuthRdaListaOfertFm1Route: AuthRdaListaOfertFm1Route,
  AuthRecepturaProtokolyRoute: AuthRecepturaProtokolyRoute,
  AuthRecepturaSurowceRoute: AuthRecepturaSurowceRoute,
  AuthRecepturaSzablonyRoute: AuthRecepturaSzablonyRoute,
  AuthSmsKampanieRoute: AuthSmsKampanieRoute,
  AuthSmsKontaktyRoute: AuthSmsKontaktyRoute,
  AuthSmsSzablonyRoute: AuthSmsSzablonyRoute,
  AuthSmsZuzycieRoute: AuthSmsZuzycieRoute,
  AuthSynchronizacjaKonsolaSqlRoute: AuthSynchronizacjaKonsolaSqlRoute,
  AuthSynchronizacjaZatwierdzeniaSqlRoute:
    AuthSynchronizacjaZatwierdzeniaSqlRoute,
  AuthDokumentyIndexRoute: AuthDokumentyIndexRoute,
  AuthHelpdeskIndexRoute: AuthHelpdeskIndexRoute,
  AuthKonfiguracjaIndexRoute: AuthKonfiguracjaIndexRoute,
  AuthKontraktyIndexRoute: AuthKontraktyIndexRoute,
  AuthSmsIndexRoute: AuthSmsIndexRoute,
  AuthKonfiguracjaIssueResolveNumberRoute:
    AuthKonfiguracjaIssueResolveNumberRoute,
  AuthKonfiguracjaSfyPrzegladRoute: AuthKonfiguracjaSfyPrzegladRoute,
  AuthKontraktyAptekiGapIdRoute: AuthKontraktyAptekiGapIdRoute,
  AuthKontraktyAptekiGapNowyRoute: AuthKontraktyAptekiGapNowyRoute,
  AuthKontraktyCennikiExfactoryIdRoute: AuthKontraktyCennikiExfactoryIdRoute,
  AuthKontraktyCennikiExfactoryNowyRoute:
    AuthKontraktyCennikiExfactoryNowyRoute,
  AuthKontraktyDoplatyGapIdRoute: AuthKontraktyDoplatyGapIdRoute,
  AuthKontraktyDoplatyGapNowyRoute: AuthKontraktyDoplatyGapNowyRoute,
  AuthKontraktyLiderZakupyIdRoute: AuthKontraktyLiderZakupyIdRoute,
  AuthKontraktyLiderZakupyNowyRoute: AuthKontraktyLiderZakupyNowyRoute,
  AuthKontraktyMslDostepnoscIdRoute: AuthKontraktyMslDostepnoscIdRoute,
  AuthKontraktyMslDostepnoscNowyRoute: AuthKontraktyMslDostepnoscNowyRoute,
  AuthKontraktyPorownanieIdRoute: AuthKontraktyPorownanieIdRoute,
  AuthKontraktyRaportyKontraktRoute: AuthKontraktyRaportyKontraktRoute,
  AuthKontraktyRaportyLiderRoute: AuthKontraktyRaportyLiderRoute,
  AuthKontraktyRaportyPodsumowanieRoute: AuthKontraktyRaportyPodsumowanieRoute,
  AuthKontraktyRaportyProducentRoute: AuthKontraktyRaportyProducentRoute,
  AuthKontraktyRozliczeniaZakupIdRoute:
    AuthKontraktyRozliczeniaZakupIdRouteWithChildren,
  AuthKontraktyRozliczeniaIdRoute: AuthKontraktyRozliczeniaIdRouteWithChildren,
  AuthKontraktyRozliczeniaAktywnoscAptekRoute:
    AuthKontraktyRozliczeniaAktywnoscAptekRoute,
  AuthKontraktyRozliczeniaPrognozaWstecznaRoute:
    AuthKontraktyRozliczeniaPrognozaWstecznaRoute,
  AuthKontraktyRozliczeniaProporcjeKanalowRoute:
    AuthKontraktyRozliczeniaProporcjeKanalowRoute,
  AuthKontraktyWeryfikacjaWysylekIdRoute:
    AuthKontraktyWeryfikacjaWysylekIdRoute,
  AuthKontraktyWeryfikacjaWysylekKlienciRoute:
    AuthKontraktyWeryfikacjaWysylekKlienciRoute,
  AuthKontraktyWeryfikacjaWysylekPolaczeniaRoute:
    AuthKontraktyWeryfikacjaWysylekPolaczeniaRoute,
  AuthRaportySystemPremiowyLiderSzczegolowoRoute:
    AuthRaportySystemPremiowyLiderSzczegolowoRoute,
  AuthRaportyWeryfikacjaSprzedazyFakturaDoParagonuRoute:
    AuthRaportyWeryfikacjaSprzedazyFakturaDoParagonuRoute,
  AuthRaportyWeryfikacjaSprzedazyZmianyRoute:
    AuthRaportyWeryfikacjaSprzedazyZmianyRoute,
  AuthRdaListaOfertFm1OfferIdRoute: AuthRdaListaOfertFm1OfferIdRoute,
  AuthRecepturaProtokolyIdRoute: AuthRecepturaProtokolyIdRoute,
  AuthSynchronizacjaAptekiIdfirmRoute: AuthSynchronizacjaAptekiIdfirmRoute,
  AuthKonfiguracjaIssueResolveIndexRoute:
    AuthKonfiguracjaIssueResolveIndexRoute,
  AuthKontraktyAptekiGapIndexRoute: AuthKontraktyAptekiGapIndexRoute,
  AuthKontraktyCennikiExfactoryIndexRoute:
    AuthKontraktyCennikiExfactoryIndexRoute,
  AuthKontraktyDoplatyGapIndexRoute: AuthKontraktyDoplatyGapIndexRoute,
  AuthKontraktyLiderZakupyIndexRoute: AuthKontraktyLiderZakupyIndexRoute,
  AuthKontraktyMslDostepnoscIndexRoute: AuthKontraktyMslDostepnoscIndexRoute,
  AuthKontraktyPorownanieIndexRoute: AuthKontraktyPorownanieIndexRoute,
  AuthKontraktyRaportyIndexRoute: AuthKontraktyRaportyIndexRoute,
  AuthKontraktyRozliczeniaZakupIndexRoute:
    AuthKontraktyRozliczeniaZakupIndexRoute,
  AuthKontraktyRozliczeniaIndexRoute: AuthKontraktyRozliczeniaIndexRoute,
  AuthKontraktyWeryfikacjaWysylekIndexRoute:
    AuthKontraktyWeryfikacjaWysylekIndexRoute,
  AuthRaportySprzWybranychBlozowIndexRoute:
    AuthRaportySprzWybranychBlozowIndexRoute,
  AuthRaportyWeryfikacjaSprzedazyIndexRoute:
    AuthRaportyWeryfikacjaSprzedazyIndexRoute,
  AuthSynchronizacjaAptekiIndexRoute: AuthSynchronizacjaAptekiIndexRoute,
  AuthRaportySprzWybranychBlozowParametryIdRoute:
    AuthRaportySprzWybranychBlozowParametryIdRoute,
  AuthRaportySprzWybranychBlozowParametryNowyRoute:
    AuthRaportySprzWybranychBlozowParametryNowyRoute,
  AuthRaportySystemPremiowyLiderIdRoute: AuthRaportySystemPremiowyLiderIdRoute,
  AuthRaportySystemPremiowyLiderNowyRoute:
    AuthRaportySystemPremiowyLiderNowyRoute,
  AuthRaportySystemPremiowyProgramPartnerskiIdRoute:
    AuthRaportySystemPremiowyProgramPartnerskiIdRoute,
  AuthRaportySystemPremiowyProgramPartnerskiNowyRoute:
    AuthRaportySystemPremiowyProgramPartnerskiNowyRoute,
  AuthRaportySystemPremiowyRentownoscIdRoute:
    AuthRaportySystemPremiowyRentownoscIdRoute,
  AuthRaportySystemPremiowyRentownoscNowaRoute:
    AuthRaportySystemPremiowyRentownoscNowaRoute,
  AuthRaportySystemPremiowyStrukturaIdRoute:
    AuthRaportySystemPremiowyStrukturaIdRoute,
  AuthRaportySystemPremiowyStrukturaNowaRoute:
    AuthRaportySystemPremiowyStrukturaNowaRoute,
  AuthRecepturaProtokolyIdDrukujRoute: AuthRecepturaProtokolyIdDrukujRoute,
  AuthRecepturaProtokolyIdEtykietaRoute: AuthRecepturaProtokolyIdEtykietaRoute,
  AuthRaportySprzWybranychBlozowParametryIndexRoute:
    AuthRaportySprzWybranychBlozowParametryIndexRoute,
  AuthRaportySystemPremiowyLiderIndexRoute:
    AuthRaportySystemPremiowyLiderIndexRoute,
  AuthRaportySystemPremiowyProgramPartnerskiIndexRoute:
    AuthRaportySystemPremiowyProgramPartnerskiIndexRoute,
  AuthRaportySystemPremiowyRentownoscIndexRoute:
    AuthRaportySystemPremiowyRentownoscIndexRoute,
  AuthRaportySystemPremiowyStrukturaIndexRoute:
    AuthRaportySystemPremiowyStrukturaIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R403Route: R403Route,
  R502Route: R502Route,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetHaslaRoute: ResetHaslaRoute,
  UstawHasloRoute: UstawHasloRoute,
  ZgloszenieRoute: ZgloszenieRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthLoginRoute: AuthLoginRoute,
  PolaczAiZgodaRoute: PolaczAiZgodaRoute,
  PubliczneKsefRoute: PubliczneKsefRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
